var zify_faq_data =
  "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";
var zify_faq_category_data =
  "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";
var status = 1;
var margin_top = 20;
if (typeof jQuery == "undefined" || typeof jQuery.fn.on == "undefined") {
  /*! jQuery v1.12.0 */
  !(function (a, b) {
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = a.document
          ? b(a, !0)
          : function (a) {
              if (!a.document)
                throw new Error("jQuery requires a window with a document");
              return b(a);
            })
      : b(a);
  })("undefined" != typeof window ? window : this, function (a, b) {
    var c = [],
      d = a.document,
      e = c.slice,
      f = c.concat,
      g = c.push,
      h = c.indexOf,
      i = {},
      j = i.toString,
      k = i.hasOwnProperty,
      l = {},
      m = "1.12.0",
      n = function (a, b) {
        return new n.fn.init(a, b);
      },
      o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      p = /^-ms-/,
      q = /-([\da-z])/gi,
      r = function (a, b) {
        return b.toUpperCase();
      };
    (n.fn = n.prototype =
      {
        jquery: m,
        constructor: n,
        selector: "",
        length: 0,
        toArray: function () {
          return e.call(this);
        },
        get: function (a) {
          return null != a
            ? 0 > a
              ? this[a + this.length]
              : this[a]
            : e.call(this);
        },
        pushStack: function (a) {
          var b = n.merge(this.constructor(), a);
          return (b.prevObject = this), (b.context = this.context), b;
        },
        each: function (a) {
          return n.each(this, a);
        },
        map: function (a) {
          return this.pushStack(
            n.map(this, function (b, c) {
              return a.call(b, c, b);
            })
          );
        },
        slice: function () {
          return this.pushStack(e.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        eq: function (a) {
          var b = this.length,
            c = +a + (0 > a ? b : 0);
          return this.pushStack(c >= 0 && b > c ? [this[c]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: g,
        sort: c.sort,
        splice: c.splice,
      }),
      (n.extend = n.fn.extend =
        function () {
          var a,
            b,
            c,
            d,
            e,
            f,
            g = arguments[0] || {},
            h = 1,
            i = arguments.length,
            j = !1;
          for (
            "boolean" == typeof g && ((j = g), (g = arguments[h] || {}), h++),
              "object" == typeof g || n.isFunction(g) || (g = {}),
              h === i && ((g = this), h--);
            i > h;
            h++
          )
            if (null != (e = arguments[h]))
              for (d in e)
                (a = g[d]),
                  (c = e[d]),
                  g !== c &&
                    (j && c && (n.isPlainObject(c) || (b = n.isArray(c)))
                      ? (b
                          ? ((b = !1), (f = a && n.isArray(a) ? a : []))
                          : (f = a && n.isPlainObject(a) ? a : {}),
                        (g[d] = n.extend(j, f, c)))
                      : void 0 !== c && (g[d] = c));
          return g;
        }),
      n.extend({
        expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (a) {
          throw new Error(a);
        },
        noop: function () {},
        isFunction: function (a) {
          return "function" === n.type(a);
        },
        isArray:
          Array.isArray ||
          function (a) {
            return "array" === n.type(a);
          },
        isWindow: function (a) {
          return null != a && a == a.window;
        },
        isNumeric: function (a) {
          var b = a && a.toString();
          return !n.isArray(a) && b - parseFloat(b) + 1 >= 0;
        },
        isEmptyObject: function (a) {
          var b;
          for (b in a) return !1;
          return !0;
        },
        isPlainObject: function (a) {
          var b;
          if (!a || "object" !== n.type(a) || a.nodeType || n.isWindow(a))
            return !1;
          try {
            if (
              a.constructor &&
              !k.call(a, "constructor") &&
              !k.call(a.constructor.prototype, "isPrototypeOf")
            )
              return !1;
          } catch (c) {
            return !1;
          }
          if (!l.ownFirst) for (b in a) return k.call(a, b);
          for (b in a);
          return void 0 === b || k.call(a, b);
        },
        type: function (a) {
          return null == a
            ? a + ""
            : "object" == typeof a || "function" == typeof a
            ? i[j.call(a)] || "object"
            : typeof a;
        },
        globalEval: function (b) {
          b &&
            n.trim(b) &&
            (
              a.execScript ||
              function (b) {
                a.eval.call(a, b);
              }
            )(b);
        },
        camelCase: function (a) {
          return a.replace(p, "ms-").replace(q, r);
        },
        nodeName: function (a, b) {
          return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
        },
        each: function (a, b) {
          var c,
            d = 0;
          if (s(a)) {
            for (c = a.length; c > d; d++)
              if (b.call(a[d], d, a[d]) === !1) break;
          } else for (d in a) if (b.call(a[d], d, a[d]) === !1) break;
          return a;
        },
        trim: function (a) {
          return null == a ? "" : (a + "").replace(o, "");
        },
        makeArray: function (a, b) {
          var c = b || [];
          return (
            null != a &&
              (s(Object(a))
                ? n.merge(c, "string" == typeof a ? [a] : a)
                : g.call(c, a)),
            c
          );
        },
        inArray: function (a, b, c) {
          var d;
          if (b) {
            if (h) return h.call(b, a, c);
            for (
              d = b.length, c = c ? (0 > c ? Math.max(0, d + c) : c) : 0;
              d > c;
              c++
            )
              if (c in b && b[c] === a) return c;
          }
          return -1;
        },
        merge: function (a, b) {
          var c = +b.length,
            d = 0,
            e = a.length;
          while (c > d) a[e++] = b[d++];
          if (c !== c) while (void 0 !== b[d]) a[e++] = b[d++];
          return (a.length = e), a;
        },
        grep: function (a, b, c) {
          for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++)
            (d = !b(a[f], f)), d !== h && e.push(a[f]);
          return e;
        },
        map: function (a, b, c) {
          var d,
            e,
            g = 0,
            h = [];
          if (s(a))
            for (d = a.length; d > g; g++)
              (e = b(a[g], g, c)), null != e && h.push(e);
          else for (g in a) (e = b(a[g], g, c)), null != e && h.push(e);
          return f.apply([], h);
        },
        guid: 1,
        proxy: function (a, b) {
          var c, d, f;
          return (
            "string" == typeof b && ((f = a[b]), (b = a), (a = f)),
            n.isFunction(a)
              ? ((c = e.call(arguments, 2)),
                (d = function () {
                  return a.apply(b || this, c.concat(e.call(arguments)));
                }),
                (d.guid = a.guid = a.guid || n.guid++),
                d)
              : void 0
          );
        },
        now: function () {
          return +new Date();
        },
        support: l,
      }),
      "function" == typeof Symbol &&
        (n.fn[Symbol.iterator] = c[Symbol.iterator]),
      n.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (a, b) {
          i["[object " + b + "]"] = b.toLowerCase();
        }
      );
    function s(a) {
      var b = !!a && "length" in a && a.length,
        c = n.type(a);
      return "function" === c || n.isWindow(a)
        ? !1
        : "array" === c ||
            0 === b ||
            ("number" == typeof b && b > 0 && b - 1 in a);
    }
    var t = (function (a) {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t,
        u = "sizzle" + 1 * new Date(),
        v = a.document,
        w = 0,
        x = 0,
        y = ga(),
        z = ga(),
        A = ga(),
        B = function (a, b) {
          return a === b && (l = !0), 0;
        },
        C = 1 << 31,
        D = {}.hasOwnProperty,
        E = [],
        F = E.pop,
        G = E.push,
        H = E.push,
        I = E.slice,
        J = function (a, b) {
          for (var c = 0, d = a.length; d > c; c++) if (a[c] === b) return c;
          return -1;
        },
        K =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        L = "[\\x20\\t\\r\\n\\f]",
        M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        N =
          "\\[" +
          L +
          "*(" +
          M +
          ")(?:" +
          L +
          "*([*^$|!~]?=)" +
          L +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          M +
          "))|)" +
          L +
          "*\\]",
        O =
          ":(" +
          M +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          N +
          ")*)|.*)\\)|)",
        P = new RegExp(L + "+", "g"),
        Q = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"),
        R = new RegExp("^" + L + "*," + L + "*"),
        S = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"),
        T = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]", "g"),
        U = new RegExp(O),
        V = new RegExp("^" + M + "$"),
        W = {
          ID: new RegExp("^#(" + M + ")"),
          CLASS: new RegExp("^\\.(" + M + ")"),
          TAG: new RegExp("^(" + M + "|[*])"),
          ATTR: new RegExp("^" + N),
          PSEUDO: new RegExp("^" + O),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              L +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              L +
              "*(?:([+-]|)" +
              L +
              "*(\\d+)|))" +
              L +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + K + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              L +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              L +
              "*((?:-\\d)?\\d*)" +
              L +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        X = /^(?:input|select|textarea|button)$/i,
        Y = /^h\d$/i,
        Z = /^[^{]+\{\s*\[native \w/,
        $ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        _ = /[+~]/,
        aa = /'|\\/g,
        ba = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"),
        ca = function (a, b, c) {
          var d = "0x" + b - 65536;
          return d !== d || c
            ? b
            : 0 > d
            ? String.fromCharCode(d + 65536)
            : String.fromCharCode((d >> 10) | 55296, (1023 & d) | 56320);
        },
        da = function () {
          m();
        };
      try {
        H.apply((E = I.call(v.childNodes)), v.childNodes),
          E[v.childNodes.length].nodeType;
      } catch (ea) {
        H = {
          apply: E.length
            ? function (a, b) {
                G.apply(a, I.call(b));
              }
            : function (a, b) {
                var c = a.length,
                  d = 0;
                while ((a[c++] = b[d++]));
                a.length = c - 1;
              },
        };
      }
      function fa(a, b, d, e) {
        var f,
          h,
          j,
          k,
          l,
          o,
          r,
          s,
          w = b && b.ownerDocument,
          x = b ? b.nodeType : 9;
        if (
          ((d = d || []),
          "string" != typeof a || !a || (1 !== x && 9 !== x && 11 !== x))
        )
          return d;
        if (
          !e &&
          ((b ? b.ownerDocument || b : v) !== n && m(b), (b = b || n), p)
        ) {
          if (11 !== x && (o = $.exec(a)))
            if ((f = o[1])) {
              if (9 === x) {
                if (!(j = b.getElementById(f))) return d;
                if (j.id === f) return d.push(j), d;
              } else if (
                w &&
                (j = w.getElementById(f)) &&
                t(b, j) &&
                j.id === f
              )
                return d.push(j), d;
            } else {
              if (o[2]) return H.apply(d, b.getElementsByTagName(a)), d;
              if (
                (f = o[3]) &&
                c.getElementsByClassName &&
                b.getElementsByClassName
              )
                return H.apply(d, b.getElementsByClassName(f)), d;
            }
          if (c.qsa && !A[a + " "] && (!q || !q.test(a))) {
            if (1 !== x) (w = b), (s = a);
            else if ("object" !== b.nodeName.toLowerCase()) {
              (k = b.getAttribute("id"))
                ? (k = k.replace(aa, "\\$&"))
                : b.setAttribute("id", (k = u)),
                (r = g(a)),
                (h = r.length),
                (l = V.test(k) ? "#" + k : "[id='" + k + "']");
              while (h--) r[h] = l + " " + qa(r[h]);
              (s = r.join(",")), (w = (_.test(a) && oa(b.parentNode)) || b);
            }
            if (s)
              try {
                return H.apply(d, w.querySelectorAll(s)), d;
              } catch (y) {
              } finally {
                k === u && b.removeAttribute("id");
              }
          }
        }
        return i(a.replace(Q, "$1"), b, d, e);
      }
      function ga() {
        var a = [];
        function b(c, e) {
          return (
            a.push(c + " ") > d.cacheLength && delete b[a.shift()],
            (b[c + " "] = e)
          );
        }
        return b;
      }
      function ha(a) {
        return (a[u] = !0), a;
      }
      function ia(a) {
        var b = n.createElement("div");
        try {
          return !!a(b);
        } catch (c) {
          return !1;
        } finally {
          b.parentNode && b.parentNode.removeChild(b), (b = null);
        }
      }
      function ja(a, b) {
        var c = a.split("|"),
          e = c.length;
        while (e--) d.attrHandle[c[e]] = b;
      }
      function ka(a, b) {
        var c = b && a,
          d =
            c &&
            1 === a.nodeType &&
            1 === b.nodeType &&
            (~b.sourceIndex || C) - (~a.sourceIndex || C);
        if (d) return d;
        if (c) while ((c = c.nextSibling)) if (c === b) return -1;
        return a ? 1 : -1;
      }
      function la(a) {
        return function (b) {
          var c = b.nodeName.toLowerCase();
          return "input" === c && b.type === a;
        };
      }
      function ma(a) {
        return function (b) {
          var c = b.nodeName.toLowerCase();
          return ("input" === c || "button" === c) && b.type === a;
        };
      }
      function na(a) {
        return ha(function (b) {
          return (
            (b = +b),
            ha(function (c, d) {
              var e,
                f = a([], c.length, b),
                g = f.length;
              while (g--) c[(e = f[g])] && (c[e] = !(d[e] = c[e]));
            })
          );
        });
      }
      function oa(a) {
        return a && "undefined" != typeof a.getElementsByTagName && a;
      }
      (c = fa.support = {}),
        (f = fa.isXML =
          function (a) {
            var b = a && (a.ownerDocument || a).documentElement;
            return b ? "HTML" !== b.nodeName : !1;
          }),
        (m = fa.setDocument =
          function (a) {
            var b,
              e,
              g = a ? a.ownerDocument || a : v;
            return g !== n && 9 === g.nodeType && g.documentElement
              ? ((n = g),
                (o = n.documentElement),
                (p = !f(n)),
                (e = n.defaultView) &&
                  e.top !== e &&
                  (e.addEventListener
                    ? e.addEventListener("unload", da, !1)
                    : e.attachEvent && e.attachEvent("onunload", da)),
                (c.attributes = ia(function (a) {
                  return (a.className = "i"), !a.getAttribute("className");
                })),
                (c.getElementsByTagName = ia(function (a) {
                  return (
                    a.appendChild(n.createComment("")),
                    !a.getElementsByTagName("*").length
                  );
                })),
                (c.getElementsByClassName = Z.test(n.getElementsByClassName)),
                (c.getById = ia(function (a) {
                  return (
                    (o.appendChild(a).id = u),
                    !n.getElementsByName || !n.getElementsByName(u).length
                  );
                })),
                c.getById
                  ? ((d.find.ID = function (a, b) {
                      if ("undefined" != typeof b.getElementById && p) {
                        var c = b.getElementById(a);
                        return c ? [c] : [];
                      }
                    }),
                    (d.filter.ID = function (a) {
                      var b = a.replace(ba, ca);
                      return function (a) {
                        return a.getAttribute("id") === b;
                      };
                    }))
                  : (delete d.find.ID,
                    (d.filter.ID = function (a) {
                      var b = a.replace(ba, ca);
                      return function (a) {
                        var c =
                          "undefined" != typeof a.getAttributeNode &&
                          a.getAttributeNode("id");
                        return c && c.value === b;
                      };
                    })),
                (d.find.TAG = c.getElementsByTagName
                  ? function (a, b) {
                      return "undefined" != typeof b.getElementsByTagName
                        ? b.getElementsByTagName(a)
                        : c.qsa
                        ? b.querySelectorAll(a)
                        : void 0;
                    }
                  : function (a, b) {
                      var c,
                        d = [],
                        e = 0,
                        f = b.getElementsByTagName(a);
                      if ("*" === a) {
                        while ((c = f[e++])) 1 === c.nodeType && d.push(c);
                        return d;
                      }
                      return f;
                    }),
                (d.find.CLASS =
                  c.getElementsByClassName &&
                  function (a, b) {
                    return "undefined" != typeof b.getElementsByClassName && p
                      ? b.getElementsByClassName(a)
                      : void 0;
                  }),
                (r = []),
                (q = []),
                (c.qsa = Z.test(n.querySelectorAll)) &&
                  (ia(function (a) {
                    (o.appendChild(a).innerHTML =
                      "<a id='" +
                      u +
                      "'></a><select id='" +
                      u +
                      "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                      a.querySelectorAll("[msallowcapture^='']").length &&
                        q.push("[*^$]=" + L + "*(?:''|\"\")"),
                      a.querySelectorAll("[selected]").length ||
                        q.push("\\[" + L + "*(?:value|" + K + ")"),
                      a.querySelectorAll("[id~=" + u + "-]").length ||
                        q.push("~="),
                      a.querySelectorAll(":checked").length ||
                        q.push(":checked"),
                      a.querySelectorAll("a#" + u + "+*").length ||
                        q.push(".#.+[+~]");
                  }),
                  ia(function (a) {
                    var b = n.createElement("input");
                    b.setAttribute("type", "hidden"),
                      a.appendChild(b).setAttribute("name", "D"),
                      a.querySelectorAll("[name=d]").length &&
                        q.push("name" + L + "*[*^$|!~]?="),
                      a.querySelectorAll(":enabled").length ||
                        q.push(":enabled", ":disabled"),
                      a.querySelectorAll("*,:x"),
                      q.push(",.*:");
                  })),
                (c.matchesSelector = Z.test(
                  (s =
                    o.matches ||
                    o.webkitMatchesSelector ||
                    o.mozMatchesSelector ||
                    o.oMatchesSelector ||
                    o.msMatchesSelector)
                )) &&
                  ia(function (a) {
                    (c.disconnectedMatch = s.call(a, "div")),
                      s.call(a, "[s!='']:x"),
                      r.push("!=", O);
                  }),
                (q = q.length && new RegExp(q.join("|"))),
                (r = r.length && new RegExp(r.join("|"))),
                (b = Z.test(o.compareDocumentPosition)),
                (t =
                  b || Z.test(o.contains)
                    ? function (a, b) {
                        var c = 9 === a.nodeType ? a.documentElement : a,
                          d = b && b.parentNode;
                        return (
                          a === d ||
                          !(
                            !d ||
                            1 !== d.nodeType ||
                            !(c.contains
                              ? c.contains(d)
                              : a.compareDocumentPosition &&
                                16 & a.compareDocumentPosition(d))
                          )
                        );
                      }
                    : function (a, b) {
                        if (b)
                          while ((b = b.parentNode)) if (b === a) return !0;
                        return !1;
                      }),
                (B = b
                  ? function (a, b) {
                      if (a === b) return (l = !0), 0;
                      var d =
                        !a.compareDocumentPosition - !b.compareDocumentPosition;
                      return d
                        ? d
                        : ((d =
                            (a.ownerDocument || a) === (b.ownerDocument || b)
                              ? a.compareDocumentPosition(b)
                              : 1),
                          1 & d ||
                          (!c.sortDetached &&
                            b.compareDocumentPosition(a) === d)
                            ? a === n || (a.ownerDocument === v && t(v, a))
                              ? -1
                              : b === n || (b.ownerDocument === v && t(v, b))
                              ? 1
                              : k
                              ? J(k, a) - J(k, b)
                              : 0
                            : 4 & d
                            ? -1
                            : 1);
                    }
                  : function (a, b) {
                      if (a === b) return (l = !0), 0;
                      var c,
                        d = 0,
                        e = a.parentNode,
                        f = b.parentNode,
                        g = [a],
                        h = [b];
                      if (!e || !f)
                        return a === n
                          ? -1
                          : b === n
                          ? 1
                          : e
                          ? -1
                          : f
                          ? 1
                          : k
                          ? J(k, a) - J(k, b)
                          : 0;
                      if (e === f) return ka(a, b);
                      c = a;
                      while ((c = c.parentNode)) g.unshift(c);
                      c = b;
                      while ((c = c.parentNode)) h.unshift(c);
                      while (g[d] === h[d]) d++;
                      return d
                        ? ka(g[d], h[d])
                        : g[d] === v
                        ? -1
                        : h[d] === v
                        ? 1
                        : 0;
                    }),
                n)
              : n;
          }),
        (fa.matches = function (a, b) {
          return fa(a, null, null, b);
        }),
        (fa.matchesSelector = function (a, b) {
          if (
            ((a.ownerDocument || a) !== n && m(a),
            (b = b.replace(T, "='$1']")),
            c.matchesSelector &&
              p &&
              !A[b + " "] &&
              (!r || !r.test(b)) &&
              (!q || !q.test(b)))
          )
            try {
              var d = s.call(a, b);
              if (
                d ||
                c.disconnectedMatch ||
                (a.document && 11 !== a.document.nodeType)
              )
                return d;
            } catch (e) {}
          return fa(b, n, null, [a]).length > 0;
        }),
        (fa.contains = function (a, b) {
          return (a.ownerDocument || a) !== n && m(a), t(a, b);
        }),
        (fa.attr = function (a, b) {
          (a.ownerDocument || a) !== n && m(a);
          var e = d.attrHandle[b.toLowerCase()],
            f =
              e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;
          return void 0 !== f
            ? f
            : c.attributes || !p
            ? a.getAttribute(b)
            : (f = a.getAttributeNode(b)) && f.specified
            ? f.value
            : null;
        }),
        (fa.error = function (a) {
          throw new Error("Syntax error, unrecognized expression: " + a);
        }),
        (fa.uniqueSort = function (a) {
          var b,
            d = [],
            e = 0,
            f = 0;
          if (
            ((l = !c.detectDuplicates),
            (k = !c.sortStable && a.slice(0)),
            a.sort(B),
            l)
          ) {
            while ((b = a[f++])) b === a[f] && (e = d.push(f));
            while (e--) a.splice(d[e], 1);
          }
          return (k = null), a;
        }),
        (e = fa.getText =
          function (a) {
            var b,
              c = "",
              d = 0,
              f = a.nodeType;
            if (f) {
              if (1 === f || 9 === f || 11 === f) {
                if ("string" == typeof a.textContent) return a.textContent;
                for (a = a.firstChild; a; a = a.nextSibling) c += e(a);
              } else if (3 === f || 4 === f) return a.nodeValue;
            } else while ((b = a[d++])) c += e(b);
            return c;
          }),
        (d = fa.selectors =
          {
            cacheLength: 50,
            createPseudo: ha,
            match: W,
            attrHandle: {},
            find: {},
            relative: {
              ">": { dir: "parentNode", first: !0 },
              " ": { dir: "parentNode" },
              "+": { dir: "previousSibling", first: !0 },
              "~": { dir: "previousSibling" },
            },
            preFilter: {
              ATTR: function (a) {
                return (
                  (a[1] = a[1].replace(ba, ca)),
                  (a[3] = (a[3] || a[4] || a[5] || "").replace(ba, ca)),
                  "~=" === a[2] && (a[3] = " " + a[3] + " "),
                  a.slice(0, 4)
                );
              },
              CHILD: function (a) {
                return (
                  (a[1] = a[1].toLowerCase()),
                  "nth" === a[1].slice(0, 3)
                    ? (a[3] || fa.error(a[0]),
                      (a[4] = +(a[4]
                        ? a[5] + (a[6] || 1)
                        : 2 * ("even" === a[3] || "odd" === a[3]))),
                      (a[5] = +(a[7] + a[8] || "odd" === a[3])))
                    : a[3] && fa.error(a[0]),
                  a
                );
              },
              PSEUDO: function (a) {
                var b,
                  c = !a[6] && a[2];
                return W.CHILD.test(a[0])
                  ? null
                  : (a[3]
                      ? (a[2] = a[4] || a[5] || "")
                      : c &&
                        U.test(c) &&
                        (b = g(c, !0)) &&
                        (b = c.indexOf(")", c.length - b) - c.length) &&
                        ((a[0] = a[0].slice(0, b)), (a[2] = c.slice(0, b))),
                    a.slice(0, 3));
              },
            },
            filter: {
              TAG: function (a) {
                var b = a.replace(ba, ca).toLowerCase();
                return "*" === a
                  ? function () {
                      return !0;
                    }
                  : function (a) {
                      return a.nodeName && a.nodeName.toLowerCase() === b;
                    };
              },
              CLASS: function (a) {
                var b = y[a + " "];
                return (
                  b ||
                  ((b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)")) &&
                    y(a, function (a) {
                      return b.test(
                        ("string" == typeof a.className && a.className) ||
                          ("undefined" != typeof a.getAttribute &&
                            a.getAttribute("class")) ||
                          ""
                      );
                    }))
                );
              },
              ATTR: function (a, b, c) {
                return function (d) {
                  var e = fa.attr(d, a);
                  return null == e
                    ? "!=" === b
                    : b
                    ? ((e += ""),
                      "=" === b
                        ? e === c
                        : "!=" === b
                        ? e !== c
                        : "^=" === b
                        ? c && 0 === e.indexOf(c)
                        : "*=" === b
                        ? c && e.indexOf(c) > -1
                        : "$=" === b
                        ? c && e.slice(-c.length) === c
                        : "~=" === b
                        ? (" " + e.replace(P, " ") + " ").indexOf(c) > -1
                        : "|=" === b
                        ? e === c || e.slice(0, c.length + 1) === c + "-"
                        : !1)
                    : !0;
                };
              },
              CHILD: function (a, b, c, d, e) {
                var f = "nth" !== a.slice(0, 3),
                  g = "last" !== a.slice(-4),
                  h = "of-type" === b;
                return 1 === d && 0 === e
                  ? function (a) {
                      return !!a.parentNode;
                    }
                  : function (b, c, i) {
                      var j,
                        k,
                        l,
                        m,
                        n,
                        o,
                        p = f !== g ? "nextSibling" : "previousSibling",
                        q = b.parentNode,
                        r = h && b.nodeName.toLowerCase(),
                        s = !i && !h,
                        t = !1;
                      if (q) {
                        if (f) {
                          while (p) {
                            m = b;
                            while ((m = m[p]))
                              if (
                                h
                                  ? m.nodeName.toLowerCase() === r
                                  : 1 === m.nodeType
                              )
                                return !1;
                            o = p = "only" === a && !o && "nextSibling";
                          }
                          return !0;
                        }
                        if (((o = [g ? q.firstChild : q.lastChild]), g && s)) {
                          (m = q),
                            (l = m[u] || (m[u] = {})),
                            (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                            (j = k[a] || []),
                            (n = j[0] === w && j[1]),
                            (t = n && j[2]),
                            (m = n && q.childNodes[n]);
                          while (
                            (m = (++n && m && m[p]) || (t = n = 0) || o.pop())
                          )
                            if (1 === m.nodeType && ++t && m === b) {
                              k[a] = [w, n, t];
                              break;
                            }
                        } else if (
                          (s &&
                            ((m = b),
                            (l = m[u] || (m[u] = {})),
                            (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                            (j = k[a] || []),
                            (n = j[0] === w && j[1]),
                            (t = n)),
                          t === !1)
                        )
                          while (
                            (m = (++n && m && m[p]) || (t = n = 0) || o.pop())
                          )
                            if (
                              (h
                                ? m.nodeName.toLowerCase() === r
                                : 1 === m.nodeType) &&
                              ++t &&
                              (s &&
                                ((l = m[u] || (m[u] = {})),
                                (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                                (k[a] = [w, t])),
                              m === b)
                            )
                              break;
                        return (t -= e), t === d || (t % d === 0 && t / d >= 0);
                      }
                    };
              },
              PSEUDO: function (a, b) {
                var c,
                  e =
                    d.pseudos[a] ||
                    d.setFilters[a.toLowerCase()] ||
                    fa.error("unsupported pseudo: " + a);
                return e[u]
                  ? e(b)
                  : e.length > 1
                  ? ((c = [a, a, "", b]),
                    d.setFilters.hasOwnProperty(a.toLowerCase())
                      ? ha(function (a, c) {
                          var d,
                            f = e(a, b),
                            g = f.length;
                          while (g--) (d = J(a, f[g])), (a[d] = !(c[d] = f[g]));
                        })
                      : function (a) {
                          return e(a, 0, c);
                        })
                  : e;
              },
            },
            pseudos: {
              not: ha(function (a) {
                var b = [],
                  c = [],
                  d = h(a.replace(Q, "$1"));
                return d[u]
                  ? ha(function (a, b, c, e) {
                      var f,
                        g = d(a, null, e, []),
                        h = a.length;
                      while (h--) (f = g[h]) && (a[h] = !(b[h] = f));
                    })
                  : function (a, e, f) {
                      return (
                        (b[0] = a), d(b, null, f, c), (b[0] = null), !c.pop()
                      );
                    };
              }),
              has: ha(function (a) {
                return function (b) {
                  return fa(a, b).length > 0;
                };
              }),
              contains: ha(function (a) {
                return (
                  (a = a.replace(ba, ca)),
                  function (b) {
                    return (
                      (b.textContent || b.innerText || e(b)).indexOf(a) > -1
                    );
                  }
                );
              }),
              lang: ha(function (a) {
                return (
                  V.test(a || "") || fa.error("unsupported lang: " + a),
                  (a = a.replace(ba, ca).toLowerCase()),
                  function (b) {
                    var c;
                    do
                      if (
                        (c = p
                          ? b.lang
                          : b.getAttribute("xml:lang") ||
                            b.getAttribute("lang"))
                      )
                        return (
                          (c = c.toLowerCase()),
                          c === a || 0 === c.indexOf(a + "-")
                        );
                    while ((b = b.parentNode) && 1 === b.nodeType);
                    return !1;
                  }
                );
              }),
              target: function (b) {
                var c = a.location && a.location.hash;
                return c && c.slice(1) === b.id;
              },
              root: function (a) {
                return a === o;
              },
              focus: function (a) {
                return (
                  a === n.activeElement &&
                  (!n.hasFocus || n.hasFocus()) &&
                  !!(a.type || a.href || ~a.tabIndex)
                );
              },
              enabled: function (a) {
                return a.disabled === !1;
              },
              disabled: function (a) {
                return a.disabled === !0;
              },
              checked: function (a) {
                var b = a.nodeName.toLowerCase();
                return (
                  ("input" === b && !!a.checked) ||
                  ("option" === b && !!a.selected)
                );
              },
              selected: function (a) {
                return (
                  a.parentNode && a.parentNode.selectedIndex, a.selected === !0
                );
              },
              empty: function (a) {
                for (a = a.firstChild; a; a = a.nextSibling)
                  if (a.nodeType < 6) return !1;
                return !0;
              },
              parent: function (a) {
                return !d.pseudos.empty(a);
              },
              header: function (a) {
                return Y.test(a.nodeName);
              },
              input: function (a) {
                return X.test(a.nodeName);
              },
              button: function (a) {
                var b = a.nodeName.toLowerCase();
                return ("input" === b && "button" === a.type) || "button" === b;
              },
              text: function (a) {
                var b;
                return (
                  "input" === a.nodeName.toLowerCase() &&
                  "text" === a.type &&
                  (null == (b = a.getAttribute("type")) ||
                    "text" === b.toLowerCase())
                );
              },
              first: na(function () {
                return [0];
              }),
              last: na(function (a, b) {
                return [b - 1];
              }),
              eq: na(function (a, b, c) {
                return [0 > c ? c + b : c];
              }),
              even: na(function (a, b) {
                for (var c = 0; b > c; c += 2) a.push(c);
                return a;
              }),
              odd: na(function (a, b) {
                for (var c = 1; b > c; c += 2) a.push(c);
                return a;
              }),
              lt: na(function (a, b, c) {
                for (var d = 0 > c ? c + b : c; --d >= 0; ) a.push(d);
                return a;
              }),
              gt: na(function (a, b, c) {
                for (var d = 0 > c ? c + b : c; ++d < b; ) a.push(d);
                return a;
              }),
            },
          }),
        (d.pseudos.nth = d.pseudos.eq);
      for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        d.pseudos[b] = la(b);
      for (b in { submit: !0, reset: !0 }) d.pseudos[b] = ma(b);
      function pa() {}
      (pa.prototype = d.filters = d.pseudos),
        (d.setFilters = new pa()),
        (g = fa.tokenize =
          function (a, b) {
            var c,
              e,
              f,
              g,
              h,
              i,
              j,
              k = z[a + " "];
            if (k) return b ? 0 : k.slice(0);
            (h = a), (i = []), (j = d.preFilter);
            while (h) {
              (!c || (e = R.exec(h))) &&
                (e && (h = h.slice(e[0].length) || h), i.push((f = []))),
                (c = !1),
                (e = S.exec(h)) &&
                  ((c = e.shift()),
                  f.push({ value: c, type: e[0].replace(Q, " ") }),
                  (h = h.slice(c.length)));
              for (g in d.filter)
                !(e = W[g].exec(h)) ||
                  (j[g] && !(e = j[g](e))) ||
                  ((c = e.shift()),
                  f.push({ value: c, type: g, matches: e }),
                  (h = h.slice(c.length)));
              if (!c) break;
            }
            return b ? h.length : h ? fa.error(a) : z(a, i).slice(0);
          });
      function qa(a) {
        for (var b = 0, c = a.length, d = ""; c > b; b++) d += a[b].value;
        return d;
      }
      function ra(a, b, c) {
        var d = b.dir,
          e = c && "parentNode" === d,
          f = x++;
        return b.first
          ? function (b, c, f) {
              while ((b = b[d])) if (1 === b.nodeType || e) return a(b, c, f);
            }
          : function (b, c, g) {
              var h,
                i,
                j,
                k = [w, f];
              if (g) {
                while ((b = b[d]))
                  if ((1 === b.nodeType || e) && a(b, c, g)) return !0;
              } else
                while ((b = b[d]))
                  if (1 === b.nodeType || e) {
                    if (
                      ((j = b[u] || (b[u] = {})),
                      (i = j[b.uniqueID] || (j[b.uniqueID] = {})),
                      (h = i[d]) && h[0] === w && h[1] === f)
                    )
                      return (k[2] = h[2]);
                    if (((i[d] = k), (k[2] = a(b, c, g)))) return !0;
                  }
            };
      }
      function sa(a) {
        return a.length > 1
          ? function (b, c, d) {
              var e = a.length;
              while (e--) if (!a[e](b, c, d)) return !1;
              return !0;
            }
          : a[0];
      }
      function ta(a, b, c) {
        for (var d = 0, e = b.length; e > d; d++) fa(a, b[d], c);
        return c;
      }
      function ua(a, b, c, d, e) {
        for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++)
          (f = a[h]) && (!c || c(f, d, e)) && (g.push(f), j && b.push(h));
        return g;
      }
      function va(a, b, c, d, e, f) {
        return (
          d && !d[u] && (d = va(d)),
          e && !e[u] && (e = va(e, f)),
          ha(function (f, g, h, i) {
            var j,
              k,
              l,
              m = [],
              n = [],
              o = g.length,
              p = f || ta(b || "*", h.nodeType ? [h] : h, []),
              q = !a || (!f && b) ? p : ua(p, m, a, h, i),
              r = c ? (e || (f ? a : o || d) ? [] : g) : q;
            if ((c && c(q, r, h, i), d)) {
              (j = ua(r, n)), d(j, [], h, i), (k = j.length);
              while (k--) (l = j[k]) && (r[n[k]] = !(q[n[k]] = l));
            }
            if (f) {
              if (e || a) {
                if (e) {
                  (j = []), (k = r.length);
                  while (k--) (l = r[k]) && j.push((q[k] = l));
                  e(null, (r = []), j, i);
                }
                k = r.length;
                while (k--)
                  (l = r[k]) &&
                    (j = e ? J(f, l) : m[k]) > -1 &&
                    (f[j] = !(g[j] = l));
              }
            } else (r = ua(r === g ? r.splice(o, r.length) : r)), e ? e(null, g, r, i) : H.apply(g, r);
          })
        );
      }
      function wa(a) {
        for (
          var b,
            c,
            e,
            f = a.length,
            g = d.relative[a[0].type],
            h = g || d.relative[" "],
            i = g ? 1 : 0,
            k = ra(
              function (a) {
                return a === b;
              },
              h,
              !0
            ),
            l = ra(
              function (a) {
                return J(b, a) > -1;
              },
              h,
              !0
            ),
            m = [
              function (a, c, d) {
                var e =
                  (!g && (d || c !== j)) ||
                  ((b = c).nodeType ? k(a, c, d) : l(a, c, d));
                return (b = null), e;
              },
            ];
          f > i;
          i++
        )
          if ((c = d.relative[a[i].type])) m = [ra(sa(m), c)];
          else {
            if (((c = d.filter[a[i].type].apply(null, a[i].matches)), c[u])) {
              for (e = ++i; f > e; e++) if (d.relative[a[e].type]) break;
              return va(
                i > 1 && sa(m),
                i > 1 &&
                  qa(
                    a
                      .slice(0, i - 1)
                      .concat({ value: " " === a[i - 2].type ? "*" : "" })
                  ).replace(Q, "$1"),
                c,
                e > i && wa(a.slice(i, e)),
                f > e && wa((a = a.slice(e))),
                f > e && qa(a)
              );
            }
            m.push(c);
          }
        return sa(m);
      }
      function xa(a, b) {
        var c = b.length > 0,
          e = a.length > 0,
          f = function (f, g, h, i, k) {
            var l,
              o,
              q,
              r = 0,
              s = "0",
              t = f && [],
              u = [],
              v = j,
              x = f || (e && d.find.TAG("*", k)),
              y = (w += null == v ? 1 : Math.random() || 0.1),
              z = x.length;
            for (
              k && (j = g === n || g || k);
              s !== z && null != (l = x[s]);
              s++
            ) {
              if (e && l) {
                (o = 0), g || l.ownerDocument === n || (m(l), (h = !p));
                while ((q = a[o++]))
                  if (q(l, g || n, h)) {
                    i.push(l);
                    break;
                  }
                k && (w = y);
              }
              c && ((l = !q && l) && r--, f && t.push(l));
            }
            if (((r += s), c && s !== r)) {
              o = 0;
              while ((q = b[o++])) q(t, u, g, h);
              if (f) {
                if (r > 0) while (s--) t[s] || u[s] || (u[s] = F.call(i));
                u = ua(u);
              }
              H.apply(i, u),
                k && !f && u.length > 0 && r + b.length > 1 && fa.uniqueSort(i);
            }
            return k && ((w = y), (j = v)), t;
          };
        return c ? ha(f) : f;
      }
      return (
        (h = fa.compile =
          function (a, b) {
            var c,
              d = [],
              e = [],
              f = A[a + " "];
            if (!f) {
              b || (b = g(a)), (c = b.length);
              while (c--) (f = wa(b[c])), f[u] ? d.push(f) : e.push(f);
              (f = A(a, xa(e, d))), (f.selector = a);
            }
            return f;
          }),
        (i = fa.select =
          function (a, b, e, f) {
            var i,
              j,
              k,
              l,
              m,
              n = "function" == typeof a && a,
              o = !f && g((a = n.selector || a));
            if (((e = e || []), 1 === o.length)) {
              if (
                ((j = o[0] = o[0].slice(0)),
                j.length > 2 &&
                  "ID" === (k = j[0]).type &&
                  c.getById &&
                  9 === b.nodeType &&
                  p &&
                  d.relative[j[1].type])
              ) {
                if (
                  ((b = (d.find.ID(k.matches[0].replace(ba, ca), b) || [])[0]),
                  !b)
                )
                  return e;
                n && (b = b.parentNode), (a = a.slice(j.shift().value.length));
              }
              i = W.needsContext.test(a) ? 0 : j.length;
              while (i--) {
                if (((k = j[i]), d.relative[(l = k.type)])) break;
                if (
                  (m = d.find[l]) &&
                  (f = m(
                    k.matches[0].replace(ba, ca),
                    (_.test(j[0].type) && oa(b.parentNode)) || b
                  ))
                ) {
                  if ((j.splice(i, 1), (a = f.length && qa(j)), !a))
                    return H.apply(e, f), e;
                  break;
                }
              }
            }
            return (
              (n || h(a, o))(
                f,
                b,
                !p,
                e,
                !b || (_.test(a) && oa(b.parentNode)) || b
              ),
              e
            );
          }),
        (c.sortStable = u.split("").sort(B).join("") === u),
        (c.detectDuplicates = !!l),
        m(),
        (c.sortDetached = ia(function (a) {
          return 1 & a.compareDocumentPosition(n.createElement("div"));
        })),
        ia(function (a) {
          return (
            (a.innerHTML = "<a href='#'></a>"),
            "#" === a.firstChild.getAttribute("href")
          );
        }) ||
          ja("type|href|height|width", function (a, b, c) {
            return c
              ? void 0
              : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
          }),
        (c.attributes &&
          ia(function (a) {
            return (
              (a.innerHTML = "<input/>"),
              a.firstChild.setAttribute("value", ""),
              "" === a.firstChild.getAttribute("value")
            );
          })) ||
          ja("value", function (a, b, c) {
            return c || "input" !== a.nodeName.toLowerCase()
              ? void 0
              : a.defaultValue;
          }),
        ia(function (a) {
          return null == a.getAttribute("disabled");
        }) ||
          ja(K, function (a, b, c) {
            var d;
            return c
              ? void 0
              : a[b] === !0
              ? b.toLowerCase()
              : (d = a.getAttributeNode(b)) && d.specified
              ? d.value
              : null;
          }),
        fa
      );
    })(a);
    (n.find = t),
      (n.expr = t.selectors),
      (n.expr[":"] = n.expr.pseudos),
      (n.uniqueSort = n.unique = t.uniqueSort),
      (n.text = t.getText),
      (n.isXMLDoc = t.isXML),
      (n.contains = t.contains);
    var u = function (a, b, c) {
        var d = [],
          e = void 0 !== c;
        while ((a = a[b]) && 9 !== a.nodeType)
          if (1 === a.nodeType) {
            if (e && n(a).is(c)) break;
            d.push(a);
          }
        return d;
      },
      v = function (a, b) {
        for (var c = []; a; a = a.nextSibling)
          1 === a.nodeType && a !== b && c.push(a);
        return c;
      },
      w = n.expr.match.needsContext,
      x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
      y = /^.[^:#\[\.,]*$/;
    function z(a, b, c) {
      if (n.isFunction(b))
        return n.grep(a, function (a, d) {
          return !!b.call(a, d, a) !== c;
        });
      if (b.nodeType)
        return n.grep(a, function (a) {
          return (a === b) !== c;
        });
      if ("string" == typeof b) {
        if (y.test(b)) return n.filter(b, a, c);
        b = n.filter(b, a);
      }
      return n.grep(a, function (a) {
        return n.inArray(a, b) > -1 !== c;
      });
    }
    (n.filter = function (a, b, c) {
      var d = b[0];
      return (
        c && (a = ":not(" + a + ")"),
        1 === b.length && 1 === d.nodeType
          ? n.find.matchesSelector(d, a)
            ? [d]
            : []
          : n.find.matches(
              a,
              n.grep(b, function (a) {
                return 1 === a.nodeType;
              })
            )
      );
    }),
      n.fn.extend({
        find: function (a) {
          var b,
            c = [],
            d = this,
            e = d.length;
          if ("string" != typeof a)
            return this.pushStack(
              n(a).filter(function () {
                for (b = 0; e > b; b++) if (n.contains(d[b], this)) return !0;
              })
            );
          for (b = 0; e > b; b++) n.find(a, d[b], c);
          return (
            (c = this.pushStack(e > 1 ? n.unique(c) : c)),
            (c.selector = this.selector ? this.selector + " " + a : a),
            c
          );
        },
        filter: function (a) {
          return this.pushStack(z(this, a || [], !1));
        },
        not: function (a) {
          return this.pushStack(z(this, a || [], !0));
        },
        is: function (a) {
          return !!z(
            this,
            "string" == typeof a && w.test(a) ? n(a) : a || [],
            !1
          ).length;
        },
      });
    var A,
      B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      C = (n.fn.init = function (a, b, c) {
        var e, f;
        if (!a) return this;
        if (((c = c || A), "string" == typeof a)) {
          if (
            ((e =
              "<" === a.charAt(0) &&
              ">" === a.charAt(a.length - 1) &&
              a.length >= 3
                ? [null, a, null]
                : B.exec(a)),
            !e || (!e[1] && b))
          )
            return !b || b.jquery
              ? (b || c).find(a)
              : this.constructor(b).find(a);
          if (e[1]) {
            if (
              ((b = b instanceof n ? b[0] : b),
              n.merge(
                this,
                n.parseHTML(
                  e[1],
                  b && b.nodeType ? b.ownerDocument || b : d,
                  !0
                )
              ),
              x.test(e[1]) && n.isPlainObject(b))
            )
              for (e in b)
                n.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e]);
            return this;
          }
          if (((f = d.getElementById(e[2])), f && f.parentNode)) {
            if (f.id !== e[2]) return A.find(a);
            (this.length = 1), (this[0] = f);
          }
          return (this.context = d), (this.selector = a), this;
        }
        return a.nodeType
          ? ((this.context = this[0] = a), (this.length = 1), this)
          : n.isFunction(a)
          ? "undefined" != typeof c.ready
            ? c.ready(a)
            : a(n)
          : (void 0 !== a.selector &&
              ((this.selector = a.selector), (this.context = a.context)),
            n.makeArray(a, this));
      });
    (C.prototype = n.fn), (A = n(d));
    var D = /^(?:parents|prev(?:Until|All))/,
      E = { children: !0, contents: !0, next: !0, prev: !0 };
    n.fn.extend({
      has: function (a) {
        var b,
          c = n(a, this),
          d = c.length;
        return this.filter(function () {
          for (b = 0; d > b; b++) if (n.contains(this, c[b])) return !0;
        });
      },
      closest: function (a, b) {
        for (
          var c,
            d = 0,
            e = this.length,
            f = [],
            g = w.test(a) || "string" != typeof a ? n(a, b || this.context) : 0;
          e > d;
          d++
        )
          for (c = this[d]; c && c !== b; c = c.parentNode)
            if (
              c.nodeType < 11 &&
              (g
                ? g.index(c) > -1
                : 1 === c.nodeType && n.find.matchesSelector(c, a))
            ) {
              f.push(c);
              break;
            }
        return this.pushStack(f.length > 1 ? n.uniqueSort(f) : f);
      },
      index: function (a) {
        return a
          ? "string" == typeof a
            ? n.inArray(this[0], n(a))
            : n.inArray(a.jquery ? a[0] : a, this)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (a, b) {
        return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a, b))));
      },
      addBack: function (a) {
        return this.add(
          null == a ? this.prevObject : this.prevObject.filter(a)
        );
      },
    });
    function F(a, b) {
      do a = a[b];
      while (a && 1 !== a.nodeType);
      return a;
    }
    n.each(
      {
        parent: function (a) {
          var b = a.parentNode;
          return b && 11 !== b.nodeType ? b : null;
        },
        parents: function (a) {
          return u(a, "parentNode");
        },
        parentsUntil: function (a, b, c) {
          return u(a, "parentNode", c);
        },
        next: function (a) {
          return F(a, "nextSibling");
        },
        prev: function (a) {
          return F(a, "previousSibling");
        },
        nextAll: function (a) {
          return u(a, "nextSibling");
        },
        prevAll: function (a) {
          return u(a, "previousSibling");
        },
        nextUntil: function (a, b, c) {
          return u(a, "nextSibling", c);
        },
        prevUntil: function (a, b, c) {
          return u(a, "previousSibling", c);
        },
        siblings: function (a) {
          return v((a.parentNode || {}).firstChild, a);
        },
        children: function (a) {
          return v(a.firstChild);
        },
        contents: function (a) {
          return n.nodeName(a, "iframe")
            ? a.contentDocument || a.contentWindow.document
            : n.merge([], a.childNodes);
        },
      },
      function (a, b) {
        n.fn[a] = function (c, d) {
          var e = n.map(this, b, c);
          return (
            "Until" !== a.slice(-5) && (d = c),
            d && "string" == typeof d && (e = n.filter(d, e)),
            this.length > 1 &&
              (E[a] || (e = n.uniqueSort(e)), D.test(a) && (e = e.reverse())),
            this.pushStack(e)
          );
        };
      }
    );
    var G = /\S+/g;
    function H(a) {
      var b = {};
      return (
        n.each(a.match(G) || [], function (a, c) {
          b[c] = !0;
        }),
        b
      );
    }
    (n.Callbacks = function (a) {
      a = "string" == typeof a ? H(a) : n.extend({}, a);
      var b,
        c,
        d,
        e,
        f = [],
        g = [],
        h = -1,
        i = function () {
          for (e = a.once, d = b = !0; g.length; h = -1) {
            c = g.shift();
            while (++h < f.length)
              f[h].apply(c[0], c[1]) === !1 &&
                a.stopOnFalse &&
                ((h = f.length), (c = !1));
          }
          a.memory || (c = !1), (b = !1), e && (f = c ? [] : "");
        },
        j = {
          add: function () {
            return (
              f &&
                (c && !b && ((h = f.length - 1), g.push(c)),
                (function d(b) {
                  n.each(b, function (b, c) {
                    n.isFunction(c)
                      ? (a.unique && j.has(c)) || f.push(c)
                      : c && c.length && "string" !== n.type(c) && d(c);
                  });
                })(arguments),
                c && !b && i()),
              this
            );
          },
          remove: function () {
            return (
              n.each(arguments, function (a, b) {
                var c;
                while ((c = n.inArray(b, f, c)) > -1)
                  f.splice(c, 1), h >= c && h--;
              }),
              this
            );
          },
          has: function (a) {
            return a ? n.inArray(a, f) > -1 : f.length > 0;
          },
          empty: function () {
            return f && (f = []), this;
          },
          disable: function () {
            return (e = g = []), (f = c = ""), this;
          },
          disabled: function () {
            return !f;
          },
          lock: function () {
            return (e = !0), c || j.disable(), this;
          },
          locked: function () {
            return !!e;
          },
          fireWith: function (a, c) {
            return (
              e ||
                ((c = c || []),
                (c = [a, c.slice ? c.slice() : c]),
                g.push(c),
                b || i()),
              this
            );
          },
          fire: function () {
            return j.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!d;
          },
        };
      return j;
    }),
      n.extend({
        Deferred: function (a) {
          var b = [
              ["resolve", "done", n.Callbacks("once memory"), "resolved"],
              ["reject", "fail", n.Callbacks("once memory"), "rejected"],
              ["notify", "progress", n.Callbacks("memory")],
            ],
            c = "pending",
            d = {
              state: function () {
                return c;
              },
              always: function () {
                return e.done(arguments).fail(arguments), this;
              },
              then: function () {
                var a = arguments;
                return n
                  .Deferred(function (c) {
                    n.each(b, function (b, f) {
                      var g = n.isFunction(a[b]) && a[b];
                      e[f[1]](function () {
                        var a = g && g.apply(this, arguments);
                        a && n.isFunction(a.promise)
                          ? a
                              .promise()
                              .progress(c.notify)
                              .done(c.resolve)
                              .fail(c.reject)
                          : c[f[0] + "With"](
                              this === d ? c.promise() : this,
                              g ? [a] : arguments
                            );
                      });
                    }),
                      (a = null);
                  })
                  .promise();
              },
              promise: function (a) {
                return null != a ? n.extend(a, d) : d;
              },
            },
            e = {};
          return (
            (d.pipe = d.then),
            n.each(b, function (a, f) {
              var g = f[2],
                h = f[3];
              (d[f[1]] = g.add),
                h &&
                  g.add(
                    function () {
                      c = h;
                    },
                    b[1 ^ a][2].disable,
                    b[2][2].lock
                  ),
                (e[f[0]] = function () {
                  return (
                    e[f[0] + "With"](this === e ? d : this, arguments), this
                  );
                }),
                (e[f[0] + "With"] = g.fireWith);
            }),
            d.promise(e),
            a && a.call(e, e),
            e
          );
        },
        when: function (a) {
          var b = 0,
            c = e.call(arguments),
            d = c.length,
            f = 1 !== d || (a && n.isFunction(a.promise)) ? d : 0,
            g = 1 === f ? a : n.Deferred(),
            h = function (a, b, c) {
              return function (d) {
                (b[a] = this),
                  (c[a] = arguments.length > 1 ? e.call(arguments) : d),
                  c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c);
              };
            },
            i,
            j,
            k;
          if (d > 1)
            for (
              i = new Array(d), j = new Array(d), k = new Array(d);
              d > b;
              b++
            )
              c[b] && n.isFunction(c[b].promise)
                ? c[b]
                    .promise()
                    .progress(h(b, j, i))
                    .done(h(b, k, c))
                    .fail(g.reject)
                : --f;
          return f || g.resolveWith(k, c), g.promise();
        },
      });
    var I;
    (n.fn.ready = function (a) {
      return n.ready.promise().done(a), this;
    }),
      n.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function (a) {
          a ? n.readyWait++ : n.ready(!0);
        },
        ready: function (a) {
          (a === !0 ? --n.readyWait : n.isReady) ||
            ((n.isReady = !0),
            (a !== !0 && --n.readyWait > 0) ||
              (I.resolveWith(d, [n]),
              n.fn.triggerHandler &&
                (n(d).triggerHandler("ready"), n(d).off("ready"))));
        },
      });
    function J() {
      d.addEventListener
        ? (d.removeEventListener("DOMContentLoaded", K),
          a.removeEventListener("load", K))
        : (d.detachEvent("onreadystatechange", K), a.detachEvent("onload", K));
    }
    function K() {
      (d.addEventListener ||
        "load" === a.event.type ||
        "complete" === d.readyState) &&
        (J(), n.ready());
    }
    (n.ready.promise = function (b) {
      if (!I)
        if (((I = n.Deferred()), "complete" === d.readyState))
          a.setTimeout(n.ready);
        else if (d.addEventListener)
          d.addEventListener("DOMContentLoaded", K),
            a.addEventListener("load", K);
        else {
          d.attachEvent("onreadystatechange", K), a.attachEvent("onload", K);
          var c = !1;
          try {
            c = null == a.frameElement && d.documentElement;
          } catch (e) {}
          c &&
            c.doScroll &&
            !(function f() {
              if (!n.isReady) {
                try {
                  c.doScroll("left");
                } catch (b) {
                  return a.setTimeout(f, 50);
                }
                J(), n.ready();
              }
            })();
        }
      return I.promise(b);
    }),
      n.ready.promise();
    var L;
    for (L in n(l)) break;
    (l.ownFirst = "0" === L),
      (l.inlineBlockNeedsLayout = !1),
      n(function () {
        var a, b, c, e;
        (c = d.getElementsByTagName("body")[0]),
          c &&
            c.style &&
            ((b = d.createElement("div")),
            (e = d.createElement("div")),
            (e.style.cssText =
              "position:absolute;border:0;width:0;height:0;top:0;left:-9999px"),
            c.appendChild(e).appendChild(b),
            "undefined" != typeof b.style.zoom &&
              ((b.style.cssText =
                "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1"),
              (l.inlineBlockNeedsLayout = a = 3 === b.offsetWidth),
              a && (c.style.zoom = 1)),
            c.removeChild(e));
      }),
      (function () {
        var a = d.createElement("div");
        l.deleteExpando = !0;
        try {
          delete a.test;
        } catch (b) {
          l.deleteExpando = !1;
        }
        a = null;
      })();
    var M = function (a) {
        var b = n.noData[(a.nodeName + " ").toLowerCase()],
          c = +a.nodeType || 1;
        return 1 !== c && 9 !== c
          ? !1
          : !b || (b !== !0 && a.getAttribute("classid") === b);
      },
      N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      O = /([A-Z])/g;
    function P(a, b, c) {
      if (void 0 === c && 1 === a.nodeType) {
        var d = "data-" + b.replace(O, "-$1").toLowerCase();
        if (((c = a.getAttribute(d)), "string" == typeof c)) {
          try {
            c =
              "true" === c
                ? !0
                : "false" === c
                ? !1
                : "null" === c
                ? null
                : +c + "" === c
                ? +c
                : N.test(c)
                ? n.parseJSON(c)
                : c;
          } catch (e) {}
          n.data(a, b, c);
        } else c = void 0;
      }
      return c;
    }
    function Q(a) {
      var b;
      for (b in a)
        if (("data" !== b || !n.isEmptyObject(a[b])) && "toJSON" !== b)
          return !1;
      return !0;
    }
    function R(a, b, d, e) {
      if (M(a)) {
        var f,
          g,
          h = n.expando,
          i = a.nodeType,
          j = i ? n.cache : a,
          k = i ? a[h] : a[h] && h;
        if (
          (k && j[k] && (e || j[k].data)) ||
          void 0 !== d ||
          "string" != typeof b
        )
          return (
            k || (k = i ? (a[h] = c.pop() || n.guid++) : h),
            j[k] || (j[k] = i ? {} : { toJSON: n.noop }),
            ("object" == typeof b || "function" == typeof b) &&
              (e
                ? (j[k] = n.extend(j[k], b))
                : (j[k].data = n.extend(j[k].data, b))),
            (g = j[k]),
            e || (g.data || (g.data = {}), (g = g.data)),
            void 0 !== d && (g[n.camelCase(b)] = d),
            "string" == typeof b
              ? ((f = g[b]), null == f && (f = g[n.camelCase(b)]))
              : (f = g),
            f
          );
      }
    }
    function S(a, b, c) {
      if (M(a)) {
        var d,
          e,
          f = a.nodeType,
          g = f ? n.cache : a,
          h = f ? a[n.expando] : n.expando;
        if (g[h]) {
          if (b && (d = c ? g[h] : g[h].data)) {
            n.isArray(b)
              ? (b = b.concat(n.map(b, n.camelCase)))
              : b in d
              ? (b = [b])
              : ((b = n.camelCase(b)), (b = b in d ? [b] : b.split(" "))),
              (e = b.length);
            while (e--) delete d[b[e]];
            if (c ? !Q(d) : !n.isEmptyObject(d)) return;
          }
          (c || (delete g[h].data, Q(g[h]))) &&
            (f
              ? n.cleanData([a], !0)
              : l.deleteExpando || g != g.window
              ? delete g[h]
              : (g[h] = void 0));
        }
      }
    }
    n.extend({
      cache: {},
      noData: {
        "applet ": !0,
        "embed ": !0,
        "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
      },
      hasData: function (a) {
        return (
          (a = a.nodeType ? n.cache[a[n.expando]] : a[n.expando]), !!a && !Q(a)
        );
      },
      data: function (a, b, c) {
        return R(a, b, c);
      },
      removeData: function (a, b) {
        return S(a, b);
      },
      _data: function (a, b, c) {
        return R(a, b, c, !0);
      },
      _removeData: function (a, b) {
        return S(a, b, !0);
      },
    }),
      n.fn.extend({
        data: function (a, b) {
          var c,
            d,
            e,
            f = this[0],
            g = f && f.attributes;
          if (void 0 === a) {
            if (
              this.length &&
              ((e = n.data(f)), 1 === f.nodeType && !n._data(f, "parsedAttrs"))
            ) {
              c = g.length;
              while (c--)
                g[c] &&
                  ((d = g[c].name),
                  0 === d.indexOf("data-") &&
                    ((d = n.camelCase(d.slice(5))), P(f, d, e[d])));
              n._data(f, "parsedAttrs", !0);
            }
            return e;
          }
          return "object" == typeof a
            ? this.each(function () {
                n.data(this, a);
              })
            : arguments.length > 1
            ? this.each(function () {
                n.data(this, a, b);
              })
            : f
            ? P(f, a, n.data(f, a))
            : void 0;
        },
        removeData: function (a) {
          return this.each(function () {
            n.removeData(this, a);
          });
        },
      }),
      n.extend({
        queue: function (a, b, c) {
          var d;
          return a
            ? ((b = (b || "fx") + "queue"),
              (d = n._data(a, b)),
              c &&
                (!d || n.isArray(c)
                  ? (d = n._data(a, b, n.makeArray(c)))
                  : d.push(c)),
              d || [])
            : void 0;
        },
        dequeue: function (a, b) {
          b = b || "fx";
          var c = n.queue(a, b),
            d = c.length,
            e = c.shift(),
            f = n._queueHooks(a, b),
            g = function () {
              n.dequeue(a, b);
            };
          "inprogress" === e && ((e = c.shift()), d--),
            e &&
              ("fx" === b && c.unshift("inprogress"),
              delete f.stop,
              e.call(a, g, f)),
            !d && f && f.empty.fire();
        },
        _queueHooks: function (a, b) {
          var c = b + "queueHooks";
          return (
            n._data(a, c) ||
            n._data(a, c, {
              empty: n.Callbacks("once memory").add(function () {
                n._removeData(a, b + "queue"), n._removeData(a, c);
              }),
            })
          );
        },
      }),
      n.fn.extend({
        queue: function (a, b) {
          var c = 2;
          return (
            "string" != typeof a && ((b = a), (a = "fx"), c--),
            arguments.length < c
              ? n.queue(this[0], a)
              : void 0 === b
              ? this
              : this.each(function () {
                  var c = n.queue(this, a, b);
                  n._queueHooks(this, a),
                    "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a);
                })
          );
        },
        dequeue: function (a) {
          return this.each(function () {
            n.dequeue(this, a);
          });
        },
        clearQueue: function (a) {
          return this.queue(a || "fx", []);
        },
        promise: function (a, b) {
          var c,
            d = 1,
            e = n.Deferred(),
            f = this,
            g = this.length,
            h = function () {
              --d || e.resolveWith(f, [f]);
            };
          "string" != typeof a && ((b = a), (a = void 0)), (a = a || "fx");
          while (g--)
            (c = n._data(f[g], a + "queueHooks")),
              c && c.empty && (d++, c.empty.add(h));
          return h(), e.promise(b);
        },
      }),
      (function () {
        var a;
        l.shrinkWrapBlocks = function () {
          if (null != a) return a;
          a = !1;
          var b, c, e;
          return (
            (c = d.getElementsByTagName("body")[0]),
            c && c.style
              ? ((b = d.createElement("div")),
                (e = d.createElement("div")),
                (e.style.cssText =
                  "position:absolute;border:0;width:0;height:0;top:0;left:-9999px"),
                c.appendChild(e).appendChild(b),
                "undefined" != typeof b.style.zoom &&
                  ((b.style.cssText =
                    "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1"),
                  (b.appendChild(d.createElement("div")).style.width = "5px"),
                  (a = 3 !== b.offsetWidth)),
                c.removeChild(e),
                a)
              : void 0
          );
        };
      })();
    var T = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      U = new RegExp("^(?:([+-])=|)(" + T + ")([a-z%]*)$", "i"),
      V = ["Top", "Right", "Bottom", "Left"],
      W = function (a, b) {
        return (
          (a = b || a),
          "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a)
        );
      };
    function X(a, b, c, d) {
      var e,
        f = 1,
        g = 20,
        h = d
          ? function () {
              return d.cur();
            }
          : function () {
              return n.css(a, b, "");
            },
        i = h(),
        j = (c && c[3]) || (n.cssNumber[b] ? "" : "px"),
        k = (n.cssNumber[b] || ("px" !== j && +i)) && U.exec(n.css(a, b));
      if (k && k[3] !== j) {
        (j = j || k[3]), (c = c || []), (k = +i || 1);
        do (f = f || ".5"), (k /= f), n.style(a, b, k + j);
        while (f !== (f = h() / i) && 1 !== f && --g);
      }
      return (
        c &&
          ((k = +k || +i || 0),
          (e = c[1] ? k + (c[1] + 1) * c[2] : +c[2]),
          d && ((d.unit = j), (d.start = k), (d.end = e))),
        e
      );
    }
    var Y = function (a, b, c, d, e, f, g) {
        var h = 0,
          i = a.length,
          j = null == c;
        if ("object" === n.type(c)) {
          e = !0;
          for (h in c) Y(a, b, h, c[h], !0, f, g);
        } else if (
          void 0 !== d &&
          ((e = !0),
          n.isFunction(d) || (g = !0),
          j &&
            (g
              ? (b.call(a, d), (b = null))
              : ((j = b),
                (b = function (a, b, c) {
                  return j.call(n(a), c);
                }))),
          b)
        )
          for (; i > h; h++) b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
        return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
      },
      Z = /^(?:checkbox|radio)$/i,
      $ = /<([\w:-]+)/,
      _ = /^$|\/(?:java|ecma)script/i,
      aa = /^\s+/,
      ba =
        "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";
    function ca(a) {
      var b = ba.split("|"),
        c = a.createDocumentFragment();
      if (c.createElement) while (b.length) c.createElement(b.pop());
      return c;
    }
    !(function () {
      var a = d.createElement("div"),
        b = d.createDocumentFragment(),
        c = d.createElement("input");
      (a.innerHTML =
        "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
        (l.leadingWhitespace = 3 === a.firstChild.nodeType),
        (l.tbody = !a.getElementsByTagName("tbody").length),
        (l.htmlSerialize = !!a.getElementsByTagName("link").length),
        (l.html5Clone =
          "<:nav></:nav>" !== d.createElement("nav").cloneNode(!0).outerHTML),
        (c.type = "checkbox"),
        (c.checked = !0),
        b.appendChild(c),
        (l.appendChecked = c.checked),
        (a.innerHTML = "<textarea>x</textarea>"),
        (l.noCloneChecked = !!a.cloneNode(!0).lastChild.defaultValue),
        b.appendChild(a),
        (c = d.createElement("input")),
        c.setAttribute("type", "radio"),
        c.setAttribute("checked", "checked"),
        c.setAttribute("name", "t"),
        a.appendChild(c),
        (l.checkClone = a.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (l.noCloneEvent = !!a.addEventListener),
        (a[n.expando] = 1),
        (l.attributes = !a.getAttribute(n.expando));
    })();
    var da = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      legend: [1, "<fieldset>", "</fieldset>"],
      area: [1, "<map>", "</map>"],
      param: [1, "<object>", "</object>"],
      thead: [1, "<table>", "</table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: l.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"],
    };
    (da.optgroup = da.option),
      (da.tbody = da.tfoot = da.colgroup = da.caption = da.thead),
      (da.th = da.td);
    function ea(a, b) {
      var c,
        d,
        e = 0,
        f =
          "undefined" != typeof a.getElementsByTagName
            ? a.getElementsByTagName(b || "*")
            : "undefined" != typeof a.querySelectorAll
            ? a.querySelectorAll(b || "*")
            : void 0;
      if (!f)
        for (f = [], c = a.childNodes || a; null != (d = c[e]); e++)
          !b || n.nodeName(d, b) ? f.push(d) : n.merge(f, ea(d, b));
      return void 0 === b || (b && n.nodeName(a, b)) ? n.merge([a], f) : f;
    }
    function fa(a, b) {
      for (var c, d = 0; null != (c = a[d]); d++)
        n._data(c, "globalEval", !b || n._data(b[d], "globalEval"));
    }
    var ga = /<|&#?\w+;/,
      ha = /<tbody/i;
    function ia(a) {
      Z.test(a.type) && (a.defaultChecked = a.checked);
    }
    function ja(a, b, c, d, e) {
      for (
        var f, g, h, i, j, k, m, o = a.length, p = ca(b), q = [], r = 0;
        o > r;
        r++
      )
        if (((g = a[r]), g || 0 === g))
          if ("object" === n.type(g)) n.merge(q, g.nodeType ? [g] : g);
          else if (ga.test(g)) {
            (i = i || p.appendChild(b.createElement("div"))),
              (j = ($.exec(g) || ["", ""])[1].toLowerCase()),
              (m = da[j] || da._default),
              (i.innerHTML = m[1] + n.htmlPrefilter(g) + m[2]),
              (f = m[0]);
            while (f--) i = i.lastChild;
            if (
              (!l.leadingWhitespace &&
                aa.test(g) &&
                q.push(b.createTextNode(aa.exec(g)[0])),
              !l.tbody)
            ) {
              (g =
                "table" !== j || ha.test(g)
                  ? "<table>" !== m[1] || ha.test(g)
                    ? 0
                    : i
                  : i.firstChild),
                (f = g && g.childNodes.length);
              while (f--)
                n.nodeName((k = g.childNodes[f]), "tbody") &&
                  !k.childNodes.length &&
                  g.removeChild(k);
            }
            n.merge(q, i.childNodes), (i.textContent = "");
            while (i.firstChild) i.removeChild(i.firstChild);
            i = p.lastChild;
          } else q.push(b.createTextNode(g));
      i && p.removeChild(i),
        l.appendChecked || n.grep(ea(q, "input"), ia),
        (r = 0);
      while ((g = q[r++]))
        if (d && n.inArray(g, d) > -1) e && e.push(g);
        else if (
          ((h = n.contains(g.ownerDocument, g)),
          (i = ea(p.appendChild(g), "script")),
          h && fa(i),
          c)
        ) {
          f = 0;
          while ((g = i[f++])) _.test(g.type || "") && c.push(g);
        }
      return (i = null), p;
    }
    !(function () {
      var b,
        c,
        e = d.createElement("div");
      for (b in { submit: !0, change: !0, focusin: !0 })
        (c = "on" + b),
          (l[b] = c in a) ||
            (e.setAttribute(c, "t"), (l[b] = e.attributes[c].expando === !1));
      e = null;
    })();
    var ka = /^(?:input|select|textarea)$/i,
      la = /^key/,
      ma = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      na = /^(?:focusinfocus|focusoutblur)$/,
      oa = /^([^.]*)(?:\.(.+)|)/;
    function pa() {
      return !0;
    }
    function qa() {
      return !1;
    }
    function ra() {
      try {
        return d.activeElement;
      } catch (a) {}
    }
    function sa(a, b, c, d, e, f) {
      var g, h;
      if ("object" == typeof b) {
        "string" != typeof c && ((d = d || c), (c = void 0));
        for (h in b) sa(a, h, c, d, b[h], f);
        return a;
      }
      if (
        (null == d && null == e
          ? ((e = c), (d = c = void 0))
          : null == e &&
            ("string" == typeof c
              ? ((e = d), (d = void 0))
              : ((e = d), (d = c), (c = void 0))),
        e === !1)
      )
        e = qa;
      else if (!e) return a;
      return (
        1 === f &&
          ((g = e),
          (e = function (a) {
            return n().off(a), g.apply(this, arguments);
          }),
          (e.guid = g.guid || (g.guid = n.guid++))),
        a.each(function () {
          n.event.add(this, b, e, d, c);
        })
      );
    }
    (n.event = {
      global: {},
      add: function (a, b, c, d, e) {
        var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          o,
          p,
          q,
          r = n._data(a);
        if (r) {
          c.handler && ((i = c), (c = i.handler), (e = i.selector)),
            c.guid || (c.guid = n.guid++),
            (g = r.events) || (g = r.events = {}),
            (k = r.handle) ||
              ((k = r.handle =
                function (a) {
                  return "undefined" == typeof n ||
                    (a && n.event.triggered === a.type)
                    ? void 0
                    : n.event.dispatch.apply(k.elem, arguments);
                }),
              (k.elem = a)),
            (b = (b || "").match(G) || [""]),
            (h = b.length);
          while (h--)
            (f = oa.exec(b[h]) || []),
              (o = q = f[1]),
              (p = (f[2] || "").split(".").sort()),
              o &&
                ((j = n.event.special[o] || {}),
                (o = (e ? j.delegateType : j.bindType) || o),
                (j = n.event.special[o] || {}),
                (l = n.extend(
                  {
                    type: o,
                    origType: q,
                    data: d,
                    handler: c,
                    guid: c.guid,
                    selector: e,
                    needsContext: e && n.expr.match.needsContext.test(e),
                    namespace: p.join("."),
                  },
                  i
                )),
                (m = g[o]) ||
                  ((m = g[o] = []),
                  (m.delegateCount = 0),
                  (j.setup && j.setup.call(a, d, p, k) !== !1) ||
                    (a.addEventListener
                      ? a.addEventListener(o, k, !1)
                      : a.attachEvent && a.attachEvent("on" + o, k))),
                j.add &&
                  (j.add.call(a, l),
                  l.handler.guid || (l.handler.guid = c.guid)),
                e ? m.splice(m.delegateCount++, 0, l) : m.push(l),
                (n.event.global[o] = !0));
          a = null;
        }
      },
      remove: function (a, b, c, d, e) {
        var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          o,
          p,
          q,
          r = n.hasData(a) && n._data(a);
        if (r && (k = r.events)) {
          (b = (b || "").match(G) || [""]), (j = b.length);
          while (j--)
            if (
              ((h = oa.exec(b[j]) || []),
              (o = q = h[1]),
              (p = (h[2] || "").split(".").sort()),
              o)
            ) {
              (l = n.event.special[o] || {}),
                (o = (d ? l.delegateType : l.bindType) || o),
                (m = k[o] || []),
                (h =
                  h[2] &&
                  new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)")),
                (i = f = m.length);
              while (f--)
                (g = m[f]),
                  (!e && q !== g.origType) ||
                    (c && c.guid !== g.guid) ||
                    (h && !h.test(g.namespace)) ||
                    (d && d !== g.selector && ("**" !== d || !g.selector)) ||
                    (m.splice(f, 1),
                    g.selector && m.delegateCount--,
                    l.remove && l.remove.call(a, g));
              i &&
                !m.length &&
                ((l.teardown && l.teardown.call(a, p, r.handle) !== !1) ||
                  n.removeEvent(a, o, r.handle),
                delete k[o]);
            } else for (o in k) n.event.remove(a, o + b[j], c, d, !0);
          n.isEmptyObject(k) && (delete r.handle, n._removeData(a, "events"));
        }
      },
      trigger: function (b, c, e, f) {
        var g,
          h,
          i,
          j,
          l,
          m,
          o,
          p = [e || d],
          q = k.call(b, "type") ? b.type : b,
          r = k.call(b, "namespace") ? b.namespace.split(".") : [];
        if (
          ((i = m = e = e || d),
          3 !== e.nodeType &&
            8 !== e.nodeType &&
            !na.test(q + n.event.triggered) &&
            (q.indexOf(".") > -1 &&
              ((r = q.split(".")), (q = r.shift()), r.sort()),
            (h = q.indexOf(":") < 0 && "on" + q),
            (b = b[n.expando] ? b : new n.Event(q, "object" == typeof b && b)),
            (b.isTrigger = f ? 2 : 3),
            (b.namespace = r.join(".")),
            (b.rnamespace = b.namespace
              ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (b.result = void 0),
            b.target || (b.target = e),
            (c = null == c ? [b] : n.makeArray(c, [b])),
            (l = n.event.special[q] || {}),
            f || !l.trigger || l.trigger.apply(e, c) !== !1))
        ) {
          if (!f && !l.noBubble && !n.isWindow(e)) {
            for (
              j = l.delegateType || q, na.test(j + q) || (i = i.parentNode);
              i;
              i = i.parentNode
            )
              p.push(i), (m = i);
            m === (e.ownerDocument || d) &&
              p.push(m.defaultView || m.parentWindow || a);
          }
          o = 0;
          while ((i = p[o++]) && !b.isPropagationStopped())
            (b.type = o > 1 ? j : l.bindType || q),
              (g =
                (n._data(i, "events") || {})[b.type] && n._data(i, "handle")),
              g && g.apply(i, c),
              (g = h && i[h]),
              g &&
                g.apply &&
                M(i) &&
                ((b.result = g.apply(i, c)),
                b.result === !1 && b.preventDefault());
          if (
            ((b.type = q),
            !f &&
              !b.isDefaultPrevented() &&
              (!l._default || l._default.apply(p.pop(), c) === !1) &&
              M(e) &&
              h &&
              e[q] &&
              !n.isWindow(e))
          ) {
            (m = e[h]), m && (e[h] = null), (n.event.triggered = q);
            try {
              e[q]();
            } catch (s) {}
            (n.event.triggered = void 0), m && (e[h] = m);
          }
          return b.result;
        }
      },
      dispatch: function (a) {
        a = n.event.fix(a);
        var b,
          c,
          d,
          f,
          g,
          h = [],
          i = e.call(arguments),
          j = (n._data(this, "events") || {})[a.type] || [],
          k = n.event.special[a.type] || {};
        if (
          ((i[0] = a),
          (a.delegateTarget = this),
          !k.preDispatch || k.preDispatch.call(this, a) !== !1)
        ) {
          (h = n.event.handlers.call(this, a, j)), (b = 0);
          while ((f = h[b++]) && !a.isPropagationStopped()) {
            (a.currentTarget = f.elem), (c = 0);
            while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped())
              (!a.rnamespace || a.rnamespace.test(g.namespace)) &&
                ((a.handleObj = g),
                (a.data = g.data),
                (d = (
                  (n.event.special[g.origType] || {}).handle || g.handler
                ).apply(f.elem, i)),
                void 0 !== d &&
                  (a.result = d) === !1 &&
                  (a.preventDefault(), a.stopPropagation()));
          }
          return k.postDispatch && k.postDispatch.call(this, a), a.result;
        }
      },
      handlers: function (a, b) {
        var c,
          d,
          e,
          f,
          g = [],
          h = b.delegateCount,
          i = a.target;
        if (
          h &&
          i.nodeType &&
          ("click" !== a.type || isNaN(a.button) || a.button < 1)
        )
          for (; i != this; i = i.parentNode || this)
            if (1 === i.nodeType && (i.disabled !== !0 || "click" !== a.type)) {
              for (d = [], c = 0; h > c; c++)
                (f = b[c]),
                  (e = f.selector + " "),
                  void 0 === d[e] &&
                    (d[e] = f.needsContext
                      ? n(e, this).index(i) > -1
                      : n.find(e, this, null, [i]).length),
                  d[e] && d.push(f);
              d.length && g.push({ elem: i, handlers: d });
            }
        return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g;
      },
      fix: function (a) {
        if (a[n.expando]) return a;
        var b,
          c,
          e,
          f = a.type,
          g = a,
          h = this.fixHooks[f];
        h ||
          (this.fixHooks[f] = h =
            ma.test(f) ? this.mouseHooks : la.test(f) ? this.keyHooks : {}),
          (e = h.props ? this.props.concat(h.props) : this.props),
          (a = new n.Event(g)),
          (b = e.length);
        while (b--) (c = e[b]), (a[c] = g[c]);
        return (
          a.target || (a.target = g.srcElement || d),
          3 === a.target.nodeType && (a.target = a.target.parentNode),
          (a.metaKey = !!a.metaKey),
          h.filter ? h.filter(a, g) : a
        );
      },
      props:
        "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
          " "
        ),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (a, b) {
          return (
            null == a.which &&
              (a.which = null != b.charCode ? b.charCode : b.keyCode),
            a
          );
        },
      },
      mouseHooks: {
        props:
          "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(
            " "
          ),
        filter: function (a, b) {
          var c,
            e,
            f,
            g = b.button,
            h = b.fromElement;
          return (
            null == a.pageX &&
              null != b.clientX &&
              ((e = a.target.ownerDocument || d),
              (f = e.documentElement),
              (c = e.body),
              (a.pageX =
                b.clientX +
                ((f && f.scrollLeft) || (c && c.scrollLeft) || 0) -
                ((f && f.clientLeft) || (c && c.clientLeft) || 0)),
              (a.pageY =
                b.clientY +
                ((f && f.scrollTop) || (c && c.scrollTop) || 0) -
                ((f && f.clientTop) || (c && c.clientTop) || 0))),
            !a.relatedTarget &&
              h &&
              (a.relatedTarget = h === a.target ? b.toElement : h),
            a.which ||
              void 0 === g ||
              (a.which = 1 & g ? 1 : 2 & g ? 3 : 4 & g ? 2 : 0),
            a
          );
        },
      },
      special: {
        load: { noBubble: !0 },
        focus: {
          trigger: function () {
            if (this !== ra() && this.focus)
              try {
                return this.focus(), !1;
              } catch (a) {}
          },
          delegateType: "focusin",
        },
        blur: {
          trigger: function () {
            return this === ra() && this.blur ? (this.blur(), !1) : void 0;
          },
          delegateType: "focusout",
        },
        click: {
          trigger: function () {
            return n.nodeName(this, "input") &&
              "checkbox" === this.type &&
              this.click
              ? (this.click(), !1)
              : void 0;
          },
          _default: function (a) {
            return n.nodeName(a.target, "a");
          },
        },
        beforeunload: {
          postDispatch: function (a) {
            void 0 !== a.result &&
              a.originalEvent &&
              (a.originalEvent.returnValue = a.result);
          },
        },
      },
      simulate: function (a, b, c) {
        var d = n.extend(new n.Event(), c, { type: a, isSimulated: !0 });
        n.event.trigger(d, null, b),
          d.isDefaultPrevented() && c.preventDefault();
      },
    }),
      (n.removeEvent = d.removeEventListener
        ? function (a, b, c) {
            a.removeEventListener && a.removeEventListener(b, c);
          }
        : function (a, b, c) {
            var d = "on" + b;
            a.detachEvent &&
              ("undefined" == typeof a[d] && (a[d] = null),
              a.detachEvent(d, c));
          }),
      (n.Event = function (a, b) {
        return this instanceof n.Event
          ? (a && a.type
              ? ((this.originalEvent = a),
                (this.type = a.type),
                (this.isDefaultPrevented =
                  a.defaultPrevented ||
                  (void 0 === a.defaultPrevented && a.returnValue === !1)
                    ? pa
                    : qa))
              : (this.type = a),
            b && n.extend(this, b),
            (this.timeStamp = (a && a.timeStamp) || n.now()),
            void (this[n.expando] = !0))
          : new n.Event(a, b);
      }),
      (n.Event.prototype = {
        constructor: n.Event,
        isDefaultPrevented: qa,
        isPropagationStopped: qa,
        isImmediatePropagationStopped: qa,
        preventDefault: function () {
          var a = this.originalEvent;
          (this.isDefaultPrevented = pa),
            a && (a.preventDefault ? a.preventDefault() : (a.returnValue = !1));
        },
        stopPropagation: function () {
          var a = this.originalEvent;
          (this.isPropagationStopped = pa),
            a &&
              !this.isSimulated &&
              (a.stopPropagation && a.stopPropagation(), (a.cancelBubble = !0));
        },
        stopImmediatePropagation: function () {
          var a = this.originalEvent;
          (this.isImmediatePropagationStopped = pa),
            a && a.stopImmediatePropagation && a.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      n.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (a, b) {
          n.event.special[a] = {
            delegateType: b,
            bindType: b,
            handle: function (a) {
              var c,
                d = this,
                e = a.relatedTarget,
                f = a.handleObj;
              return (
                (!e || (e !== d && !n.contains(d, e))) &&
                  ((a.type = f.origType),
                  (c = f.handler.apply(this, arguments)),
                  (a.type = b)),
                c
              );
            },
          };
        }
      ),
      l.submit ||
        (n.event.special.submit = {
          setup: function () {
            return n.nodeName(this, "form")
              ? !1
              : void n.event.add(
                  this,
                  "click._submit keypress._submit",
                  function (a) {
                    var b = a.target,
                      c =
                        n.nodeName(b, "input") || n.nodeName(b, "button")
                          ? n.prop(b, "form")
                          : void 0;
                    c &&
                      !n._data(c, "submit") &&
                      (n.event.add(c, "submit._submit", function (a) {
                        a._submitBubble = !0;
                      }),
                      n._data(c, "submit", !0));
                  }
                );
          },
          postDispatch: function (a) {
            a._submitBubble &&
              (delete a._submitBubble,
              this.parentNode &&
                !a.isTrigger &&
                n.event.simulate("submit", this.parentNode, a));
          },
          teardown: function () {
            return n.nodeName(this, "form")
              ? !1
              : void n.event.remove(this, "._submit");
          },
        }),
      l.change ||
        (n.event.special.change = {
          setup: function () {
            return ka.test(this.nodeName)
              ? (("checkbox" === this.type || "radio" === this.type) &&
                  (n.event.add(this, "propertychange._change", function (a) {
                    "checked" === a.originalEvent.propertyName &&
                      (this._justChanged = !0);
                  }),
                  n.event.add(this, "click._change", function (a) {
                    this._justChanged &&
                      !a.isTrigger &&
                      (this._justChanged = !1),
                      n.event.simulate("change", this, a);
                  })),
                !1)
              : void n.event.add(this, "beforeactivate._change", function (a) {
                  var b = a.target;
                  ka.test(b.nodeName) &&
                    !n._data(b, "change") &&
                    (n.event.add(b, "change._change", function (a) {
                      !this.parentNode ||
                        a.isSimulated ||
                        a.isTrigger ||
                        n.event.simulate("change", this.parentNode, a);
                    }),
                    n._data(b, "change", !0));
                });
          },
          handle: function (a) {
            var b = a.target;
            return this !== b ||
              a.isSimulated ||
              a.isTrigger ||
              ("radio" !== b.type && "checkbox" !== b.type)
              ? a.handleObj.handler.apply(this, arguments)
              : void 0;
          },
          teardown: function () {
            return n.event.remove(this, "._change"), !ka.test(this.nodeName);
          },
        }),
      l.focusin ||
        n.each({ focus: "focusin", blur: "focusout" }, function (a, b) {
          var c = function (a) {
            n.event.simulate(b, a.target, n.event.fix(a));
          };
          n.event.special[b] = {
            setup: function () {
              var d = this.ownerDocument || this,
                e = n._data(d, b);
              e || d.addEventListener(a, c, !0), n._data(d, b, (e || 0) + 1);
            },
            teardown: function () {
              var d = this.ownerDocument || this,
                e = n._data(d, b) - 1;
              e
                ? n._data(d, b, e)
                : (d.removeEventListener(a, c, !0), n._removeData(d, b));
            },
          };
        }),
      n.fn.extend({
        on: function (a, b, c, d) {
          return sa(this, a, b, c, d);
        },
        one: function (a, b, c, d) {
          return sa(this, a, b, c, d, 1);
        },
        off: function (a, b, c) {
          var d, e;
          if (a && a.preventDefault && a.handleObj)
            return (
              (d = a.handleObj),
              n(a.delegateTarget).off(
                d.namespace ? d.origType + "." + d.namespace : d.origType,
                d.selector,
                d.handler
              ),
              this
            );
          if ("object" == typeof a) {
            for (e in a) this.off(e, b, a[e]);
            return this;
          }
          return (
            (b === !1 || "function" == typeof b) && ((c = b), (b = void 0)),
            c === !1 && (c = qa),
            this.each(function () {
              n.event.remove(this, a, c, b);
            })
          );
        },
        trigger: function (a, b) {
          return this.each(function () {
            n.event.trigger(a, b, this);
          });
        },
        triggerHandler: function (a, b) {
          var c = this[0];
          return c ? n.event.trigger(a, b, c, !0) : void 0;
        },
      });
    var ta = / jQuery\d+="(?:null|\d+)"/g,
      ua = new RegExp("<(?:" + ba + ")[\\s/>]", "i"),
      va =
        /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
      wa = /<script|<style|<link/i,
      xa = /checked\s*(?:[^=]|=\s*.checked.)/i,
      ya = /^true\/(.*)/,
      za = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      Aa = ca(d),
      Ba = Aa.appendChild(d.createElement("div"));
    function Ca(a, b) {
      return n.nodeName(a, "table") &&
        n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr")
        ? a.getElementsByTagName("tbody")[0] ||
            a.appendChild(a.ownerDocument.createElement("tbody"))
        : a;
    }
    function Da(a) {
      return (a.type = (null !== n.find.attr(a, "type")) + "/" + a.type), a;
    }
    function Ea(a) {
      var b = ya.exec(a.type);
      return b ? (a.type = b[1]) : a.removeAttribute("type"), a;
    }
    function Fa(a, b) {
      if (1 === b.nodeType && n.hasData(a)) {
        var c,
          d,
          e,
          f = n._data(a),
          g = n._data(b, f),
          h = f.events;
        if (h) {
          delete g.handle, (g.events = {});
          for (c in h)
            for (d = 0, e = h[c].length; e > d; d++) n.event.add(b, c, h[c][d]);
        }
        g.data && (g.data = n.extend({}, g.data));
      }
    }
    function Ga(a, b) {
      var c, d, e;
      if (1 === b.nodeType) {
        if (((c = b.nodeName.toLowerCase()), !l.noCloneEvent && b[n.expando])) {
          e = n._data(b);
          for (d in e.events) n.removeEvent(b, d, e.handle);
          b.removeAttribute(n.expando);
        }
        "script" === c && b.text !== a.text
          ? ((Da(b).text = a.text), Ea(b))
          : "object" === c
          ? (b.parentNode && (b.outerHTML = a.outerHTML),
            l.html5Clone &&
              a.innerHTML &&
              !n.trim(b.innerHTML) &&
              (b.innerHTML = a.innerHTML))
          : "input" === c && Z.test(a.type)
          ? ((b.defaultChecked = b.checked = a.checked),
            b.value !== a.value && (b.value = a.value))
          : "option" === c
          ? (b.defaultSelected = b.selected = a.defaultSelected)
          : ("input" === c || "textarea" === c) &&
            (b.defaultValue = a.defaultValue);
      }
    }
    function Ha(a, b, c, d) {
      b = f.apply([], b);
      var e,
        g,
        h,
        i,
        j,
        k,
        m = 0,
        o = a.length,
        p = o - 1,
        q = b[0],
        r = n.isFunction(q);
      if (r || (o > 1 && "string" == typeof q && !l.checkClone && xa.test(q)))
        return a.each(function (e) {
          var f = a.eq(e);
          r && (b[0] = q.call(this, e, f.html())), Ha(f, b, c, d);
        });
      if (
        o &&
        ((k = ja(b, a[0].ownerDocument, !1, a, d)),
        (e = k.firstChild),
        1 === k.childNodes.length && (k = e),
        e || d)
      ) {
        for (i = n.map(ea(k, "script"), Da), h = i.length; o > m; m++)
          (g = k),
            m !== p &&
              ((g = n.clone(g, !0, !0)), h && n.merge(i, ea(g, "script"))),
            c.call(a[m], g, m);
        if (h)
          for (
            j = i[i.length - 1].ownerDocument, n.map(i, Ea), m = 0;
            h > m;
            m++
          )
            (g = i[m]),
              _.test(g.type || "") &&
                !n._data(g, "globalEval") &&
                n.contains(j, g) &&
                (g.src
                  ? n._evalUrl && n._evalUrl(g.src)
                  : n.globalEval(
                      (g.text || g.textContent || g.innerHTML || "").replace(
                        za,
                        ""
                      )
                    ));
        k = e = null;
      }
      return a;
    }
    function Ia(a, b, c) {
      for (var d, e = b ? n.filter(b, a) : a, f = 0; null != (d = e[f]); f++)
        c || 1 !== d.nodeType || n.cleanData(ea(d)),
          d.parentNode &&
            (c && n.contains(d.ownerDocument, d) && fa(ea(d, "script")),
            d.parentNode.removeChild(d));
      return a;
    }
    n.extend({
      htmlPrefilter: function (a) {
        return a.replace(va, "<$1></$2>");
      },
      clone: function (a, b, c) {
        var d,
          e,
          f,
          g,
          h,
          i = n.contains(a.ownerDocument, a);
        if (
          (l.html5Clone || n.isXMLDoc(a) || !ua.test("<" + a.nodeName + ">")
            ? (f = a.cloneNode(!0))
            : ((Ba.innerHTML = a.outerHTML),
              Ba.removeChild((f = Ba.firstChild))),
          !(
            (l.noCloneEvent && l.noCloneChecked) ||
            (1 !== a.nodeType && 11 !== a.nodeType) ||
            n.isXMLDoc(a)
          ))
        )
          for (d = ea(f), h = ea(a), g = 0; null != (e = h[g]); ++g)
            d[g] && Ga(e, d[g]);
        if (b)
          if (c)
            for (h = h || ea(a), d = d || ea(f), g = 0; null != (e = h[g]); g++)
              Fa(e, d[g]);
          else Fa(a, f);
        return (
          (d = ea(f, "script")),
          d.length > 0 && fa(d, !i && ea(a, "script")),
          (d = h = e = null),
          f
        );
      },
      cleanData: function (a, b) {
        for (
          var d,
            e,
            f,
            g,
            h = 0,
            i = n.expando,
            j = n.cache,
            k = l.attributes,
            m = n.event.special;
          null != (d = a[h]);
          h++
        )
          if ((b || M(d)) && ((f = d[i]), (g = f && j[f]))) {
            if (g.events)
              for (e in g.events)
                m[e] ? n.event.remove(d, e) : n.removeEvent(d, e, g.handle);
            j[f] &&
              (delete j[f],
              k || "undefined" == typeof d.removeAttribute
                ? (d[i] = void 0)
                : d.removeAttribute(i),
              c.push(f));
          }
      },
    }),
      n.fn.extend({
        domManip: Ha,
        detach: function (a) {
          return Ia(this, a, !0);
        },
        remove: function (a) {
          return Ia(this, a);
        },
        text: function (a) {
          return Y(
            this,
            function (a) {
              return void 0 === a
                ? n.text(this)
                : this.empty().append(
                    ((this[0] && this[0].ownerDocument) || d).createTextNode(a)
                  );
            },
            null,
            a,
            arguments.length
          );
        },
        append: function () {
          return Ha(this, arguments, function (a) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var b = Ca(this, a);
              b.appendChild(a);
            }
          });
        },
        prepend: function () {
          return Ha(this, arguments, function (a) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var b = Ca(this, a);
              b.insertBefore(a, b.firstChild);
            }
          });
        },
        before: function () {
          return Ha(this, arguments, function (a) {
            this.parentNode && this.parentNode.insertBefore(a, this);
          });
        },
        after: function () {
          return Ha(this, arguments, function (a) {
            this.parentNode &&
              this.parentNode.insertBefore(a, this.nextSibling);
          });
        },
        empty: function () {
          for (var a, b = 0; null != (a = this[b]); b++) {
            1 === a.nodeType && n.cleanData(ea(a, !1));
            while (a.firstChild) a.removeChild(a.firstChild);
            a.options && n.nodeName(a, "select") && (a.options.length = 0);
          }
          return this;
        },
        clone: function (a, b) {
          return (
            (a = null == a ? !1 : a),
            (b = null == b ? a : b),
            this.map(function () {
              return n.clone(this, a, b);
            })
          );
        },
        html: function (a) {
          return Y(
            this,
            function (a) {
              var b = this[0] || {},
                c = 0,
                d = this.length;
              if (void 0 === a)
                return 1 === b.nodeType ? b.innerHTML.replace(ta, "") : void 0;
              if (
                "string" == typeof a &&
                !wa.test(a) &&
                (l.htmlSerialize || !ua.test(a)) &&
                (l.leadingWhitespace || !aa.test(a)) &&
                !da[($.exec(a) || ["", ""])[1].toLowerCase()]
              ) {
                a = n.htmlPrefilter(a);
                try {
                  for (; d > c; c++)
                    (b = this[c] || {}),
                      1 === b.nodeType &&
                        (n.cleanData(ea(b, !1)), (b.innerHTML = a));
                  b = 0;
                } catch (e) {}
              }
              b && this.empty().append(a);
            },
            null,
            a,
            arguments.length
          );
        },
        replaceWith: function () {
          var a = [];
          return Ha(
            this,
            arguments,
            function (b) {
              var c = this.parentNode;
              n.inArray(this, a) < 0 &&
                (n.cleanData(ea(this)), c && c.replaceChild(b, this));
            },
            a
          );
        },
      }),
      n.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (a, b) {
          n.fn[a] = function (a) {
            for (var c, d = 0, e = [], f = n(a), h = f.length - 1; h >= d; d++)
              (c = d === h ? this : this.clone(!0)),
                n(f[d])[b](c),
                g.apply(e, c.get());
            return this.pushStack(e);
          };
        }
      );
    var Ja,
      Ka = { HTML: "block", BODY: "block" };
    function La(a, b) {
      var c = n(b.createElement(a)).appendTo(b.body),
        d = n.css(c[0], "display");
      return c.detach(), d;
    }
    function Ma(a) {
      var b = d,
        c = Ka[a];
      return (
        c ||
          ((c = La(a, b)),
          ("none" !== c && c) ||
            ((Ja = (
              Ja || n("<iframe frameborder='0' width='0' height='0'/>")
            ).appendTo(b.documentElement)),
            (b = (Ja[0].contentWindow || Ja[0].contentDocument).document),
            b.write(),
            b.close(),
            (c = La(a, b)),
            Ja.detach()),
          (Ka[a] = c)),
        c
      );
    }
    var Na = /^margin/,
      Oa = new RegExp("^(" + T + ")(?!px)[a-z%]+$", "i"),
      Pa = function (a, b, c, d) {
        var e,
          f,
          g = {};
        for (f in b) (g[f] = a.style[f]), (a.style[f] = b[f]);
        e = c.apply(a, d || []);
        for (f in b) a.style[f] = g[f];
        return e;
      },
      Qa = d.documentElement;
    !(function () {
      var b,
        c,
        e,
        f,
        g,
        h,
        i = d.createElement("div"),
        j = d.createElement("div");
      if (j.style) {
        (j.style.cssText = "float:left;opacity:.5"),
          (l.opacity = "0.5" === j.style.opacity),
          (l.cssFloat = !!j.style.cssFloat),
          (j.style.backgroundClip = "content-box"),
          (j.cloneNode(!0).style.backgroundClip = ""),
          (l.clearCloneStyle = "content-box" === j.style.backgroundClip),
          (i = d.createElement("div")),
          (i.style.cssText =
            "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
          (j.innerHTML = ""),
          i.appendChild(j),
          (l.boxSizing =
            "" === j.style.boxSizing ||
            "" === j.style.MozBoxSizing ||
            "" === j.style.WebkitBoxSizing),
          n.extend(l, {
            reliableHiddenOffsets: function () {
              return null == b && k(), f;
            },
            boxSizingReliable: function () {
              return null == b && k(), e;
            },
            pixelMarginRight: function () {
              return null == b && k(), c;
            },
            pixelPosition: function () {
              return null == b && k(), b;
            },
            reliableMarginRight: function () {
              return null == b && k(), g;
            },
            reliableMarginLeft: function () {
              return null == b && k(), h;
            },
          });
        function k() {
          var k,
            l,
            m = d.documentElement;
          m.appendChild(i),
            (j.style.cssText =
              "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
            (b = e = h = !1),
            (c = g = !0),
            a.getComputedStyle &&
              ((l = a.getComputedStyle(j)),
              (b = "1%" !== (l || {}).top),
              (h = "2px" === (l || {}).marginLeft),
              (e = "4px" === (l || { width: "4px" }).width),
              (j.style.marginRight = "50%"),
              (c = "4px" === (l || { marginRight: "4px" }).marginRight),
              (k = j.appendChild(d.createElement("div"))),
              (k.style.cssText = j.style.cssText =
                "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
              (k.style.marginRight = k.style.width = "0"),
              (j.style.width = "1px"),
              (g = !parseFloat((a.getComputedStyle(k) || {}).marginRight)),
              j.removeChild(k)),
            (j.style.display = "none"),
            (f = 0 === j.getClientRects().length),
            f &&
              ((j.style.display = ""),
              (j.innerHTML = "<table><tr><td></td><td>t</td></tr></table>"),
              (k = j.getElementsByTagName("td")),
              (k[0].style.cssText = "margin:0;border:0;padding:0;display:none"),
              (f = 0 === k[0].offsetHeight),
              f &&
                ((k[0].style.display = ""),
                (k[1].style.display = "none"),
                (f = 0 === k[0].offsetHeight))),
            m.removeChild(i);
        }
      }
    })();
    var Ra,
      Sa,
      Ta = /^(top|right|bottom|left)$/;
    a.getComputedStyle
      ? ((Ra = function (b) {
          var c = b.ownerDocument.defaultView;
          return c.opener || (c = a), c.getComputedStyle(b);
        }),
        (Sa = function (a, b, c) {
          var d,
            e,
            f,
            g,
            h = a.style;
          return (
            (c = c || Ra(a)),
            (g = c ? c.getPropertyValue(b) || c[b] : void 0),
            c &&
              ("" !== g ||
                n.contains(a.ownerDocument, a) ||
                (g = n.style(a, b)),
              !l.pixelMarginRight() &&
                Oa.test(g) &&
                Na.test(b) &&
                ((d = h.width),
                (e = h.minWidth),
                (f = h.maxWidth),
                (h.minWidth = h.maxWidth = h.width = g),
                (g = c.width),
                (h.width = d),
                (h.minWidth = e),
                (h.maxWidth = f))),
            void 0 === g ? g : g + ""
          );
        }))
      : Qa.currentStyle &&
        ((Ra = function (a) {
          return a.currentStyle;
        }),
        (Sa = function (a, b, c) {
          var d,
            e,
            f,
            g,
            h = a.style;
          return (
            (c = c || Ra(a)),
            (g = c ? c[b] : void 0),
            null == g && h && h[b] && (g = h[b]),
            Oa.test(g) &&
              !Ta.test(b) &&
              ((d = h.left),
              (e = a.runtimeStyle),
              (f = e && e.left),
              f && (e.left = a.currentStyle.left),
              (h.left = "fontSize" === b ? "1em" : g),
              (g = h.pixelLeft + "px"),
              (h.left = d),
              f && (e.left = f)),
            void 0 === g ? g : g + "" || "auto"
          );
        }));
    function Ua(a, b) {
      return {
        get: function () {
          return a()
            ? void delete this.get
            : (this.get = b).apply(this, arguments);
        },
      };
    }
    var Va = /alpha\([^)]*\)/i,
      Wa = /opacity\s*=\s*([^)]*)/i,
      Xa = /^(none|table(?!-c[ea]).+)/,
      Ya = new RegExp("^(" + T + ")(.*)$", "i"),
      Za = { position: "absolute", visibility: "hidden", display: "block" },
      $a = { letterSpacing: "0", fontWeight: "400" },
      _a = ["Webkit", "O", "Moz", "ms"],
      ab = d.createElement("div").style;
    function bb(a) {
      if (a in ab) return a;
      var b = a.charAt(0).toUpperCase() + a.slice(1),
        c = _a.length;
      while (c--) if (((a = _a[c] + b), a in ab)) return a;
    }
    function cb(a, b) {
      for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++)
        (d = a[g]),
          d.style &&
            ((f[g] = n._data(d, "olddisplay")),
            (c = d.style.display),
            b
              ? (f[g] || "none" !== c || (d.style.display = ""),
                "" === d.style.display &&
                  W(d) &&
                  (f[g] = n._data(d, "olddisplay", Ma(d.nodeName))))
              : ((e = W(d)),
                ((c && "none" !== c) || !e) &&
                  n._data(d, "olddisplay", e ? c : n.css(d, "display"))));
      for (g = 0; h > g; g++)
        (d = a[g]),
          d.style &&
            ((b && "none" !== d.style.display && "" !== d.style.display) ||
              (d.style.display = b ? f[g] || "" : "none"));
      return a;
    }
    function db(a, b, c) {
      var d = Ya.exec(b);
      return d ? Math.max(0, d[1] - (c || 0)) + (d[2] || "px") : b;
    }
    function eb(a, b, c, d, e) {
      for (
        var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0,
          g = 0;
        4 > f;
        f += 2
      )
        "margin" === c && (g += n.css(a, c + V[f], !0, e)),
          d
            ? ("content" === c && (g -= n.css(a, "padding" + V[f], !0, e)),
              "margin" !== c &&
                (g -= n.css(a, "border" + V[f] + "Width", !0, e)))
            : ((g += n.css(a, "padding" + V[f], !0, e)),
              "padding" !== c &&
                (g += n.css(a, "border" + V[f] + "Width", !0, e)));
      return g;
    }
    function fb(b, c, e) {
      var f = !0,
        g = "width" === c ? b.offsetWidth : b.offsetHeight,
        h = Ra(b),
        i = l.boxSizing && "border-box" === n.css(b, "boxSizing", !1, h);
      if (
        (d.msFullscreenElement &&
          a.top !== a &&
          b.getClientRects().length &&
          (g = Math.round(100 * b.getBoundingClientRect()[c])),
        0 >= g || null == g)
      ) {
        if (
          ((g = Sa(b, c, h)),
          (0 > g || null == g) && (g = b.style[c]),
          Oa.test(g))
        )
          return g;
        (f = i && (l.boxSizingReliable() || g === b.style[c])),
          (g = parseFloat(g) || 0);
      }
      return g + eb(b, c, e || (i ? "border" : "content"), f, h) + "px";
    }
    n.extend({
      cssHooks: {
        opacity: {
          get: function (a, b) {
            if (b) {
              var c = Sa(a, "opacity");
              return "" === c ? "1" : c;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: { float: l.cssFloat ? "cssFloat" : "styleFloat" },
      style: function (a, b, c, d) {
        if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
          var e,
            f,
            g,
            h = n.camelCase(b),
            i = a.style;
          if (
            ((b = n.cssProps[h] || (n.cssProps[h] = bb(h) || h)),
            (g = n.cssHooks[b] || n.cssHooks[h]),
            void 0 === c)
          )
            return g && "get" in g && void 0 !== (e = g.get(a, !1, d))
              ? e
              : i[b];
          if (
            ((f = typeof c),
            "string" === f &&
              (e = U.exec(c)) &&
              e[1] &&
              ((c = X(a, b, e)), (f = "number")),
            null != c &&
              c === c &&
              ("number" === f &&
                (c += (e && e[3]) || (n.cssNumber[h] ? "" : "px")),
              l.clearCloneStyle ||
                "" !== c ||
                0 !== b.indexOf("background") ||
                (i[b] = "inherit"),
              !(g && "set" in g && void 0 === (c = g.set(a, c, d)))))
          )
            try {
              i[b] = c;
            } catch (j) {}
        }
      },
      css: function (a, b, c, d) {
        var e,
          f,
          g,
          h = n.camelCase(b);
        return (
          (b = n.cssProps[h] || (n.cssProps[h] = bb(h) || h)),
          (g = n.cssHooks[b] || n.cssHooks[h]),
          g && "get" in g && (f = g.get(a, !0, c)),
          void 0 === f && (f = Sa(a, b, d)),
          "normal" === f && b in $a && (f = $a[b]),
          "" === c || c
            ? ((e = parseFloat(f)), c === !0 || isFinite(e) ? e || 0 : f)
            : f
        );
      },
    }),
      n.each(["height", "width"], function (a, b) {
        n.cssHooks[b] = {
          get: function (a, c, d) {
            return c
              ? Xa.test(n.css(a, "display")) && 0 === a.offsetWidth
                ? Pa(a, Za, function () {
                    return fb(a, b, d);
                  })
                : fb(a, b, d)
              : void 0;
          },
          set: function (a, c, d) {
            var e = d && Ra(a);
            return db(
              a,
              c,
              d
                ? eb(
                    a,
                    b,
                    d,
                    l.boxSizing &&
                      "border-box" === n.css(a, "boxSizing", !1, e),
                    e
                  )
                : 0
            );
          },
        };
      }),
      l.opacity ||
        (n.cssHooks.opacity = {
          get: function (a, b) {
            return Wa.test(
              (b && a.currentStyle ? a.currentStyle.filter : a.style.filter) ||
                ""
            )
              ? 0.01 * parseFloat(RegExp.$1) + ""
              : b
              ? "1"
              : "";
          },
          set: function (a, b) {
            var c = a.style,
              d = a.currentStyle,
              e = n.isNumeric(b) ? "alpha(opacity=" + 100 * b + ")" : "",
              f = (d && d.filter) || c.filter || "";
            (c.zoom = 1),
              ((b >= 1 || "" === b) &&
                "" === n.trim(f.replace(Va, "")) &&
                c.removeAttribute &&
                (c.removeAttribute("filter"), "" === b || (d && !d.filter))) ||
                (c.filter = Va.test(f) ? f.replace(Va, e) : f + " " + e);
          },
        }),
      (n.cssHooks.marginRight = Ua(l.reliableMarginRight, function (a, b) {
        return b
          ? Pa(a, { display: "inline-block" }, Sa, [a, "marginRight"])
          : void 0;
      })),
      (n.cssHooks.marginLeft = Ua(l.reliableMarginLeft, function (a, b) {
        return b
          ? (parseFloat(Sa(a, "marginLeft")) ||
              (n.contains(a.ownerDocument, a)
                ? a.getBoundingClientRect().left -
                  Pa(
                    a,
                    {
                      marginLeft: 0,
                    },
                    function () {
                      return a.getBoundingClientRect().left;
                    }
                  )
                : 0)) + "px"
          : void 0;
      })),
      n.each({ margin: "", padding: "", border: "Width" }, function (a, b) {
        (n.cssHooks[a + b] = {
          expand: function (c) {
            for (
              var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c];
              4 > d;
              d++
            )
              e[a + V[d] + b] = f[d] || f[d - 2] || f[0];
            return e;
          },
        }),
          Na.test(a) || (n.cssHooks[a + b].set = db);
      }),
      n.fn.extend({
        css: function (a, b) {
          return Y(
            this,
            function (a, b, c) {
              var d,
                e,
                f = {},
                g = 0;
              if (n.isArray(b)) {
                for (d = Ra(a), e = b.length; e > g; g++)
                  f[b[g]] = n.css(a, b[g], !1, d);
                return f;
              }
              return void 0 !== c ? n.style(a, b, c) : n.css(a, b);
            },
            a,
            b,
            arguments.length > 1
          );
        },
        show: function () {
          return cb(this, !0);
        },
        hide: function () {
          return cb(this);
        },
        toggle: function (a) {
          return "boolean" == typeof a
            ? a
              ? this.show()
              : this.hide()
            : this.each(function () {
                W(this) ? n(this).show() : n(this).hide();
              });
        },
      });
    function gb(a, b, c, d, e) {
      return new gb.prototype.init(a, b, c, d, e);
    }
    (n.Tween = gb),
      (gb.prototype = {
        constructor: gb,
        init: function (a, b, c, d, e, f) {
          (this.elem = a),
            (this.prop = c),
            (this.easing = e || n.easing._default),
            (this.options = b),
            (this.start = this.now = this.cur()),
            (this.end = d),
            (this.unit = f || (n.cssNumber[c] ? "" : "px"));
        },
        cur: function () {
          var a = gb.propHooks[this.prop];
          return a && a.get ? a.get(this) : gb.propHooks._default.get(this);
        },
        run: function (a) {
          var b,
            c = gb.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = b =
                  n.easing[this.easing](
                    a,
                    this.options.duration * a,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = b = a),
            (this.now = (this.end - this.start) * b + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            c && c.set ? c.set(this) : gb.propHooks._default.set(this),
            this
          );
        },
      }),
      (gb.prototype.init.prototype = gb.prototype),
      (gb.propHooks = {
        _default: {
          get: function (a) {
            var b;
            return 1 !== a.elem.nodeType ||
              (null != a.elem[a.prop] && null == a.elem.style[a.prop])
              ? a.elem[a.prop]
              : ((b = n.css(a.elem, a.prop, "")), b && "auto" !== b ? b : 0);
          },
          set: function (a) {
            n.fx.step[a.prop]
              ? n.fx.step[a.prop](a)
              : 1 !== a.elem.nodeType ||
                (null == a.elem.style[n.cssProps[a.prop]] &&
                  !n.cssHooks[a.prop])
              ? (a.elem[a.prop] = a.now)
              : n.style(a.elem, a.prop, a.now + a.unit);
          },
        },
      }),
      (gb.propHooks.scrollTop = gb.propHooks.scrollLeft =
        {
          set: function (a) {
            a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
          },
        }),
      (n.easing = {
        linear: function (a) {
          return a;
        },
        swing: function (a) {
          return 0.5 - Math.cos(a * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (n.fx = gb.prototype.init),
      (n.fx.step = {});
    var hb,
      ib,
      jb = /^(?:toggle|show|hide)$/,
      kb = /queueHooks$/;
    function lb() {
      return (
        a.setTimeout(function () {
          hb = void 0;
        }),
        (hb = n.now())
      );
    }
    function mb(a, b) {
      var c,
        d = { height: a },
        e = 0;
      for (b = b ? 1 : 0; 4 > e; e += 2 - b)
        (c = V[e]), (d["margin" + c] = d["padding" + c] = a);
      return b && (d.opacity = d.width = a), d;
    }
    function nb(a, b, c) {
      for (
        var d,
          e = (qb.tweeners[b] || []).concat(qb.tweeners["*"]),
          f = 0,
          g = e.length;
        g > f;
        f++
      )
        if ((d = e[f].call(c, b, a))) return d;
    }
    function ob(a, b, c) {
      var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        m = this,
        o = {},
        p = a.style,
        q = a.nodeType && W(a),
        r = n._data(a, "fxshow");
      c.queue ||
        ((h = n._queueHooks(a, "fx")),
        null == h.unqueued &&
          ((h.unqueued = 0),
          (i = h.empty.fire),
          (h.empty.fire = function () {
            h.unqueued || i();
          })),
        h.unqueued++,
        m.always(function () {
          m.always(function () {
            h.unqueued--, n.queue(a, "fx").length || h.empty.fire();
          });
        })),
        1 === a.nodeType &&
          ("height" in b || "width" in b) &&
          ((c.overflow = [p.overflow, p.overflowX, p.overflowY]),
          (j = n.css(a, "display")),
          (k = "none" === j ? n._data(a, "olddisplay") || Ma(a.nodeName) : j),
          "inline" === k &&
            "none" === n.css(a, "float") &&
            (l.inlineBlockNeedsLayout && "inline" !== Ma(a.nodeName)
              ? (p.zoom = 1)
              : (p.display = "inline-block"))),
        c.overflow &&
          ((p.overflow = "hidden"),
          l.shrinkWrapBlocks() ||
            m.always(function () {
              (p.overflow = c.overflow[0]),
                (p.overflowX = c.overflow[1]),
                (p.overflowY = c.overflow[2]);
            }));
      for (d in b)
        if (((e = b[d]), jb.exec(e))) {
          if (
            (delete b[d],
            (f = f || "toggle" === e),
            e === (q ? "hide" : "show"))
          ) {
            if ("show" !== e || !r || void 0 === r[d]) continue;
            q = !0;
          }
          o[d] = (r && r[d]) || n.style(a, d);
        } else j = void 0;
      if (n.isEmptyObject(o))
        "inline" === ("none" === j ? Ma(a.nodeName) : j) && (p.display = j);
      else {
        r ? "hidden" in r && (q = r.hidden) : (r = n._data(a, "fxshow", {})),
          f && (r.hidden = !q),
          q
            ? n(a).show()
            : m.done(function () {
                n(a).hide();
              }),
          m.done(function () {
            var b;
            n._removeData(a, "fxshow");
            for (b in o) n.style(a, b, o[b]);
          });
        for (d in o)
          (g = nb(q ? r[d] : 0, d, m)),
            d in r ||
              ((r[d] = g.start),
              q &&
                ((g.end = g.start),
                (g.start = "width" === d || "height" === d ? 1 : 0)));
      }
    }
    function pb(a, b) {
      var c, d, e, f, g;
      for (c in a)
        if (
          ((d = n.camelCase(c)),
          (e = b[d]),
          (f = a[c]),
          n.isArray(f) && ((e = f[1]), (f = a[c] = f[0])),
          c !== d && ((a[d] = f), delete a[c]),
          (g = n.cssHooks[d]),
          g && "expand" in g)
        ) {
          (f = g.expand(f)), delete a[d];
          for (c in f) c in a || ((a[c] = f[c]), (b[c] = e));
        } else b[d] = e;
    }
    function qb(a, b, c) {
      var d,
        e,
        f = 0,
        g = qb.prefilters.length,
        h = n.Deferred().always(function () {
          delete i.elem;
        }),
        i = function () {
          if (e) return !1;
          for (
            var b = hb || lb(),
              c = Math.max(0, j.startTime + j.duration - b),
              d = c / j.duration || 0,
              f = 1 - d,
              g = 0,
              i = j.tweens.length;
            i > g;
            g++
          )
            j.tweens[g].run(f);
          return (
            h.notifyWith(a, [j, f, c]),
            1 > f && i ? c : (h.resolveWith(a, [j]), !1)
          );
        },
        j = h.promise({
          elem: a,
          props: n.extend({}, b),
          opts: n.extend(
            !0,
            { specialEasing: {}, easing: n.easing._default },
            c
          ),
          originalProperties: b,
          originalOptions: c,
          startTime: hb || lb(),
          duration: c.duration,
          tweens: [],
          createTween: function (b, c) {
            var d = n.Tween(
              a,
              j.opts,
              b,
              c,
              j.opts.specialEasing[b] || j.opts.easing
            );
            return j.tweens.push(d), d;
          },
          stop: function (b) {
            var c = 0,
              d = b ? j.tweens.length : 0;
            if (e) return this;
            for (e = !0; d > c; c++) j.tweens[c].run(1);
            return (
              b
                ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b]))
                : h.rejectWith(a, [j, b]),
              this
            );
          },
        }),
        k = j.props;
      for (pb(k, j.opts.specialEasing); g > f; f++)
        if ((d = qb.prefilters[f].call(j, a, k, j.opts)))
          return (
            n.isFunction(d.stop) &&
              (n._queueHooks(j.elem, j.opts.queue).stop = n.proxy(d.stop, d)),
            d
          );
      return (
        n.map(k, nb, j),
        n.isFunction(j.opts.start) && j.opts.start.call(a, j),
        n.fx.timer(n.extend(i, { elem: a, anim: j, queue: j.opts.queue })),
        j
          .progress(j.opts.progress)
          .done(j.opts.done, j.opts.complete)
          .fail(j.opts.fail)
          .always(j.opts.always)
      );
    }
    (n.Animation = n.extend(qb, {
      tweeners: {
        "*": [
          function (a, b) {
            var c = this.createTween(a, b);
            return X(c.elem, a, U.exec(b), c), c;
          },
        ],
      },
      tweener: function (a, b) {
        n.isFunction(a) ? ((b = a), (a = ["*"])) : (a = a.match(G));
        for (var c, d = 0, e = a.length; e > d; d++)
          (c = a[d]),
            (qb.tweeners[c] = qb.tweeners[c] || []),
            qb.tweeners[c].unshift(b);
      },
      prefilters: [ob],
      prefilter: function (a, b) {
        b ? qb.prefilters.unshift(a) : qb.prefilters.push(a);
      },
    })),
      (n.speed = function (a, b, c) {
        var d =
          a && "object" == typeof a
            ? n.extend({}, a)
            : {
                complete: c || (!c && b) || (n.isFunction(a) && a),
                duration: a,
                easing: (c && b) || (b && !n.isFunction(b) && b),
              };
        return (
          (d.duration = n.fx.off
            ? 0
            : "number" == typeof d.duration
            ? d.duration
            : d.duration in n.fx.speeds
            ? n.fx.speeds[d.duration]
            : n.fx.speeds._default),
          (null == d.queue || d.queue === !0) && (d.queue = "fx"),
          (d.old = d.complete),
          (d.complete = function () {
            n.isFunction(d.old) && d.old.call(this),
              d.queue && n.dequeue(this, d.queue);
          }),
          d
        );
      }),
      n.fn.extend({
        fadeTo: function (a, b, c, d) {
          return this.filter(W)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: b }, a, c, d);
        },
        animate: function (a, b, c, d) {
          var e = n.isEmptyObject(a),
            f = n.speed(b, c, d),
            g = function () {
              var b = qb(this, n.extend({}, a), f);
              (e || n._data(this, "finish")) && b.stop(!0);
            };
          return (
            (g.finish = g),
            e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g)
          );
        },
        stop: function (a, b, c) {
          var d = function (a) {
            var b = a.stop;
            delete a.stop, b(c);
          };
          return (
            "string" != typeof a && ((c = b), (b = a), (a = void 0)),
            b && a !== !1 && this.queue(a || "fx", []),
            this.each(function () {
              var b = !0,
                e = null != a && a + "queueHooks",
                f = n.timers,
                g = n._data(this);
              if (e) g[e] && g[e].stop && d(g[e]);
              else for (e in g) g[e] && g[e].stop && kb.test(e) && d(g[e]);
              for (e = f.length; e--; )
                f[e].elem !== this ||
                  (null != a && f[e].queue !== a) ||
                  (f[e].anim.stop(c), (b = !1), f.splice(e, 1));
              (b || !c) && n.dequeue(this, a);
            })
          );
        },
        finish: function (a) {
          return (
            a !== !1 && (a = a || "fx"),
            this.each(function () {
              var b,
                c = n._data(this),
                d = c[a + "queue"],
                e = c[a + "queueHooks"],
                f = n.timers,
                g = d ? d.length : 0;
              for (
                c.finish = !0,
                  n.queue(this, a, []),
                  e && e.stop && e.stop.call(this, !0),
                  b = f.length;
                b--;

              )
                f[b].elem === this &&
                  f[b].queue === a &&
                  (f[b].anim.stop(!0), f.splice(b, 1));
              for (b = 0; g > b; b++)
                d[b] && d[b].finish && d[b].finish.call(this);
              delete c.finish;
            })
          );
        },
      }),
      n.each(["toggle", "show", "hide"], function (a, b) {
        var c = n.fn[b];
        n.fn[b] = function (a, d, e) {
          return null == a || "boolean" == typeof a
            ? c.apply(this, arguments)
            : this.animate(mb(b, !0), a, d, e);
        };
      }),
      n.each(
        {
          slideDown: mb("show"),
          slideUp: mb("hide"),
          slideToggle: mb("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (a, b) {
          n.fn[a] = function (a, c, d) {
            return this.animate(b, a, c, d);
          };
        }
      ),
      (n.timers = []),
      (n.fx.tick = function () {
        var a,
          b = n.timers,
          c = 0;
        for (hb = n.now(); c < b.length; c++)
          (a = b[c]), a() || b[c] !== a || b.splice(c--, 1);
        b.length || n.fx.stop(), (hb = void 0);
      }),
      (n.fx.timer = function (a) {
        n.timers.push(a), a() ? n.fx.start() : n.timers.pop();
      }),
      (n.fx.interval = 13),
      (n.fx.start = function () {
        ib || (ib = a.setInterval(n.fx.tick, n.fx.interval));
      }),
      (n.fx.stop = function () {
        a.clearInterval(ib), (ib = null);
      }),
      (n.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (n.fn.delay = function (b, c) {
        return (
          (b = n.fx ? n.fx.speeds[b] || b : b),
          (c = c || "fx"),
          this.queue(c, function (c, d) {
            var e = a.setTimeout(c, b);
            d.stop = function () {
              a.clearTimeout(e);
            };
          })
        );
      }),
      (function () {
        var a,
          b = d.createElement("input"),
          c = d.createElement("div"),
          e = d.createElement("select"),
          f = e.appendChild(d.createElement("option"));
        (c = d.createElement("div")),
          c.setAttribute("className", "t"),
          (c.innerHTML =
            "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
          (a = c.getElementsByTagName("a")[0]),
          b.setAttribute("type", "checkbox"),
          c.appendChild(b),
          (a = c.getElementsByTagName("a")[0]),
          (a.style.cssText = "top:1px"),
          (l.getSetAttribute = "t" !== c.className),
          (l.style = /top/.test(a.getAttribute("style"))),
          (l.hrefNormalized = "/a" === a.getAttribute("href")),
          (l.checkOn = !!b.value),
          (l.optSelected = f.selected),
          (l.enctype = !!d.createElement("form").enctype),
          (e.disabled = !0),
          (l.optDisabled = !f.disabled),
          (b = d.createElement("input")),
          b.setAttribute("value", ""),
          (l.input = "" === b.getAttribute("value")),
          (b.value = "t"),
          b.setAttribute("type", "radio"),
          (l.radioValue = "t" === b.value);
      })();
    var rb = /\r/g;
    n.fn.extend({
      val: function (a) {
        var b,
          c,
          d,
          e = this[0];
        {
          if (arguments.length)
            return (
              (d = n.isFunction(a)),
              this.each(function (c) {
                var e;
                1 === this.nodeType &&
                  ((e = d ? a.call(this, c, n(this).val()) : a),
                  null == e
                    ? (e = "")
                    : "number" == typeof e
                    ? (e += "")
                    : n.isArray(e) &&
                      (e = n.map(e, function (a) {
                        return null == a ? "" : a + "";
                      })),
                  (b =
                    n.valHooks[this.type] ||
                    n.valHooks[this.nodeName.toLowerCase()]),
                  (b && "set" in b && void 0 !== b.set(this, e, "value")) ||
                    (this.value = e));
              })
            );
          if (e)
            return (
              (b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()]),
              b && "get" in b && void 0 !== (c = b.get(e, "value"))
                ? c
                : ((c = e.value),
                  "string" == typeof c ? c.replace(rb, "") : null == c ? "" : c)
            );
        }
      },
    }),
      n.extend({
        valHooks: {
          option: {
            get: function (a) {
              var b = n.find.attr(a, "value");
              return null != b ? b : n.trim(n.text(a));
            },
          },
          select: {
            get: function (a) {
              for (
                var b,
                  c,
                  d = a.options,
                  e = a.selectedIndex,
                  f = "select-one" === a.type || 0 > e,
                  g = f ? null : [],
                  h = f ? e + 1 : d.length,
                  i = 0 > e ? h : f ? e : 0;
                h > i;
                i++
              )
                if (
                  ((c = d[i]),
                  (c.selected || i === e) &&
                    (l.optDisabled
                      ? !c.disabled
                      : null === c.getAttribute("disabled")) &&
                    (!c.parentNode.disabled ||
                      !n.nodeName(c.parentNode, "optgroup")))
                ) {
                  if (((b = n(c).val()), f)) return b;
                  g.push(b);
                }
              return g;
            },
            set: function (a, b) {
              var c,
                d,
                e = a.options,
                f = n.makeArray(b),
                g = e.length;
              while (g--)
                if (((d = e[g]), n.inArray(n.valHooks.option.get(d), f) >= 0))
                  try {
                    d.selected = c = !0;
                  } catch (h) {
                    d.scrollHeight;
                  }
                else d.selected = !1;
              return c || (a.selectedIndex = -1), e;
            },
          },
        },
      }),
      n.each(["radio", "checkbox"], function () {
        (n.valHooks[this] = {
          set: function (a, b) {
            return n.isArray(b)
              ? (a.checked = n.inArray(n(a).val(), b) > -1)
              : void 0;
          },
        }),
          l.checkOn ||
            (n.valHooks[this].get = function (a) {
              return null === a.getAttribute("value") ? "on" : a.value;
            });
      });
    var sb,
      tb,
      ub = n.expr.attrHandle,
      vb = /^(?:checked|selected)$/i,
      wb = l.getSetAttribute,
      xb = l.input;
    n.fn.extend({
      attr: function (a, b) {
        return Y(this, n.attr, a, b, arguments.length > 1);
      },
      removeAttr: function (a) {
        return this.each(function () {
          n.removeAttr(this, a);
        });
      },
    }),
      n.extend({
        attr: function (a, b, c) {
          var d,
            e,
            f = a.nodeType;
          if (3 !== f && 8 !== f && 2 !== f)
            return "undefined" == typeof a.getAttribute
              ? n.prop(a, b, c)
              : ((1 === f && n.isXMLDoc(a)) ||
                  ((b = b.toLowerCase()),
                  (e =
                    n.attrHooks[b] || (n.expr.match.bool.test(b) ? tb : sb))),
                void 0 !== c
                  ? null === c
                    ? void n.removeAttr(a, b)
                    : e && "set" in e && void 0 !== (d = e.set(a, c, b))
                    ? d
                    : (a.setAttribute(b, c + ""), c)
                  : e && "get" in e && null !== (d = e.get(a, b))
                  ? d
                  : ((d = n.find.attr(a, b)), null == d ? void 0 : d));
        },
        attrHooks: {
          type: {
            set: function (a, b) {
              if (!l.radioValue && "radio" === b && n.nodeName(a, "input")) {
                var c = a.value;
                return a.setAttribute("type", b), c && (a.value = c), b;
              }
            },
          },
        },
        removeAttr: function (a, b) {
          var c,
            d,
            e = 0,
            f = b && b.match(G);
          if (f && 1 === a.nodeType)
            while ((c = f[e++]))
              (d = n.propFix[c] || c),
                n.expr.match.bool.test(c)
                  ? (xb && wb) || !vb.test(c)
                    ? (a[d] = !1)
                    : (a[n.camelCase("default-" + c)] = a[d] = !1)
                  : n.attr(a, c, ""),
                a.removeAttribute(wb ? c : d);
        },
      }),
      (tb = {
        set: function (a, b, c) {
          return (
            b === !1
              ? n.removeAttr(a, c)
              : (xb && wb) || !vb.test(c)
              ? a.setAttribute((!wb && n.propFix[c]) || c, c)
              : (a[n.camelCase("default-" + c)] = a[c] = !0),
            c
          );
        },
      }),
      n.each(n.expr.match.bool.source.match(/\w+/g), function (a, b) {
        var c = ub[b] || n.find.attr;
        (xb && wb) || !vb.test(b)
          ? (ub[b] = function (a, b, d) {
              var e, f;
              return (
                d ||
                  ((f = ub[b]),
                  (ub[b] = e),
                  (e = null != c(a, b, d) ? b.toLowerCase() : null),
                  (ub[b] = f)),
                e
              );
            })
          : (ub[b] = function (a, b, c) {
              return c
                ? void 0
                : a[n.camelCase("default-" + b)]
                ? b.toLowerCase()
                : null;
            });
      }),
      (xb && wb) ||
        (n.attrHooks.value = {
          set: function (a, b, c) {
            return n.nodeName(a, "input")
              ? void (a.defaultValue = b)
              : sb && sb.set(a, b, c);
          },
        }),
      wb ||
        ((sb = {
          set: function (a, b, c) {
            var d = a.getAttributeNode(c);
            return (
              d || a.setAttributeNode((d = a.ownerDocument.createAttribute(c))),
              (d.value = b += ""),
              "value" === c || b === a.getAttribute(c) ? b : void 0
            );
          },
        }),
        (ub.id =
          ub.name =
          ub.coords =
            function (a, b, c) {
              var d;
              return c
                ? void 0
                : (d = a.getAttributeNode(b)) && "" !== d.value
                ? d.value
                : null;
            }),
        (n.valHooks.button = {
          get: function (a, b) {
            var c = a.getAttributeNode(b);
            return c && c.specified ? c.value : void 0;
          },
          set: sb.set,
        }),
        (n.attrHooks.contenteditable = {
          set: function (a, b, c) {
            sb.set(a, "" === b ? !1 : b, c);
          },
        }),
        n.each(["width", "height"], function (a, b) {
          n.attrHooks[b] = {
            set: function (a, c) {
              return "" === c ? (a.setAttribute(b, "auto"), c) : void 0;
            },
          };
        })),
      l.style ||
        (n.attrHooks.style = {
          get: function (a) {
            return a.style.cssText || void 0;
          },
          set: function (a, b) {
            return (a.style.cssText = b + "");
          },
        });
    var yb = /^(?:input|select|textarea|button|object)$/i,
      zb = /^(?:a|area)$/i;
    n.fn.extend({
      prop: function (a, b) {
        return Y(this, n.prop, a, b, arguments.length > 1);
      },
      removeProp: function (a) {
        return (
          (a = n.propFix[a] || a),
          this.each(function () {
            try {
              (this[a] = void 0), delete this[a];
            } catch (b) {}
          })
        );
      },
    }),
      n.extend({
        prop: function (a, b, c) {
          var d,
            e,
            f = a.nodeType;
          if (3 !== f && 8 !== f && 2 !== f)
            return (
              (1 === f && n.isXMLDoc(a)) ||
                ((b = n.propFix[b] || b), (e = n.propHooks[b])),
              void 0 !== c
                ? e && "set" in e && void 0 !== (d = e.set(a, c, b))
                  ? d
                  : (a[b] = c)
                : e && "get" in e && null !== (d = e.get(a, b))
                ? d
                : a[b]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (a) {
              var b = n.find.attr(a, "tabindex");
              return b
                ? parseInt(b, 10)
                : yb.test(a.nodeName) || (zb.test(a.nodeName) && a.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      l.hrefNormalized ||
        n.each(["href", "src"], function (a, b) {
          n.propHooks[b] = {
            get: function (a) {
              return a.getAttribute(b, 4);
            },
          };
        }),
      l.optSelected ||
        (n.propHooks.selected = {
          get: function (a) {
            var b = a.parentNode;
            return (
              b &&
                (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex),
              null
            );
          },
        }),
      n.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          n.propFix[this.toLowerCase()] = this;
        }
      ),
      l.enctype || (n.propFix.enctype = "encoding");
    var Ab = /[\t\r\n\f]/g;
    function Bb(a) {
      return n.attr(a, "class") || "";
    }
    n.fn.extend({
      addClass: function (a) {
        var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i = 0;
        if (n.isFunction(a))
          return this.each(function (b) {
            n(this).addClass(a.call(this, b, Bb(this)));
          });
        if ("string" == typeof a && a) {
          b = a.match(G) || [];
          while ((c = this[i++]))
            if (
              ((e = Bb(c)),
              (d = 1 === c.nodeType && (" " + e + " ").replace(Ab, " ")))
            ) {
              g = 0;
              while ((f = b[g++]))
                d.indexOf(" " + f + " ") < 0 && (d += f + " ");
              (h = n.trim(d)), e !== h && n.attr(c, "class", h);
            }
        }
        return this;
      },
      removeClass: function (a) {
        var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i = 0;
        if (n.isFunction(a))
          return this.each(function (b) {
            n(this).removeClass(a.call(this, b, Bb(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ("string" == typeof a && a) {
          b = a.match(G) || [];
          while ((c = this[i++]))
            if (
              ((e = Bb(c)),
              (d = 1 === c.nodeType && (" " + e + " ").replace(Ab, " ")))
            ) {
              g = 0;
              while ((f = b[g++]))
                while (d.indexOf(" " + f + " ") > -1)
                  d = d.replace(" " + f + " ", " ");
              (h = n.trim(d)), e !== h && n.attr(c, "class", h);
            }
        }
        return this;
      },
      toggleClass: function (a, b) {
        var c = typeof a;
        return "boolean" == typeof b && "string" === c
          ? b
            ? this.addClass(a)
            : this.removeClass(a)
          : n.isFunction(a)
          ? this.each(function (c) {
              n(this).toggleClass(a.call(this, c, Bb(this), b), b);
            })
          : this.each(function () {
              var b, d, e, f;
              if ("string" === c) {
                (d = 0), (e = n(this)), (f = a.match(G) || []);
                while ((b = f[d++]))
                  e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
              } else (void 0 === a || "boolean" === c) && ((b = Bb(this)), b && n._data(this, "__className__", b), n.attr(this, "class", b || a === !1 ? "" : n._data(this, "__className__") || ""));
            });
      },
      hasClass: function (a) {
        var b,
          c,
          d = 0;
        b = " " + a + " ";
        while ((c = this[d++]))
          if (
            1 === c.nodeType &&
            (" " + Bb(c) + " ").replace(Ab, " ").indexOf(b) > -1
          )
            return !0;
        return !1;
      },
    }),
      n.each(
        "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
          " "
        ),
        function (a, b) {
          n.fn[b] = function (a, c) {
            return arguments.length > 0
              ? this.on(b, null, a, c)
              : this.trigger(b);
          };
        }
      ),
      n.fn.extend({
        hover: function (a, b) {
          return this.mouseenter(a).mouseleave(b || a);
        },
      });
    var Cb = a.location,
      Db = n.now(),
      Eb = /\?/,
      Fb =
        /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    (n.parseJSON = function (b) {
      if (a.JSON && a.JSON.parse) return a.JSON.parse(b + "");
      var c,
        d = null,
        e = n.trim(b + "");
      return e &&
        !n.trim(
          e.replace(Fb, function (a, b, e, f) {
            return (
              c && b && (d = 0),
              0 === d ? a : ((c = e || b), (d += !f - !e), "")
            );
          })
        )
        ? Function("return " + e)()
        : n.error("Invalid JSON: " + b);
    }),
      (n.parseXML = function (b) {
        var c, d;
        if (!b || "string" != typeof b) return null;
        try {
          a.DOMParser
            ? ((d = new a.DOMParser()), (c = d.parseFromString(b, "text/xml")))
            : ((c = new a.ActiveXObject("Microsoft.XMLDOM")),
              (c.async = "false"),
              c.loadXML(b));
        } catch (e) {
          c = void 0;
        }
        return (
          (c &&
            c.documentElement &&
            !c.getElementsByTagName("parsererror").length) ||
            n.error("Invalid XML: " + b),
          c
        );
      });
    var Gb = /#.*$/,
      Hb = /([?&])_=[^&]*/,
      Ib = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
      Jb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Kb = /^(?:GET|HEAD)$/,
      Lb = /^\/\//,
      Mb = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
      Nb = {},
      Ob = {},
      Pb = "*/".concat("*"),
      Qb = Cb.href,
      Rb = Mb.exec(Qb.toLowerCase()) || [];
    function Sb(a) {
      return function (b, c) {
        "string" != typeof b && ((c = b), (b = "*"));
        var d,
          e = 0,
          f = b.toLowerCase().match(G) || [];
        if (n.isFunction(c))
          while ((d = f[e++]))
            "+" === d.charAt(0)
              ? ((d = d.slice(1) || "*"), (a[d] = a[d] || []).unshift(c))
              : (a[d] = a[d] || []).push(c);
      };
    }
    function Tb(a, b, c, d) {
      var e = {},
        f = a === Ob;
      function g(h) {
        var i;
        return (
          (e[h] = !0),
          n.each(a[h] || [], function (a, h) {
            var j = h(b, c, d);
            return "string" != typeof j || f || e[j]
              ? f
                ? !(i = j)
                : void 0
              : (b.dataTypes.unshift(j), g(j), !1);
          }),
          i
        );
      }
      return g(b.dataTypes[0]) || (!e["*"] && g("*"));
    }
    function Ub(a, b) {
      var c,
        d,
        e = n.ajaxSettings.flatOptions || {};
      for (d in b) void 0 !== b[d] && ((e[d] ? a : c || (c = {}))[d] = b[d]);
      return c && n.extend(!0, a, c), a;
    }
    function Vb(a, b, c) {
      var d,
        e,
        f,
        g,
        h = a.contents,
        i = a.dataTypes;
      while ("*" === i[0])
        i.shift(),
          void 0 === e &&
            (e = a.mimeType || b.getResponseHeader("Content-Type"));
      if (e)
        for (g in h)
          if (h[g] && h[g].test(e)) {
            i.unshift(g);
            break;
          }
      if (i[0] in c) f = i[0];
      else {
        for (g in c) {
          if (!i[0] || a.converters[g + " " + i[0]]) {
            f = g;
            break;
          }
          d || (d = g);
        }
        f = f || d;
      }
      return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0;
    }
    function Wb(a, b, c, d) {
      var e,
        f,
        g,
        h,
        i,
        j = {},
        k = a.dataTypes.slice();
      if (k[1]) for (g in a.converters) j[g.toLowerCase()] = a.converters[g];
      f = k.shift();
      while (f)
        if (
          (a.responseFields[f] && (c[a.responseFields[f]] = b),
          !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)),
          (i = f),
          (f = k.shift()))
        )
          if ("*" === f) f = i;
          else if ("*" !== i && i !== f) {
            if (((g = j[i + " " + f] || j["* " + f]), !g))
              for (e in j)
                if (
                  ((h = e.split(" ")),
                  h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]]))
                ) {
                  g === !0
                    ? (g = j[e])
                    : j[e] !== !0 && ((f = h[0]), k.unshift(h[1]));
                  break;
                }
            if (g !== !0)
              if (g && a["throws"]) b = g(b);
              else
                try {
                  b = g(b);
                } catch (l) {
                  return {
                    state: "parsererror",
                    error: g ? l : "No conversion from " + i + " to " + f,
                  };
                }
          }
      return { state: "success", data: b };
    }
    n.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Qb,
        type: "GET",
        isLocal: Jb.test(Rb[1]),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": Pb,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": n.parseJSON,
          "text xml": n.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (a, b) {
        return b ? Ub(Ub(a, n.ajaxSettings), b) : Ub(n.ajaxSettings, a);
      },
      ajaxPrefilter: Sb(Nb),
      ajaxTransport: Sb(Ob),
      ajax: function (b, c) {
        "object" == typeof b && ((c = b), (b = void 0)), (c = c || {});
        var d,
          e,
          f,
          g,
          h,
          i,
          j,
          k,
          l = n.ajaxSetup({}, c),
          m = l.context || l,
          o = l.context && (m.nodeType || m.jquery) ? n(m) : n.event,
          p = n.Deferred(),
          q = n.Callbacks("once memory"),
          r = l.statusCode || {},
          s = {},
          t = {},
          u = 0,
          v = "canceled",
          w = {
            readyState: 0,
            getResponseHeader: function (a) {
              var b;
              if (2 === u) {
                if (!k) {
                  k = {};
                  while ((b = Ib.exec(g))) k[b[1].toLowerCase()] = b[2];
                }
                b = k[a.toLowerCase()];
              }
              return null == b ? null : b;
            },
            getAllResponseHeaders: function () {
              return 2 === u ? g : null;
            },
            setRequestHeader: function (a, b) {
              var c = a.toLowerCase();
              return u || ((a = t[c] = t[c] || a), (s[a] = b)), this;
            },
            overrideMimeType: function (a) {
              return u || (l.mimeType = a), this;
            },
            statusCode: function (a) {
              var b;
              if (a)
                if (2 > u) for (b in a) r[b] = [r[b], a[b]];
                else w.always(a[w.status]);
              return this;
            },
            abort: function (a) {
              var b = a || v;
              return j && j.abort(b), y(0, b), this;
            },
          };
        if (
          ((p.promise(w).complete = q.add),
          (w.success = w.done),
          (w.error = w.fail),
          (l.url = ((b || l.url || Qb) + "")
            .replace(Gb, "")
            .replace(Lb, Rb[1] + "//")),
          (l.type = c.method || c.type || l.method || l.type),
          (l.dataTypes = n
            .trim(l.dataType || "*")
            .toLowerCase()
            .match(G) || [""]),
          null == l.crossDomain &&
            ((d = Mb.exec(l.url.toLowerCase())),
            (l.crossDomain = !(
              !d ||
              (d[1] === Rb[1] &&
                d[2] === Rb[2] &&
                (d[3] || ("http:" === d[1] ? "80" : "443")) ===
                  (Rb[3] || ("http:" === Rb[1] ? "80" : "443")))
            ))),
          l.data &&
            l.processData &&
            "string" != typeof l.data &&
            (l.data = n.param(l.data, l.traditional)),
          Tb(Nb, l, c, w),
          2 === u)
        )
          return w;
        (i = n.event && l.global),
          i && 0 === n.active++ && n.event.trigger("ajaxStart"),
          (l.type = l.type.toUpperCase()),
          (l.hasContent = !Kb.test(l.type)),
          (f = l.url),
          l.hasContent ||
            (l.data &&
              ((f = l.url += (Eb.test(f) ? "&" : "?") + l.data), delete l.data),
            l.cache === !1 &&
              (l.url = Hb.test(f)
                ? f.replace(Hb, "$1_=" + Db++)
                : f + (Eb.test(f) ? "&" : "?") + "_=" + Db++)),
          l.ifModified &&
            (n.lastModified[f] &&
              w.setRequestHeader("If-Modified-Since", n.lastModified[f]),
            n.etag[f] && w.setRequestHeader("If-None-Match", n.etag[f])),
          ((l.data && l.hasContent && l.contentType !== !1) || c.contentType) &&
            w.setRequestHeader("Content-Type", l.contentType),
          w.setRequestHeader(
            "Accept",
            l.dataTypes[0] && l.accepts[l.dataTypes[0]]
              ? l.accepts[l.dataTypes[0]] +
                  ("*" !== l.dataTypes[0] ? ", " + Pb + "; q=0.01" : "")
              : l.accepts["*"]
          );
        for (e in l.headers) w.setRequestHeader(e, l.headers[e]);
        if (l.beforeSend && (l.beforeSend.call(m, w, l) === !1 || 2 === u))
          return w.abort();
        v = "abort";
        for (e in { success: 1, error: 1, complete: 1 }) w[e](l[e]);
        if ((j = Tb(Ob, l, c, w))) {
          if (((w.readyState = 1), i && o.trigger("ajaxSend", [w, l]), 2 === u))
            return w;
          l.async &&
            l.timeout > 0 &&
            (h = a.setTimeout(function () {
              w.abort("timeout");
            }, l.timeout));
          try {
            (u = 1), j.send(s, y);
          } catch (x) {
            if (!(2 > u)) throw x;
            y(-1, x);
          }
        } else y(-1, "No Transport");
        function y(b, c, d, e) {
          var k,
            s,
            t,
            v,
            x,
            y = c;
          2 !== u &&
            ((u = 2),
            h && a.clearTimeout(h),
            (j = void 0),
            (g = e || ""),
            (w.readyState = b > 0 ? 4 : 0),
            (k = (b >= 200 && 300 > b) || 304 === b),
            d && (v = Vb(l, w, d)),
            (v = Wb(l, v, w, k)),
            k
              ? (l.ifModified &&
                  ((x = w.getResponseHeader("Last-Modified")),
                  x && (n.lastModified[f] = x),
                  (x = w.getResponseHeader("etag")),
                  x && (n.etag[f] = x)),
                204 === b || "HEAD" === l.type
                  ? (y = "nocontent")
                  : 304 === b
                  ? (y = "notmodified")
                  : ((y = v.state), (s = v.data), (t = v.error), (k = !t)))
              : ((t = y), (b || !y) && ((y = "error"), 0 > b && (b = 0))),
            (w.status = b),
            (w.statusText = (c || y) + ""),
            k ? p.resolveWith(m, [s, y, w]) : p.rejectWith(m, [w, y, t]),
            w.statusCode(r),
            (r = void 0),
            i && o.trigger(k ? "ajaxSuccess" : "ajaxError", [w, l, k ? s : t]),
            q.fireWith(m, [w, y]),
            i &&
              (o.trigger("ajaxComplete", [w, l]),
              --n.active || n.event.trigger("ajaxStop")));
        }
        return w;
      },
      getJSON: function (a, b, c) {
        return n.get(a, b, c, "json");
      },
      getScript: function (a, b) {
        return n.get(a, void 0, b, "script");
      },
    }),
      n.each(["get", "post"], function (a, b) {
        n[b] = function (a, c, d, e) {
          return (
            n.isFunction(c) && ((e = e || d), (d = c), (c = void 0)),
            n.ajax(
              n.extend(
                { url: a, type: b, dataType: e, data: c, success: d },
                n.isPlainObject(a) && a
              )
            )
          );
        };
      }),
      (n._evalUrl = function (a) {
        return n.ajax({
          url: a,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          throws: !0,
        });
      }),
      n.fn.extend({
        wrapAll: function (a) {
          if (n.isFunction(a))
            return this.each(function (b) {
              n(this).wrapAll(a.call(this, b));
            });
          if (this[0]) {
            var b = n(a, this[0].ownerDocument).eq(0).clone(!0);
            this[0].parentNode && b.insertBefore(this[0]),
              b
                .map(function () {
                  var a = this;
                  while (a.firstChild && 1 === a.firstChild.nodeType)
                    a = a.firstChild;
                  return a;
                })
                .append(this);
          }
          return this;
        },
        wrapInner: function (a) {
          return n.isFunction(a)
            ? this.each(function (b) {
                n(this).wrapInner(a.call(this, b));
              })
            : this.each(function () {
                var b = n(this),
                  c = b.contents();
                c.length ? c.wrapAll(a) : b.append(a);
              });
        },
        wrap: function (a) {
          var b = n.isFunction(a);
          return this.each(function (c) {
            n(this).wrapAll(b ? a.call(this, c) : a);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              n.nodeName(this, "body") || n(this).replaceWith(this.childNodes);
            })
            .end();
        },
      });
    function Xb(a) {
      return (a.style && a.style.display) || n.css(a, "display");
    }
    function Yb(a) {
      while (a && 1 === a.nodeType) {
        if ("none" === Xb(a) || "hidden" === a.type) return !0;
        a = a.parentNode;
      }
      return !1;
    }
    (n.expr.filters.hidden = function (a) {
      return l.reliableHiddenOffsets()
        ? a.offsetWidth <= 0 &&
            a.offsetHeight <= 0 &&
            !a.getClientRects().length
        : Yb(a);
    }),
      (n.expr.filters.visible = function (a) {
        return !n.expr.filters.hidden(a);
      });
    var Zb = /%20/g,
      $b = /\[\]$/,
      _b = /\r?\n/g,
      ac = /^(?:submit|button|image|reset|file)$/i,
      bc = /^(?:input|select|textarea|keygen)/i;
    function cc(a, b, c, d) {
      var e;
      if (n.isArray(b))
        n.each(b, function (b, e) {
          c || $b.test(a)
            ? d(a, e)
            : cc(
                a + "[" + ("object" == typeof e && null != e ? b : "") + "]",
                e,
                c,
                d
              );
        });
      else if (c || "object" !== n.type(b)) d(a, b);
      else for (e in b) cc(a + "[" + e + "]", b[e], c, d);
    }
    (n.param = function (a, b) {
      var c,
        d = [],
        e = function (a, b) {
          (b = n.isFunction(b) ? b() : null == b ? "" : b),
            (d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b));
        };
      if (
        (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional),
        n.isArray(a) || (a.jquery && !n.isPlainObject(a)))
      )
        n.each(a, function () {
          e(this.name, this.value);
        });
      else for (c in a) cc(c, a[c], b, e);
      return d.join("&").replace(Zb, "+");
    }),
      n.fn.extend({
        serialize: function () {
          return n.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var a = n.prop(this, "elements");
            return a ? n.makeArray(a) : this;
          })
            .filter(function () {
              var a = this.type;
              return (
                this.name &&
                !n(this).is(":disabled") &&
                bc.test(this.nodeName) &&
                !ac.test(a) &&
                (this.checked || !Z.test(a))
              );
            })
            .map(function (a, b) {
              var c = n(this).val();
              return null == c
                ? null
                : n.isArray(c)
                ? n.map(c, function (a) {
                    return { name: b.name, value: a.replace(_b, "\r\n") };
                  })
                : { name: b.name, value: c.replace(_b, "\r\n") };
            })
            .get();
        },
      }),
      (n.ajaxSettings.xhr =
        void 0 !== a.ActiveXObject
          ? function () {
              return this.isLocal
                ? hc()
                : d.documentMode > 8
                ? gc()
                : (/^(get|post|head|put|delete|options)$/i.test(this.type) &&
                    gc()) ||
                  hc();
            }
          : gc);
    var dc = 0,
      ec = {},
      fc = n.ajaxSettings.xhr();
    a.attachEvent &&
      a.attachEvent("onunload", function () {
        for (var a in ec) ec[a](void 0, !0);
      }),
      (l.cors = !!fc && "withCredentials" in fc),
      (fc = l.ajax = !!fc),
      fc &&
        n.ajaxTransport(function (b) {
          if (!b.crossDomain || l.cors) {
            var c;
            return {
              send: function (d, e) {
                var f,
                  g = b.xhr(),
                  h = ++dc;
                if (
                  (g.open(b.type, b.url, b.async, b.username, b.password),
                  b.xhrFields)
                )
                  for (f in b.xhrFields) g[f] = b.xhrFields[f];
                b.mimeType &&
                  g.overrideMimeType &&
                  g.overrideMimeType(b.mimeType),
                  b.crossDomain ||
                    d["X-Requested-With"] ||
                    (d["X-Requested-With"] = "XMLHttpRequest");
                for (f in d)
                  void 0 !== d[f] && g.setRequestHeader(f, d[f] + "");
                g.send((b.hasContent && b.data) || null),
                  (c = function (a, d) {
                    var f, i, j;
                    if (c && (d || 4 === g.readyState))
                      if (
                        (delete ec[h],
                        (c = void 0),
                        (g.onreadystatechange = n.noop),
                        d)
                      )
                        4 !== g.readyState && g.abort();
                      else {
                        (j = {}),
                          (f = g.status),
                          "string" == typeof g.responseText &&
                            (j.text = g.responseText);
                        try {
                          i = g.statusText;
                        } catch (k) {
                          i = "";
                        }
                        f || !b.isLocal || b.crossDomain
                          ? 1223 === f && (f = 204)
                          : (f = j.text ? 200 : 404);
                      }
                    j && e(f, i, j, g.getAllResponseHeaders());
                  }),
                  b.async
                    ? 4 === g.readyState
                      ? a.setTimeout(c)
                      : (g.onreadystatechange = ec[h] = c)
                    : c();
              },
              abort: function () {
                c && c(void 0, !0);
              },
            };
          }
        });
    function gc() {
      try {
        return new a.XMLHttpRequest();
      } catch (b) {}
    }
    function hc() {
      try {
        return new a.ActiveXObject("Microsoft.XMLHTTP");
      } catch (b) {}
    }
    n.ajaxPrefilter(function (a) {
      a.crossDomain && (a.contents.script = !1);
    }),
      n.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (a) {
            return n.globalEval(a), a;
          },
        },
      }),
      n.ajaxPrefilter("script", function (a) {
        void 0 === a.cache && (a.cache = !1),
          a.crossDomain && ((a.type = "GET"), (a.global = !1));
      }),
      n.ajaxTransport("script", function (a) {
        if (a.crossDomain) {
          var b,
            c = d.head || n("head")[0] || d.documentElement;
          return {
            send: function (e, f) {
              (b = d.createElement("script")),
                (b.async = !0),
                a.scriptCharset && (b.charset = a.scriptCharset),
                (b.src = a.url),
                (b.onload = b.onreadystatechange =
                  function (a, c) {
                    (c ||
                      !b.readyState ||
                      /loaded|complete/.test(b.readyState)) &&
                      ((b.onload = b.onreadystatechange = null),
                      b.parentNode && b.parentNode.removeChild(b),
                      (b = null),
                      c || f(200, "success"));
                  }),
                c.insertBefore(b, c.firstChild);
            },
            abort: function () {
              b && b.onload(void 0, !0);
            },
          };
        }
      });
    var ic = [],
      jc = /(=)\?(?=&|$)|\?\?/;
    n.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var a = ic.pop() || n.expando + "_" + Db++;
        return (this[a] = !0), a;
      },
    }),
      n.ajaxPrefilter("json jsonp", function (b, c, d) {
        var e,
          f,
          g,
          h =
            b.jsonp !== !1 &&
            (jc.test(b.url)
              ? "url"
              : "string" == typeof b.data &&
                0 ===
                  (b.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                jc.test(b.data) &&
                "data");
        return h || "jsonp" === b.dataTypes[0]
          ? ((e = b.jsonpCallback =
              n.isFunction(b.jsonpCallback)
                ? b.jsonpCallback()
                : b.jsonpCallback),
            h
              ? (b[h] = b[h].replace(jc, "$1" + e))
              : b.jsonp !== !1 &&
                (b.url += (Eb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e),
            (b.converters["script json"] = function () {
              return g || n.error(e + " was not called"), g[0];
            }),
            (b.dataTypes[0] = "json"),
            (f = a[e]),
            (a[e] = function () {
              g = arguments;
            }),
            d.always(function () {
              void 0 === f ? n(a).removeProp(e) : (a[e] = f),
                b[e] && ((b.jsonpCallback = c.jsonpCallback), ic.push(e)),
                g && n.isFunction(f) && f(g[0]),
                (g = f = void 0);
            }),
            "script")
          : void 0;
      }),
      (l.createHTMLDocument = (function () {
        if (!d.implementation.createHTMLDocument) return !1;
        var a = d.implementation.createHTMLDocument("");
        return (
          (a.body.innerHTML = "<form></form><form></form>"),
          2 === a.body.childNodes.length
        );
      })()),
      (n.parseHTML = function (a, b, c) {
        if (!a || "string" != typeof a) return null;
        "boolean" == typeof b && ((c = b), (b = !1)),
          (b =
            b ||
            (l.createHTMLDocument
              ? d.implementation.createHTMLDocument("")
              : d));
        var e = x.exec(a),
          f = !c && [];
        return e
          ? [b.createElement(e[1])]
          : ((e = ja([a], b, f)),
            f && f.length && n(f).remove(),
            n.merge([], e.childNodes));
      });
    var kc = n.fn.load;
    (n.fn.load = function (a, b, c) {
      if ("string" != typeof a && kc) return kc.apply(this, arguments);
      var d,
        e,
        f,
        g = this,
        h = a.indexOf(" ");
      return (
        h > -1 && ((d = n.trim(a.slice(h, a.length))), (a = a.slice(0, h))),
        n.isFunction(b)
          ? ((c = b), (b = void 0))
          : b && "object" == typeof b && (e = "POST"),
        g.length > 0 &&
          n
            .ajax({ url: a, type: e || "GET", dataType: "html", data: b })
            .done(function (a) {
              (f = arguments),
                g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a);
            })
            .always(
              c &&
                function (a, b) {
                  g.each(function () {
                    c.apply(g, f || [a.responseText, b, a]);
                  });
                }
            ),
        this
      );
    }),
      n.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (a, b) {
          n.fn[b] = function (a) {
            return this.on(b, a);
          };
        }
      ),
      (n.expr.filters.animated = function (a) {
        return n.grep(n.timers, function (b) {
          return a === b.elem;
        }).length;
      });
    function lc(a) {
      return n.isWindow(a)
        ? a
        : 9 === a.nodeType
        ? a.defaultView || a.parentWindow
        : !1;
    }
    (n.offset = {
      setOffset: function (a, b, c) {
        var d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = n.css(a, "position"),
          l = n(a),
          m = {};
        "static" === k && (a.style.position = "relative"),
          (h = l.offset()),
          (f = n.css(a, "top")),
          (i = n.css(a, "left")),
          (j =
            ("absolute" === k || "fixed" === k) &&
            n.inArray("auto", [f, i]) > -1),
          j
            ? ((d = l.position()), (g = d.top), (e = d.left))
            : ((g = parseFloat(f) || 0), (e = parseFloat(i) || 0)),
          n.isFunction(b) && (b = b.call(a, c, n.extend({}, h))),
          null != b.top && (m.top = b.top - h.top + g),
          null != b.left && (m.left = b.left - h.left + e),
          "using" in b ? b.using.call(a, m) : l.css(m);
      },
    }),
      n.fn.extend({
        offset: function (a) {
          if (arguments.length)
            return void 0 === a
              ? this
              : this.each(function (b) {
                  n.offset.setOffset(this, a, b);
                });
          var b,
            c,
            d = { top: 0, left: 0 },
            e = this[0],
            f = e && e.ownerDocument;
          if (f)
            return (
              (b = f.documentElement),
              n.contains(b, e)
                ? ("undefined" != typeof e.getBoundingClientRect &&
                    (d = e.getBoundingClientRect()),
                  (c = lc(f)),
                  {
                    top:
                      d.top +
                      (c.pageYOffset || b.scrollTop) -
                      (b.clientTop || 0),
                    left:
                      d.left +
                      (c.pageXOffset || b.scrollLeft) -
                      (b.clientLeft || 0),
                  })
                : d
            );
        },
        position: function () {
          if (this[0]) {
            var a,
              b,
              c = { top: 0, left: 0 },
              d = this[0];
            return (
              "fixed" === n.css(d, "position")
                ? (b = d.getBoundingClientRect())
                : ((a = this.offsetParent()),
                  (b = this.offset()),
                  n.nodeName(a[0], "html") || (c = a.offset()),
                  (c.top += n.css(a[0], "borderTopWidth", !0) - a.scrollTop()),
                  (c.left +=
                    n.css(a[0], "borderLeftWidth", !0) - a.scrollLeft())),
              {
                top: b.top - c.top - n.css(d, "marginTop", !0),
                left: b.left - c.left - n.css(d, "marginLeft", !0),
              }
            );
          }
        },
        offsetParent: function () {
          return this.map(function () {
            var a = this.offsetParent;
            while (
              a &&
              !n.nodeName(a, "html") &&
              "static" === n.css(a, "position")
            )
              a = a.offsetParent;
            return a || Qa;
          });
        },
      }),
      n.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (a, b) {
          var c = /Y/.test(b);
          n.fn[a] = function (d) {
            return Y(
              this,
              function (a, d, e) {
                var f = lc(a);
                return void 0 === e
                  ? f
                    ? b in f
                      ? f[b]
                      : f.document.documentElement[d]
                    : a[d]
                  : void (f
                      ? f.scrollTo(
                          c ? n(f).scrollLeft() : e,
                          c ? e : n(f).scrollTop()
                        )
                      : (a[d] = e));
              },
              a,
              d,
              arguments.length,
              null
            );
          };
        }
      ),
      n.each(["top", "left"], function (a, b) {
        n.cssHooks[b] = Ua(l.pixelPosition, function (a, c) {
          return c
            ? ((c = Sa(a, b)), Oa.test(c) ? n(a).position()[b] + "px" : c)
            : void 0;
        });
      }),
      n.each({ Height: "height", Width: "width" }, function (a, b) {
        n.each(
          { padding: "inner" + a, content: b, "": "outer" + a },
          function (c, d) {
            n.fn[d] = function (d, e) {
              var f = arguments.length && (c || "boolean" != typeof d),
                g = c || (d === !0 || e === !0 ? "margin" : "border");
              return Y(
                this,
                function (b, c, d) {
                  var e;
                  return n.isWindow(b)
                    ? b.document.documentElement["client" + a]
                    : 9 === b.nodeType
                    ? ((e = b.documentElement),
                      Math.max(
                        b.body["scroll" + a],
                        e["scroll" + a],
                        b.body["offset" + a],
                        e["offset" + a],
                        e["client" + a]
                      ))
                    : void 0 === d
                    ? n.css(b, c, g)
                    : n.style(b, c, d, g);
                },
                b,
                f ? d : void 0,
                f,
                null
              );
            };
          }
        );
      }),
      n.fn.extend({
        bind: function (a, b, c) {
          return this.on(a, null, b, c);
        },
        unbind: function (a, b) {
          return this.off(a, null, b);
        },
        delegate: function (a, b, c, d) {
          return this.on(b, a, c, d);
        },
        undelegate: function (a, b, c) {
          return 1 === arguments.length
            ? this.off(a, "**")
            : this.off(b, a || "**", c);
        },
      }),
      (n.fn.size = function () {
        return this.length;
      }),
      (n.fn.andSelf = n.fn.addBack),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return n;
        });
    var mc = a.jQuery,
      nc = a.$;
    return (
      (n.noConflict = function (b) {
        return (
          a.$ === n && (a.$ = nc), b && a.jQuery === n && (a.jQuery = mc), n
        );
      }),
      b || (a.jQuery = a.$ = n),
      n
    );
  });
  /*! jQuery Migrate v1.4.1 */
  "undefined" == typeof jQuery.migrateMute && (jQuery.migrateMute = !0),
    (function (a, b, c) {
      function d(c) {
        var d = b.console;
        f[c] ||
          ((f[c] = !0),
          a.migrateWarnings.push(c),
          d &&
            d.warn &&
            !a.migrateMute &&
            (d.warn("JQMIGRATE: " + c),
            a.migrateTrace && d.trace && d.trace()));
      }
      function e(b, c, e, f) {
        if (Object.defineProperty)
          try {
            return void Object.defineProperty(b, c, {
              configurable: !0,
              enumerable: !0,
              get: function () {
                return d(f), e;
              },
              set: function (a) {
                d(f), (e = a);
              },
            });
          } catch (g) {}
        (a._definePropertyBroken = !0), (b[c] = e);
      }
      a.migrateVersion = "1.4.1";
      var f = {};
      (a.migrateWarnings = []),
        b.console &&
          b.console.log &&
          b.console.log(
            "JQMIGRATE: Migrate is installed" +
              (a.migrateMute ? "" : " with logging active") +
              ", version " +
              a.migrateVersion
          ),
        a.migrateTrace === c && (a.migrateTrace = !0),
        (a.migrateReset = function () {
          (f = {}), (a.migrateWarnings.length = 0);
        }),
        "BackCompat" === document.compatMode &&
          d("jQuery is not compatible with Quirks Mode");
      var g = a("<input/>", { size: 1 }).attr("size") && a.attrFn,
        h = a.attr,
        i =
          (a.attrHooks.value && a.attrHooks.value.get) ||
          function () {
            return null;
          },
        j =
          (a.attrHooks.value && a.attrHooks.value.set) ||
          function () {
            return c;
          },
        k = /^(?:input|button)$/i,
        l = /^[238]$/,
        m =
          /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
        n = /^(?:checked|selected)$/i;
      e(a, "attrFn", g || {}, "jQuery.attrFn is deprecated"),
        (a.attr = function (b, e, f, i) {
          var j = e.toLowerCase(),
            o = b && b.nodeType;
          return i &&
            (h.length < 4 && d("jQuery.fn.attr( props, pass ) is deprecated"),
            b && !l.test(o) && (g ? e in g : a.isFunction(a.fn[e])))
            ? a(b)[e](f)
            : ("type" === e &&
                f !== c &&
                k.test(b.nodeName) &&
                b.parentNode &&
                d("Can't change the 'type' of an input or button in IE 6/7/8"),
              !a.attrHooks[j] &&
                m.test(j) &&
                ((a.attrHooks[j] = {
                  get: function (b, d) {
                    var e,
                      f = a.prop(b, d);
                    return f === !0 ||
                      ("boolean" != typeof f &&
                        (e = b.getAttributeNode(d)) &&
                        e.nodeValue !== !1)
                      ? d.toLowerCase()
                      : c;
                  },
                  set: function (b, c, d) {
                    var e;
                    return (
                      c === !1
                        ? a.removeAttr(b, d)
                        : ((e = a.propFix[d] || d),
                          e in b && (b[e] = !0),
                          b.setAttribute(d, d.toLowerCase())),
                      d
                    );
                  },
                }),
                n.test(j) &&
                  d(
                    "jQuery.fn.attr('" +
                      j +
                      "') might use property instead of attribute"
                  )),
              h.call(a, b, e, f));
        }),
        (a.attrHooks.value = {
          get: function (a, b) {
            var c = (a.nodeName || "").toLowerCase();
            return "button" === c
              ? i.apply(this, arguments)
              : ("input" !== c &&
                  "option" !== c &&
                  d("jQuery.fn.attr('value') no longer gets properties"),
                b in a ? a.value : null);
          },
          set: function (a, b) {
            var c = (a.nodeName || "").toLowerCase();
            return "button" === c
              ? j.apply(this, arguments)
              : ("input" !== c &&
                  "option" !== c &&
                  d("jQuery.fn.attr('value', val) no longer sets properties"),
                void (a.value = b));
          },
        });
      var o,
        p,
        q = a.fn.init,
        r = a.find,
        s = a.parseJSON,
        t = /^\s*</,
        u = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/,
        v = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g,
        w = /^([^<]*)(<[\w\W]+>)([^>]*)$/;
      (a.fn.init = function (b, e, f) {
        var g, h;
        return b &&
          "string" == typeof b &&
          !a.isPlainObject(e) &&
          (g = w.exec(a.trim(b))) &&
          g[0] &&
          (t.test(b) || d("$(html) HTML strings must start with '<' character"),
          g[3] && d("$(html) HTML text after last tag is ignored"),
          "#" === g[0].charAt(0) &&
            (d("HTML string cannot start with a '#' character"),
            a.error("JQMIGRATE: Invalid selector string (XSS)")),
          e && e.context && e.context.nodeType && (e = e.context),
          a.parseHTML)
          ? q.call(
              this,
              a.parseHTML(g[2], (e && e.ownerDocument) || e || document, !0),
              e,
              f
            )
          : ((h = q.apply(this, arguments)),
            b && b.selector !== c
              ? ((h.selector = b.selector), (h.context = b.context))
              : ((h.selector = "string" == typeof b ? b : ""),
                b && (h.context = b.nodeType ? b : e || document)),
            h);
      }),
        (a.fn.init.prototype = a.fn),
        (a.find = function (a) {
          var b = Array.prototype.slice.call(arguments);
          if ("string" == typeof a && u.test(a))
            try {
              document.querySelector(a);
            } catch (c) {
              a = a.replace(v, function (a, b, c, d) {
                return "[" + b + c + '"' + d + '"]';
              });
              try {
                document.querySelector(a),
                  d("Attribute selector with '#' must be quoted: " + b[0]),
                  (b[0] = a);
              } catch (e) {
                d("Attribute selector with '#' was not fixed: " + b[0]);
              }
            }
          return r.apply(this, b);
        });
      var x;
      for (x in r)
        Object.prototype.hasOwnProperty.call(r, x) && (a.find[x] = r[x]);
      (a.parseJSON = function (a) {
        return a
          ? s.apply(this, arguments)
          : (d("jQuery.parseJSON requires a valid JSON string"), null);
      }),
        (a.uaMatch = function (a) {
          a = a.toLowerCase();
          var b =
            /(chrome)[ \/]([\w.]+)/.exec(a) ||
            /(webkit)[ \/]([\w.]+)/.exec(a) ||
            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a) ||
            /(msie) ([\w.]+)/.exec(a) ||
            (a.indexOf("compatible") < 0 &&
              /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a)) ||
            [];
          return { browser: b[1] || "", version: b[2] || "0" };
        }),
        a.browser ||
          ((o = a.uaMatch(navigator.userAgent)),
          (p = {}),
          o.browser && ((p[o.browser] = !0), (p.version = o.version)),
          p.chrome ? (p.webkit = !0) : p.webkit && (p.safari = !0),
          (a.browser = p)),
        e(a, "browser", a.browser, "jQuery.browser is deprecated"),
        (a.boxModel = a.support.boxModel =
          "CSS1Compat" === document.compatMode),
        e(a, "boxModel", a.boxModel, "jQuery.boxModel is deprecated"),
        e(
          a.support,
          "boxModel",
          a.support.boxModel,
          "jQuery.support.boxModel is deprecated"
        ),
        (a.sub = function () {
          function b(a, c) {
            return new b.fn.init(a, c);
          }
          a.extend(!0, b, this),
            (b.superclass = this),
            (b.fn = b.prototype = this()),
            (b.fn.constructor = b),
            (b.sub = this.sub),
            (b.fn.init = function (d, e) {
              var f = a.fn.init.call(this, d, e, c);
              return f instanceof b ? f : b(f);
            }),
            (b.fn.init.prototype = b.fn);
          var c = b(document);
          return d("jQuery.sub() is deprecated"), b;
        }),
        (a.fn.size = function () {
          return (
            d("jQuery.fn.size() is deprecated; use the .length property"),
            this.length
          );
        });
      var y = !1;
      a.swap &&
        a.each(["height", "width", "reliableMarginRight"], function (b, c) {
          var d = a.cssHooks[c] && a.cssHooks[c].get;
          d &&
            (a.cssHooks[c].get = function () {
              var a;
              return (y = !0), (a = d.apply(this, arguments)), (y = !1), a;
            });
        }),
        (a.swap = function (a, b, c, e) {
          var f,
            g,
            h = {};
          y || d("jQuery.swap() is undocumented and deprecated");
          for (g in b) (h[g] = a.style[g]), (a.style[g] = b[g]);
          f = c.apply(a, e || []);
          for (g in b) a.style[g] = h[g];
          return f;
        }),
        a.ajaxSetup({ converters: { "text json": a.parseJSON } });
      var z = a.fn.data;
      a.fn.data = function (b) {
        var e,
          f,
          g = this[0];
        return !g ||
          "events" !== b ||
          1 !== arguments.length ||
          ((e = a.data(g, b)),
          (f = a._data(g, b)),
          (e !== c && e !== f) || f === c)
          ? z.apply(this, arguments)
          : (d("Use of jQuery.fn.data('events') is deprecated"), f);
      };
      var A = /\/(java|ecma)script/i;
      a.clean ||
        (a.clean = function (b, c, e, f) {
          (c = c || document),
            (c = (!c.nodeType && c[0]) || c),
            (c = c.ownerDocument || c),
            d("jQuery.clean() is deprecated");
          var g,
            h,
            i,
            j,
            k = [];
          if ((a.merge(k, a.buildFragment(b, c).childNodes), e))
            for (
              i = function (a) {
                return !a.type || A.test(a.type)
                  ? f
                    ? f.push(a.parentNode ? a.parentNode.removeChild(a) : a)
                    : e.appendChild(a)
                  : void 0;
              },
                g = 0;
              null != (h = k[g]);
              g++
            )
              (a.nodeName(h, "script") && i(h)) ||
                (e.appendChild(h),
                "undefined" != typeof h.getElementsByTagName &&
                  ((j = a.grep(
                    a.merge([], h.getElementsByTagName("script")),
                    i
                  )),
                  k.splice.apply(k, [g + 1, 0].concat(j)),
                  (g += j.length)));
          return k;
        });
      var B = a.event.add,
        C = a.event.remove,
        D = a.event.trigger,
        E = a.fn.toggle,
        F = a.fn.live,
        G = a.fn.die,
        H = a.fn.load,
        I = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess",
        J = new RegExp("\\b(?:" + I + ")\\b"),
        K = /(?:^|\s)hover(\.\S+|)\b/,
        L = function (b) {
          return "string" != typeof b || a.event.special.hover
            ? b
            : (K.test(b) &&
                d(
                  "'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'"
                ),
              b && b.replace(K, "mouseenter$1 mouseleave$1"));
        };
      a.event.props &&
        "attrChange" !== a.event.props[0] &&
        a.event.props.unshift(
          "attrChange",
          "attrName",
          "relatedNode",
          "srcElement"
        ),
        a.event.dispatch &&
          e(
            a.event,
            "handle",
            a.event.dispatch,
            "jQuery.event.handle is undocumented and deprecated"
          ),
        (a.event.add = function (a, b, c, e, f) {
          a !== document &&
            J.test(b) &&
            d("AJAX events should be attached to document: " + b),
            B.call(this, a, L(b || ""), c, e, f);
        }),
        (a.event.remove = function (a, b, c, d, e) {
          C.call(this, a, L(b) || "", c, d, e);
        }),
        a.each(["load", "unload", "error"], function (b, c) {
          a.fn[c] = function () {
            var a = Array.prototype.slice.call(arguments, 0);
            return "load" === c && "string" == typeof a[0]
              ? H.apply(this, a)
              : (d("jQuery.fn." + c + "() is deprecated"),
                a.splice(0, 0, c),
                arguments.length
                  ? this.bind.apply(this, a)
                  : (this.triggerHandler.apply(this, a), this));
          };
        }),
        (a.fn.toggle = function (b, c) {
          if (!a.isFunction(b) || !a.isFunction(c))
            return E.apply(this, arguments);
          d("jQuery.fn.toggle(handler, handler...) is deprecated");
          var e = arguments,
            f = b.guid || a.guid++,
            g = 0,
            h = function (c) {
              var d = (a._data(this, "lastToggle" + b.guid) || 0) % g;
              return (
                a._data(this, "lastToggle" + b.guid, d + 1),
                c.preventDefault(),
                e[d].apply(this, arguments) || !1
              );
            };
          for (h.guid = f; g < e.length; ) e[g++].guid = f;
          return this.click(h);
        }),
        (a.fn.live = function (b, c, e) {
          return (
            d("jQuery.fn.live() is deprecated"),
            F
              ? F.apply(this, arguments)
              : (a(this.context).on(b, this.selector, c, e), this)
          );
        }),
        (a.fn.die = function (b, c) {
          return (
            d("jQuery.fn.die() is deprecated"),
            G
              ? G.apply(this, arguments)
              : (a(this.context).off(b, this.selector || "**", c), this)
          );
        }),
        (a.event.trigger = function (a, b, c, e) {
          return (
            c ||
              J.test(a) ||
              d("Global events are undocumented and deprecated"),
            D.call(this, a, b, c || document, e)
          );
        }),
        a.each(I.split("|"), function (b, c) {
          a.event.special[c] = {
            setup: function () {
              var b = this;
              return (
                b !== document &&
                  (a.event.add(document, c + "." + a.guid, function () {
                    a.event.trigger(
                      c,
                      Array.prototype.slice.call(arguments, 1),
                      b,
                      !0
                    );
                  }),
                  a._data(this, c, a.guid++)),
                !1
              );
            },
            teardown: function () {
              return (
                this !== document &&
                  a.event.remove(document, c + "." + a._data(this, c)),
                !1
              );
            },
          };
        }),
        (a.event.special.ready = {
          setup: function () {
            this === document && d("'ready' event is deprecated");
          },
        });
      var M = a.fn.andSelf || a.fn.addBack,
        N = a.fn.find;
      if (
        ((a.fn.andSelf = function () {
          return (
            d("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()"),
            M.apply(this, arguments)
          );
        }),
        (a.fn.find = function (a) {
          var b = N.apply(this, arguments);
          return (
            (b.context = this.context),
            (b.selector = this.selector ? this.selector + " " + a : a),
            b
          );
        }),
        a.Callbacks)
      ) {
        var O = a.Deferred,
          P = [
            [
              "resolve",
              "done",
              a.Callbacks("once memory"),
              a.Callbacks("once memory"),
              "resolved",
            ],
            [
              "reject",
              "fail",
              a.Callbacks("once memory"),
              a.Callbacks("once memory"),
              "rejected",
            ],
            [
              "notify",
              "progress",
              a.Callbacks("memory"),
              a.Callbacks("memory"),
            ],
          ];
        a.Deferred = function (b) {
          var c = O(),
            e = c.promise();
          return (
            (c.pipe = e.pipe =
              function () {
                var b = arguments;
                return (
                  d("deferred.pipe() is deprecated"),
                  a
                    .Deferred(function (d) {
                      a.each(P, function (f, g) {
                        var h = a.isFunction(b[f]) && b[f];
                        c[g[1]](function () {
                          var b = h && h.apply(this, arguments);
                          b && a.isFunction(b.promise)
                            ? b
                                .promise()
                                .done(d.resolve)
                                .fail(d.reject)
                                .progress(d.notify)
                            : d[g[0] + "With"](
                                this === e ? d.promise() : this,
                                h ? [b] : arguments
                              );
                        });
                      }),
                        (b = null);
                    })
                    .promise()
                );
              }),
            (c.isResolved = function () {
              return (
                d("deferred.isResolved is deprecated"), "resolved" === c.state()
              );
            }),
            (c.isRejected = function () {
              return (
                d("deferred.isRejected is deprecated"), "rejected" === c.state()
              );
            }),
            b && b.call(c, c),
            c
          );
        };
      }
    })(jQuery, window);
}

/*!
 * typeahead.js 0.11.1
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
 */
!(function (a, b) {
  "function" == typeof define && define.amd
    ? define("bloodhound", ["jquery"], function (c) {
        return (a.Bloodhound = b(c));
      })
    : "object" == typeof exports
    ? (module.exports = b(require("jquery")))
    : (a.Bloodhound = b(jQuery));
})(this, function (a) {
  var b = (function () {
      "use strict";
      return {
        isMsie: function () {
          return /(msie|trident)/i.test(navigator.userAgent)
            ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2]
            : !1;
        },
        isBlankString: function (a) {
          return !a || /^\s*$/.test(a);
        },
        escapeRegExChars: function (a) {
          return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        },
        isString: function (a) {
          return "string" == typeof a;
        },
        isNumber: function (a) {
          return "number" == typeof a;
        },
        isArray: a.isArray,
        isFunction: a.isFunction,
        isObject: a.isPlainObject,
        isUndefined: function (a) {
          return "undefined" == typeof a;
        },
        isElement: function (a) {
          return !(!a || 1 !== a.nodeType);
        },
        isJQuery: function (b) {
          return b instanceof a;
        },
        toStr: function (a) {
          return b.isUndefined(a) || null === a ? "" : a + "";
        },
        bind: a.proxy,
        each: function (b, c) {
          function d(a, b) {
            return c(b, a);
          }
          a.each(b, d);
        },
        map: a.map,
        filter: a.grep,
        every: function (b, c) {
          var d = !0;
          return b
            ? (a.each(b, function (a, e) {
                return (d = c.call(null, e, a, b)) ? void 0 : !1;
              }),
              !!d)
            : d;
        },
        some: function (b, c) {
          var d = !1;
          return b
            ? (a.each(b, function (a, e) {
                return (d = c.call(null, e, a, b)) ? !1 : void 0;
              }),
              !!d)
            : d;
        },
        mixin: a.extend,
        identity: function (a) {
          return a;
        },
        clone: function (b) {
          return a.extend(!0, {}, b);
        },
        getIdGenerator: function () {
          var a = 0;
          return function () {
            return a++;
          };
        },
        templatify: function (b) {
          function c() {
            return String(b);
          }
          return a.isFunction(b) ? b : c;
        },
        defer: function (a) {
          setTimeout(a, 0);
        },
        debounce: function (a, b, c) {
          var d, e;
          return function () {
            var f,
              g,
              h = this,
              i = arguments;
            return (
              (f = function () {
                (d = null), c || (e = a.apply(h, i));
              }),
              (g = c && !d),
              clearTimeout(d),
              (d = setTimeout(f, b)),
              g && (e = a.apply(h, i)),
              e
            );
          };
        },
        throttle: function (a, b) {
          var c, d, e, f, g, h;
          return (
            (g = 0),
            (h = function () {
              (g = new Date()), (e = null), (f = a.apply(c, d));
            }),
            function () {
              var i = new Date(),
                j = b - (i - g);
              return (
                (c = this),
                (d = arguments),
                0 >= j
                  ? (clearTimeout(e), (e = null), (g = i), (f = a.apply(c, d)))
                  : e || (e = setTimeout(h, j)),
                f
              );
            }
          );
        },
        stringify: function (a) {
          return b.isString(a) ? a : JSON.stringify(a);
        },
        noop: function () {},
      };
    })(),
    c = "0.11.1",
    d = (function () {
      "use strict";
      function a(a) {
        return (a = b.toStr(a)), a ? a.split(/\s+/) : [];
      }
      function c(a) {
        return (a = b.toStr(a)), a ? a.split(/\W+/) : [];
      }
      function d(a) {
        return function (c) {
          return (
            (c = b.isArray(c) ? c : [].slice.call(arguments, 0)),
            function (d) {
              var e = [];
              return (
                b.each(c, function (c) {
                  e = e.concat(a(b.toStr(d[c])));
                }),
                e
              );
            }
          );
        };
      }
      return {
        nonword: c,
        whitespace: a,
        obj: { nonword: d(c), whitespace: d(a) },
      };
    })(),
    e = (function () {
      "use strict";
      function c(c) {
        (this.maxSize = b.isNumber(c) ? c : 100),
          this.reset(),
          this.maxSize <= 0 && (this.set = this.get = a.noop);
      }
      function d() {
        this.head = this.tail = null;
      }
      function e(a, b) {
        (this.key = a), (this.val = b), (this.prev = this.next = null);
      }
      return (
        b.mixin(c.prototype, {
          set: function (a, b) {
            var c,
              d = this.list.tail;
            this.size >= this.maxSize &&
              (this.list.remove(d), delete this.hash[d.key], this.size--),
              (c = this.hash[a])
                ? ((c.val = b), this.list.moveToFront(c))
                : ((c = new e(a, b)),
                  this.list.add(c),
                  (this.hash[a] = c),
                  this.size++);
          },
          get: function (a) {
            var b = this.hash[a];
            return b ? (this.list.moveToFront(b), b.val) : void 0;
          },
          reset: function () {
            (this.size = 0), (this.hash = {}), (this.list = new d());
          },
        }),
        b.mixin(d.prototype, {
          add: function (a) {
            this.head && ((a.next = this.head), (this.head.prev = a)),
              (this.head = a),
              (this.tail = this.tail || a);
          },
          remove: function (a) {
            a.prev ? (a.prev.next = a.next) : (this.head = a.next),
              a.next ? (a.next.prev = a.prev) : (this.tail = a.prev);
          },
          moveToFront: function (a) {
            this.remove(a), this.add(a);
          },
        }),
        c
      );
    })(),
    f = (function () {
      "use strict";
      function c(a, c) {
        (this.prefix = ["__", a, "__"].join("")),
          (this.ttlKey = "__ttl__"),
          (this.keyMatcher = new RegExp("^" + b.escapeRegExChars(this.prefix))),
          (this.ls = c || h),
          !this.ls && this._noop();
      }
      function d() {
        return new Date().getTime();
      }
      function e(a) {
        return JSON.stringify(b.isUndefined(a) ? null : a);
      }
      function f(b) {
        return a.parseJSON(b);
      }
      function g(a) {
        var b,
          c,
          d = [],
          e = h.length;
        for (b = 0; e > b; b++)
          (c = h.key(b)).match(a) && d.push(c.replace(a, ""));
        return d;
      }
      var h;
      try {
        (h = window.localStorage), h.setItem("~~~", "!"), h.removeItem("~~~");
      } catch (i) {
        h = null;
      }
      return (
        b.mixin(c.prototype, {
          _prefix: function (a) {
            return this.prefix + a;
          },
          _ttlKey: function (a) {
            return this._prefix(a) + this.ttlKey;
          },
          _noop: function () {
            this.get =
              this.set =
              this.remove =
              this.clear =
              this.isExpired =
                b.noop;
          },
          _safeSet: function (a, b) {
            try {
              this.ls.setItem(a, b);
            } catch (c) {
              "QuotaExceededError" === c.name && (this.clear(), this._noop());
            }
          },
          get: function (a) {
            return (
              this.isExpired(a) && this.remove(a),
              f(this.ls.getItem(this._prefix(a)))
            );
          },
          set: function (a, c, f) {
            return (
              b.isNumber(f)
                ? this._safeSet(this._ttlKey(a), e(d() + f))
                : this.ls.removeItem(this._ttlKey(a)),
              this._safeSet(this._prefix(a), e(c))
            );
          },
          remove: function (a) {
            return (
              this.ls.removeItem(this._ttlKey(a)),
              this.ls.removeItem(this._prefix(a)),
              this
            );
          },
          clear: function () {
            var a,
              b = g(this.keyMatcher);
            for (a = b.length; a--; ) this.remove(b[a]);
            return this;
          },
          isExpired: function (a) {
            var c = f(this.ls.getItem(this._ttlKey(a)));
            return b.isNumber(c) && d() > c ? !0 : !1;
          },
        }),
        c
      );
    })(),
    g = (function () {
      "use strict";
      function c(a) {
        (a = a || {}),
          (this.cancelled = !1),
          (this.lastReq = null),
          (this._send = a.transport),
          (this._get = a.limiter ? a.limiter(this._get) : this._get),
          (this._cache = a.cache === !1 ? new e(0) : h);
      }
      var d = 0,
        f = {},
        g = 6,
        h = new e(10);
      return (
        (c.setMaxPendingRequests = function (a) {
          g = a;
        }),
        (c.resetCache = function () {
          h.reset();
        }),
        b.mixin(c.prototype, {
          _fingerprint: function (b) {
            return (b = b || {}), b.url + b.type + a.param(b.data || {});
          },
          _get: function (a, b) {
            function c(a) {
              b(null, a), k._cache.set(i, a);
            }
            function e() {
              b(!0);
            }
            function h() {
              d--,
                delete f[i],
                k.onDeckRequestArgs &&
                  (k._get.apply(k, k.onDeckRequestArgs),
                  (k.onDeckRequestArgs = null));
            }
            var i,
              j,
              k = this;
            (i = this._fingerprint(a)),
              this.cancelled ||
                i !== this.lastReq ||
                ((j = f[i])
                  ? j.done(c).fail(e)
                  : g > d
                  ? (d++, (f[i] = this._send(a).done(c).fail(e).always(h)))
                  : (this.onDeckRequestArgs = [].slice.call(arguments, 0)));
          },
          get: function (c, d) {
            var e, f;
            (d = d || a.noop),
              (c = b.isString(c) ? { url: c } : c || {}),
              (f = this._fingerprint(c)),
              (this.cancelled = !1),
              (this.lastReq = f),
              (e = this._cache.get(f)) ? d(null, e) : this._get(c, d);
          },
          cancel: function () {
            this.cancelled = !0;
          },
        }),
        c
      );
    })(),
    h = (window.SearchIndex = (function () {
      "use strict";
      function c(c) {
        (c = c || {}),
          (c.datumTokenizer && c.queryTokenizer) ||
            a.error("datumTokenizer and queryTokenizer are both required"),
          (this.identify = c.identify || b.stringify),
          (this.datumTokenizer = c.datumTokenizer),
          (this.queryTokenizer = c.queryTokenizer),
          this.reset();
      }
      function d(a) {
        return (
          (a = b.filter(a, function (a) {
            return !!a;
          })),
          (a = b.map(a, function (a) {
            return a.toLowerCase();
          }))
        );
      }
      function e() {
        var a = {};
        return (a[i] = []), (a[h] = {}), a;
      }
      function f(a) {
        for (var b = {}, c = [], d = 0, e = a.length; e > d; d++)
          b[a[d]] || ((b[a[d]] = !0), c.push(a[d]));
        return c;
      }
      function g(a, b) {
        var c = 0,
          d = 0,
          e = [];
        (a = a.sort()), (b = b.sort());
        for (var f = a.length, g = b.length; f > c && g > d; )
          a[c] < b[d] ? c++ : a[c] > b[d] ? d++ : (e.push(a[c]), c++, d++);
        return e;
      }
      var h = "c",
        i = "i";
      return (
        b.mixin(c.prototype, {
          bootstrap: function (a) {
            (this.datums = a.datums), (this.trie = a.trie);
          },
          add: function (a) {
            var c = this;
            (a = b.isArray(a) ? a : [a]),
              b.each(a, function (a) {
                var f, g;
                (c.datums[(f = c.identify(a))] = a),
                  (g = d(c.datumTokenizer(a))),
                  b.each(g, function (a) {
                    var b, d, g;
                    for (b = c.trie, d = a.split(""); (g = d.shift()); )
                      (b = b[h][g] || (b[h][g] = e())), b[i].push(f);
                  });
              });
          },
          get: function (a) {
            var c = this;
            return b.map(a, function (a) {
              return c.datums[a];
            });
          },
          search: function (a) {
            var c,
              e,
              j = this;
            return (
              (c = d(this.queryTokenizer(a))),
              b.each(c, function (a) {
                var b, c, d, f;
                if (e && 0 === e.length) return !1;
                for (b = j.trie, c = a.split(""); b && (d = c.shift()); )
                  b = b[h][d];
                return b && 0 === c.length
                  ? ((f = b[i].slice(0)), void (e = e ? g(e, f) : f))
                  : ((e = []), !1);
              }),
              e
                ? b.map(f(e), function (a) {
                    return j.datums[a];
                  })
                : []
            );
          },
          all: function () {
            var a = [];
            for (var b in this.datums) a.push(this.datums[b]);
            return a;
          },
          reset: function () {
            (this.datums = {}), (this.trie = e());
          },
          serialize: function () {
            return { datums: this.datums, trie: this.trie };
          },
        }),
        c
      );
    })()),
    i = (function () {
      "use strict";
      function a(a) {
        (this.url = a.url),
          (this.ttl = a.ttl),
          (this.cache = a.cache),
          (this.prepare = a.prepare),
          (this.transform = a.transform),
          (this.transport = a.transport),
          (this.thumbprint = a.thumbprint),
          (this.storage = new f(a.cacheKey));
      }
      var c;
      return (
        (c = { data: "data", protocol: "protocol", thumbprint: "thumbprint" }),
        b.mixin(a.prototype, {
          _settings: function () {
            return { url: this.url, type: "GET", dataType: "json" };
          },
          store: function (a) {
            this.cache &&
              (this.storage.set(c.data, a, this.ttl),
              this.storage.set(c.protocol, location.protocol, this.ttl),
              this.storage.set(c.thumbprint, this.thumbprint, this.ttl));
          },
          fromCache: function () {
            var a,
              b = {};
            return this.cache
              ? ((b.data = this.storage.get(c.data)),
                (b.protocol = this.storage.get(c.protocol)),
                (b.thumbprint = this.storage.get(c.thumbprint)),
                (a =
                  b.thumbprint !== this.thumbprint ||
                  b.protocol !== location.protocol),
                b.data && !a ? b.data : null)
              : null;
          },
          fromNetwork: function (a) {
            function b() {
              a(!0);
            }
            function c(b) {
              a(null, e.transform(b));
            }
            var d,
              e = this;
            a &&
              ((d = this.prepare(this._settings())),
              this.transport(d).fail(b).done(c));
          },
          clear: function () {
            return this.storage.clear(), this;
          },
        }),
        a
      );
    })(),
    j = (function () {
      "use strict";
      function a(a) {
        (this.url = a.url),
          (this.prepare = a.prepare),
          (this.transform = a.transform),
          (this.transport = new g({
            cache: a.cache,
            limiter: a.limiter,
            transport: a.transport,
          }));
      }
      return (
        b.mixin(a.prototype, {
          _settings: function () {
            return { url: this.url, type: "GET", dataType: "json" };
          },
          get: function (a, b) {
            function c(a, c) {
              b(a ? [] : e.transform(c));
            }
            var d,
              e = this;
            if (b)
              return (
                (a = a || ""),
                (d = this.prepare(a, this._settings())),
                this.transport.get(d, c)
              );
          },
          cancelLastRequest: function () {
            this.transport.cancel();
          },
        }),
        a
      );
    })(),
    k = (function () {
      "use strict";
      function d(d) {
        var e;
        return d
          ? ((e = {
              url: null,
              ttl: 864e5,
              cache: !0,
              cacheKey: null,
              thumbprint: "",
              prepare: b.identity,
              transform: b.identity,
              transport: null,
            }),
            (d = b.isString(d) ? { url: d } : d),
            (d = b.mixin(e, d)),
            !d.url && a.error("prefetch requires url to be set"),
            (d.transform = d.filter || d.transform),
            (d.cacheKey = d.cacheKey || d.url),
            (d.thumbprint = c + d.thumbprint),
            (d.transport = d.transport ? h(d.transport) : a.ajax),
            d)
          : null;
      }
      function e(c) {
        var d;
        if (c)
          return (
            (d = {
              url: null,
              cache: !0,
              prepare: null,
              replace: null,
              wildcard: null,
              limiter: null,
              rateLimitBy: "debounce",
              rateLimitWait: 300,
              transform: b.identity,
              transport: null,
            }),
            (c = b.isString(c) ? { url: c } : c),
            (c = b.mixin(d, c)),
            !c.url && a.error("remote requires url to be set"),
            (c.transform = c.filter || c.transform),
            (c.prepare = f(c)),
            (c.limiter = g(c)),
            (c.transport = c.transport ? h(c.transport) : a.ajax),
            delete c.replace,
            delete c.wildcard,
            delete c.rateLimitBy,
            delete c.rateLimitWait,
            c
          );
      }
      function f(a) {
        function b(a, b) {
          return (b.url = f(b.url, a)), b;
        }
        function c(a, b) {
          return (b.url = b.url.replace(g, encodeURIComponent(a))), b;
        }
        function d(a, b) {
          return b;
        }
        var e, f, g;
        return (
          (e = a.prepare),
          (f = a.replace),
          (g = a.wildcard),
          e ? e : (e = f ? b : a.wildcard ? c : d)
        );
      }
      function g(a) {
        function c(a) {
          return function (c) {
            return b.debounce(c, a);
          };
        }
        function d(a) {
          return function (c) {
            return b.throttle(c, a);
          };
        }
        var e, f, g;
        return (
          (e = a.limiter),
          (f = a.rateLimitBy),
          (g = a.rateLimitWait),
          e || (e = /^throttle$/i.test(f) ? d(g) : c(g)),
          e
        );
      }
      function h(c) {
        return function (d) {
          function e(a) {
            b.defer(function () {
              g.resolve(a);
            });
          }
          function f(a) {
            b.defer(function () {
              g.reject(a);
            });
          }
          var g = a.Deferred();
          return c(d, e, f), g;
        };
      }
      return function (c) {
        var f, g;
        return (
          (f = {
            initialize: !0,
            identify: b.stringify,
            datumTokenizer: null,
            queryTokenizer: null,
            sufficient: 5,
            sorter: null,
            local: [],
            prefetch: null,
            remote: null,
          }),
          (c = b.mixin(f, c || {})),
          !c.datumTokenizer && a.error("datumTokenizer is required"),
          !c.queryTokenizer && a.error("queryTokenizer is required"),
          (g = c.sorter),
          (c.sorter = g
            ? function (a) {
                return a.sort(g);
              }
            : b.identity),
          (c.local = b.isFunction(c.local) ? c.local() : c.local),
          (c.prefetch = d(c.prefetch)),
          (c.remote = e(c.remote)),
          c
        );
      };
    })(),
    l = (function () {
      "use strict";
      function c(a) {
        (a = k(a)),
          (this.sorter = a.sorter),
          (this.identify = a.identify),
          (this.sufficient = a.sufficient),
          (this.local = a.local),
          (this.remote = a.remote ? new j(a.remote) : null),
          (this.prefetch = a.prefetch ? new i(a.prefetch) : null),
          (this.index = new h({
            identify: this.identify,
            datumTokenizer: a.datumTokenizer,
            queryTokenizer: a.queryTokenizer,
          })),
          a.initialize !== !1 && this.initialize();
      }
      var e;
      return (
        (e = window && window.Bloodhound),
        (c.noConflict = function () {
          return window && (window.Bloodhound = e), c;
        }),
        (c.tokenizers = d),
        b.mixin(c.prototype, {
          __ttAdapter: function () {
            function a(a, b, d) {
              return c.search(a, b, d);
            }
            function b(a, b) {
              return c.search(a, b);
            }
            var c = this;
            return this.remote ? a : b;
          },
          _loadPrefetch: function () {
            function b(a, b) {
              return a
                ? c.reject()
                : (e.add(b),
                  e.prefetch.store(e.index.serialize()),
                  void c.resolve());
            }
            var c,
              d,
              e = this;
            return (
              (c = a.Deferred()),
              this.prefetch
                ? (d = this.prefetch.fromCache())
                  ? (this.index.bootstrap(d), c.resolve())
                  : this.prefetch.fromNetwork(b)
                : c.resolve(),
              c.promise()
            );
          },
          _initialize: function () {
            function a() {
              b.add(b.local);
            }
            var b = this;
            return (
              this.clear(),
              (this.initPromise = this._loadPrefetch()).done(a),
              this.initPromise
            );
          },
          initialize: function (a) {
            return !this.initPromise || a
              ? this._initialize()
              : this.initPromise;
          },
          add: function (a) {
            return this.index.add(a), this;
          },
          get: function (a) {
            return (
              (a = b.isArray(a) ? a : [].slice.call(arguments)),
              this.index.get(a)
            );
          },
          search: function (a, c, d) {
            function e(a) {
              var c = [];
              b.each(a, function (a) {
                !b.some(f, function (b) {
                  return g.identify(a) === g.identify(b);
                }) && c.push(a);
              }),
                d && d(c);
            }
            var f,
              g = this;
            return (
              (f = this.sorter(this.index.search(a))),
              c(this.remote ? f.slice() : f),
              this.remote && f.length < this.sufficient
                ? this.remote.get(a, e)
                : this.remote && this.remote.cancelLastRequest(),
              this
            );
          },
          all: function () {
            return this.index.all();
          },
          clear: function () {
            return this.index.reset(), this;
          },
          clearPrefetchCache: function () {
            return this.prefetch && this.prefetch.clear(), this;
          },
          clearRemoteCache: function () {
            return g.resetCache(), this;
          },
          ttAdapter: function () {
            return this.__ttAdapter();
          },
        }),
        c
      );
    })();
  return l;
}),
  (function (a, b) {
    "function" == typeof define && define.amd
      ? define("typeahead.js", ["jquery"], function (a) {
          return b(a);
        })
      : "object" == typeof exports
      ? (module.exports = b(require("jquery")))
      : b(jQuery);
  })(this, function (a) {
    var b = (function () {
        "use strict";
        return {
          isMsie: function () {
            return /(msie|trident)/i.test(navigator.userAgent)
              ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2]
              : !1;
          },
          isBlankString: function (a) {
            return !a || /^\s*$/.test(a);
          },
          escapeRegExChars: function (a) {
            return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
          },
          isString: function (a) {
            return "string" == typeof a;
          },
          isNumber: function (a) {
            return "number" == typeof a;
          },
          isArray: a.isArray,
          isFunction: a.isFunction,
          isObject: a.isPlainObject,
          isUndefined: function (a) {
            return "undefined" == typeof a;
          },
          isElement: function (a) {
            return !(!a || 1 !== a.nodeType);
          },
          isJQuery: function (b) {
            return b instanceof a;
          },
          toStr: function (a) {
            return b.isUndefined(a) || null === a ? "" : a + "";
          },
          bind: a.proxy,
          each: function (b, c) {
            function d(a, b) {
              return c(b, a);
            }
            a.each(b, d);
          },
          map: a.map,
          filter: a.grep,
          every: function (b, c) {
            var d = !0;
            return b
              ? (a.each(b, function (a, e) {
                  return (d = c.call(null, e, a, b)) ? void 0 : !1;
                }),
                !!d)
              : d;
          },
          some: function (b, c) {
            var d = !1;
            return b
              ? (a.each(b, function (a, e) {
                  return (d = c.call(null, e, a, b)) ? !1 : void 0;
                }),
                !!d)
              : d;
          },
          mixin: a.extend,
          identity: function (a) {
            return a;
          },
          clone: function (b) {
            return a.extend(!0, {}, b);
          },
          getIdGenerator: function () {
            var a = 0;
            return function () {
              return a++;
            };
          },
          templatify: function (b) {
            function c() {
              return String(b);
            }
            return a.isFunction(b) ? b : c;
          },
          defer: function (a) {
            setTimeout(a, 0);
          },
          debounce: function (a, b, c) {
            var d, e;
            return function () {
              var f,
                g,
                h = this,
                i = arguments;
              return (
                (f = function () {
                  (d = null), c || (e = a.apply(h, i));
                }),
                (g = c && !d),
                clearTimeout(d),
                (d = setTimeout(f, b)),
                g && (e = a.apply(h, i)),
                e
              );
            };
          },
          throttle: function (a, b) {
            var c, d, e, f, g, h;
            return (
              (g = 0),
              (h = function () {
                (g = new Date()), (e = null), (f = a.apply(c, d));
              }),
              function () {
                var i = new Date(),
                  j = b - (i - g);
                return (
                  (c = this),
                  (d = arguments),
                  0 >= j
                    ? (clearTimeout(e),
                      (e = null),
                      (g = i),
                      (f = a.apply(c, d)))
                    : e || (e = setTimeout(h, j)),
                  f
                );
              }
            );
          },
          stringify: function (a) {
            return b.isString(a) ? a : JSON.stringify(a);
          },
          noop: function () {},
        };
      })(),
      c = (function () {
        "use strict";
        function a(a) {
          var g, h;
          return (
            (h = b.mixin({}, f, a)),
            (g = { css: e(), classes: h, html: c(h), selectors: d(h) }),
            {
              css: g.css,
              html: g.html,
              classes: g.classes,
              selectors: g.selectors,
              mixin: function (a) {
                b.mixin(a, g);
              },
            }
          );
        }
        function c(a) {
          return {
            wrapper: '<span class="' + a.wrapper + '"></span>',
            menu: '<div class="' + a.menu + '"></div>',
          };
        }
        function d(a) {
          var c = {};
          return (
            b.each(a, function (a, b) {
              c[b] = "." + a;
            }),
            c
          );
        }
        function e() {
          var a = {
            wrapper: { position: "relative", display: "inline-block" },
            hint: {
              position: "absolute",
              top: "0",
              left: "0",
              borderColor: "transparent",
              boxShadow: "none",
              opacity: "1",
            },
            input: {
              position: "relative",
              verticalAlign: "top",
              backgroundColor: "transparent",
            },
            inputWithNoHint: { position: "relative", verticalAlign: "top" },
            menu: {
              position: "absolute",
              top: "100%",
              left: "0",
              zIndex: "100",
              display: "none",
            },
            ltr: { left: "0", right: "auto" },
            rtl: { left: "auto", right: " 0" },
          };
          return (
            b.isMsie() &&
              b.mixin(a.input, {
                backgroundImage:
                  "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)",
              }),
            a
          );
        }
        var f = {
          wrapper: "twitter-typeahead",
          input: "tt-input",
          hint: "tt-hint",
          menu: "tt-menu",
          dataset: "tt-dataset",
          suggestion: "tt-suggestion",
          selectable: "tt-selectable",
          empty: "tt-empty",
          open: "tt-open",
          cursor: "tt-cursor",
          highlight: "tt-highlight",
        };
        return a;
      })(),
      d = (function () {
        "use strict";
        function c(b) {
          (b && b.el) || a.error("EventBus initialized without el"),
            (this.$el = a(b.el));
        }
        var d, e;
        return (
          (d = "typeahead:"),
          (e = {
            render: "rendered",
            cursorchange: "cursorchanged",
            select: "selected",
            autocomplete: "autocompleted",
          }),
          b.mixin(c.prototype, {
            _trigger: function (b, c) {
              var e;
              return (
                (e = a.Event(d + b)),
                (c = c || []).unshift(e),
                this.$el.trigger.apply(this.$el, c),
                e
              );
            },
            before: function (a) {
              var b, c;
              return (
                (b = [].slice.call(arguments, 1)),
                (c = this._trigger("before" + a, b)),
                c.isDefaultPrevented()
              );
            },
            trigger: function (a) {
              var b;
              this._trigger(a, [].slice.call(arguments, 1)),
                (b = e[a]) && this._trigger(b, [].slice.call(arguments, 1));
            },
          }),
          c
        );
      })(),
      e = (function () {
        "use strict";
        function a(a, b, c, d) {
          var e;
          if (!c) return this;
          for (
            b = b.split(i),
              c = d ? h(c, d) : c,
              this._callbacks = this._callbacks || {};
            (e = b.shift());

          )
            (this._callbacks[e] = this._callbacks[e] || {
              sync: [],
              async: [],
            }),
              this._callbacks[e][a].push(c);
          return this;
        }
        function b(b, c, d) {
          return a.call(this, "async", b, c, d);
        }
        function c(b, c, d) {
          return a.call(this, "sync", b, c, d);
        }
        function d(a) {
          var b;
          if (!this._callbacks) return this;
          for (a = a.split(i); (b = a.shift()); ) delete this._callbacks[b];
          return this;
        }
        function e(a) {
          var b, c, d, e, g;
          if (!this._callbacks) return this;
          for (
            a = a.split(i), d = [].slice.call(arguments, 1);
            (b = a.shift()) && (c = this._callbacks[b]);

          )
            (e = f(c.sync, this, [b].concat(d))),
              (g = f(c.async, this, [b].concat(d))),
              e() && j(g);
          return this;
        }
        function f(a, b, c) {
          function d() {
            for (var d, e = 0, f = a.length; !d && f > e; e += 1)
              d = a[e].apply(b, c) === !1;
            return !d;
          }
          return d;
        }
        function g() {
          var a;
          return (a = window.setImmediate
            ? function (a) {
                setImmediate(function () {
                  a();
                });
              }
            : function (a) {
                setTimeout(function () {
                  a();
                }, 0);
              });
        }
        function h(a, b) {
          return a.bind
            ? a.bind(b)
            : function () {
                a.apply(b, [].slice.call(arguments, 0));
              };
        }
        var i = /\s+/,
          j = g();
        return { onSync: c, onAsync: b, off: d, trigger: e };
      })(),
      f = (function (a) {
        "use strict";
        function c(a, c, d) {
          for (var e, f = [], g = 0, h = a.length; h > g; g++)
            f.push(b.escapeRegExChars(a[g]));
          return (
            (e = d ? "\\b(" + f.join("|") + ")\\b" : "(" + f.join("|") + ")"),
            c ? new RegExp(e) : new RegExp(e, "i")
          );
        }
        var d = {
          node: null,
          pattern: null,
          tagName: "strong",
          className: null,
          wordsOnly: !1,
          caseSensitive: !1,
        };
        return function (e) {
          function f(b) {
            var c, d, f;
            return (
              (c = h.exec(b.data)) &&
                ((f = a.createElement(e.tagName)),
                e.className && (f.className = e.className),
                (d = b.splitText(c.index)),
                d.splitText(c[0].length),
                f.appendChild(d.cloneNode(!0)),
                b.parentNode.replaceChild(f, d)),
              !!c
            );
          }
          function g(a, b) {
            for (var c, d = 3, e = 0; e < a.childNodes.length; e++)
              (c = a.childNodes[e]),
                c.nodeType === d ? (e += b(c) ? 1 : 0) : g(c, b);
          }
          var h;
          (e = b.mixin({}, d, e)),
            e.node &&
              e.pattern &&
              ((e.pattern = b.isArray(e.pattern) ? e.pattern : [e.pattern]),
              (h = c(e.pattern, e.caseSensitive, e.wordsOnly)),
              g(e.node, f));
        };
      })(window.document),
      g = (function () {
        "use strict";
        function c(c, e) {
          (c = c || {}),
            c.input || a.error("input is missing"),
            e.mixin(this),
            (this.$hint = a(c.hint)),
            (this.$input = a(c.input)),
            (this.query = this.$input.val()),
            (this.queryWhenFocused = this.hasFocus() ? this.query : null),
            (this.$overflowHelper = d(this.$input)),
            this._checkLanguageDirection(),
            0 === this.$hint.length &&
              (this.setHint =
                this.getHint =
                this.clearHint =
                this.clearHintIfInvalid =
                  b.noop);
        }
        function d(b) {
          return a('<pre aria-hidden="true"></pre>')
            .css({
              position: "absolute",
              visibility: "hidden",
              whiteSpace: "pre",
              fontFamily: b.css("font-family"),
              fontSize: b.css("font-size"),
              fontStyle: b.css("font-style"),
              fontVariant: b.css("font-variant"),
              fontWeight: b.css("font-weight"),
              wordSpacing: b.css("word-spacing"),
              letterSpacing: b.css("letter-spacing"),
              textIndent: b.css("text-indent"),
              textRendering: b.css("text-rendering"),
              textTransform: b.css("text-transform"),
            })
            .insertAfter(b);
        }
        function f(a, b) {
          return c.normalizeQuery(a) === c.normalizeQuery(b);
        }
        function g(a) {
          return a.altKey || a.ctrlKey || a.metaKey || a.shiftKey;
        }
        var h;
        return (
          (h = {
            9: "tab",
            27: "esc",
            37: "left",
            39: "right",
            13: "enter",
            38: "up",
            40: "down",
          }),
          (c.normalizeQuery = function (a) {
            return b
              .toStr(a)
              .replace(/^\s*/g, "")
              .replace(/\s{2,}/g, " ");
          }),
          b.mixin(c.prototype, e, {
            _onBlur: function () {
              this.resetInputValue(), this.trigger("blurred");
            },
            _onFocus: function () {
              (this.queryWhenFocused = this.query), this.trigger("focused");
            },
            _onKeydown: function (a) {
              var b = h[a.which || a.keyCode];
              this._managePreventDefault(b, a),
                b && this._shouldTrigger(b, a) && this.trigger(b + "Keyed", a);
            },
            _onInput: function () {
              this._setQuery(this.getInputValue()),
                this.clearHintIfInvalid(),
                this._checkLanguageDirection();
            },
            _managePreventDefault: function (a, b) {
              var c;
              switch (a) {
                case "up":
                case "down":
                  c = !g(b);
                  break;
                default:
                  c = !1;
              }
              c && b.preventDefault();
            },
            _shouldTrigger: function (a, b) {
              var c;
              switch (a) {
                case "tab":
                  c = !g(b);
                  break;
                default:
                  c = !0;
              }
              return c;
            },
            _checkLanguageDirection: function () {
              var a = (this.$input.css("direction") || "ltr").toLowerCase();
              this.dir !== a &&
                ((this.dir = a),
                this.$hint.attr("dir", a),
                this.trigger("langDirChanged", a));
            },
            _setQuery: function (a, b) {
              var c, d;
              (c = f(a, this.query)),
                (d = c ? this.query.length !== a.length : !1),
                (this.query = a),
                b || c
                  ? !b && d && this.trigger("whitespaceChanged", this.query)
                  : this.trigger("queryChanged", this.query);
            },
            bind: function () {
              var a,
                c,
                d,
                e,
                f = this;
              return (
                (a = b.bind(this._onBlur, this)),
                (c = b.bind(this._onFocus, this)),
                (d = b.bind(this._onKeydown, this)),
                (e = b.bind(this._onInput, this)),
                this.$input
                  .on("blur.tt", a)
                  .on("focus.tt", c)
                  .on("keydown.tt", d),
                !b.isMsie() || b.isMsie() > 9
                  ? this.$input.on("input.tt", e)
                  : this.$input.on(
                      "keydown.tt keypress.tt cut.tt paste.tt",
                      function (a) {
                        h[a.which || a.keyCode] ||
                          b.defer(b.bind(f._onInput, f, a));
                      }
                    ),
                this
              );
            },
            focus: function () {
              this.$input.focus();
            },
            blur: function () {
              this.$input.blur();
            },
            getLangDir: function () {
              return this.dir;
            },
            getQuery: function () {
              return this.query || "";
            },
            setQuery: function (a, b) {
              this.setInputValue(a), this._setQuery(a, b);
            },
            hasQueryChangedSinceLastFocus: function () {
              return this.query !== this.queryWhenFocused;
            },
            getInputValue: function () {
              return this.$input.val();
            },
            setInputValue: function (a) {
              this.$input.val(a),
                this.clearHintIfInvalid(),
                this._checkLanguageDirection();
            },
            resetInputValue: function () {
              this.setInputValue(this.query);
            },
            getHint: function () {
              return this.$hint.val();
            },
            setHint: function (a) {
              this.$hint.val(a);
            },
            clearHint: function () {
              this.setHint("");
            },
            clearHintIfInvalid: function () {
              var a, b, c, d;
              (a = this.getInputValue()),
                (b = this.getHint()),
                (c = a !== b && 0 === b.indexOf(a)),
                (d = "" !== a && c && !this.hasOverflow()),
                !d && this.clearHint();
            },
            hasFocus: function () {
              return this.$input.is(":focus");
            },
            hasOverflow: function () {
              var a = this.$input.width() - 2;
              return (
                this.$overflowHelper.text(this.getInputValue()),
                this.$overflowHelper.width() >= a
              );
            },
            isCursorAtEnd: function () {
              var a, c, d;
              return (
                (a = this.$input.val().length),
                (c = this.$input[0].selectionStart),
                b.isNumber(c)
                  ? c === a
                  : document.selection
                  ? ((d = document.selection.createRange()),
                    d.moveStart("character", -a),
                    a === d.text.length)
                  : !0
              );
            },
            destroy: function () {
              this.$hint.off(".tt"),
                this.$input.off(".tt"),
                this.$overflowHelper.remove(),
                (this.$hint = this.$input = this.$overflowHelper = a("<div>"));
            },
          }),
          c
        );
      })(),
      h = (function () {
        "use strict";
        function c(c, e) {
          (c = c || {}),
            (c.templates = c.templates || {}),
            (c.templates.notFound = c.templates.notFound || c.templates.empty),
            c.source || a.error("missing source"),
            c.node || a.error("missing node"),
            c.name && !h(c.name) && a.error("invalid dataset name: " + c.name),
            e.mixin(this),
            (this.highlight = !!c.highlight),
            (this.name = c.name || j()),
            (this.limit = c.limit || 5),
            (this.displayFn = d(c.display || c.displayKey)),
            (this.templates = g(c.templates, this.displayFn)),
            (this.source = c.source.__ttAdapter
              ? c.source.__ttAdapter()
              : c.source),
            (this.async = b.isUndefined(c.async)
              ? this.source.length > 2
              : !!c.async),
            this._resetLastSuggestion(),
            (this.$el = a(c.node)
              .addClass(this.classes.dataset)
              .addClass(this.classes.dataset + "-" + this.name));
        }
        function d(a) {
          function c(b) {
            return b[a];
          }
          return (a = a || b.stringify), b.isFunction(a) ? a : c;
        }
        function g(c, d) {
          function e(b) {
            return a("<div>").text(d(b));
          }
          return {
            notFound: c.notFound && b.templatify(c.notFound),
            pending: c.pending && b.templatify(c.pending),
            header: c.header && b.templatify(c.header),
            footer: c.footer && b.templatify(c.footer),
            suggestion: c.suggestion || e,
          };
        }
        function h(a) {
          return /^[_a-zA-Z0-9-]+$/.test(a);
        }
        var i, j;
        return (
          (i = { val: "tt-selectable-display", obj: "tt-selectable-object" }),
          (j = b.getIdGenerator()),
          (c.extractData = function (b) {
            var c = a(b);
            return c.data(i.obj)
              ? { val: c.data(i.val) || "", obj: c.data(i.obj) || null }
              : null;
          }),
          b.mixin(c.prototype, e, {
            _overwrite: function (a, b) {
              (b = b || []),
                b.length
                  ? this._renderSuggestions(a, b)
                  : this.async && this.templates.pending
                  ? this._renderPending(a)
                  : !this.async && this.templates.notFound
                  ? this._renderNotFound(a)
                  : this._empty(),
                this.trigger("rendered", this.name, b, !1);
            },
            _append: function (a, b) {
              (b = b || []),
                b.length && this.$lastSuggestion.length
                  ? this._appendSuggestions(a, b)
                  : b.length
                  ? this._renderSuggestions(a, b)
                  : !this.$lastSuggestion.length &&
                    this.templates.notFound &&
                    this._renderNotFound(a),
                this.trigger("rendered", this.name, b, !0);
            },
            _renderSuggestions: function (a, b) {
              var c;
              (c = this._getSuggestionsFragment(a, b)),
                (this.$lastSuggestion = c.children().last()),
                this.$el
                  .html(c)
                  .prepend(this._getHeader(a, b))
                  .append(this._getFooter(a, b));
            },
            _appendSuggestions: function (a, b) {
              var c, d;
              (c = this._getSuggestionsFragment(a, b)),
                (d = c.children().last()),
                this.$lastSuggestion.after(c),
                (this.$lastSuggestion = d);
            },
            _renderPending: function (a) {
              var b = this.templates.pending;
              this._resetLastSuggestion(),
                b && this.$el.html(b({ query: a, dataset: this.name }));
            },
            _renderNotFound: function (a) {
              var b = this.templates.notFound;
              this._resetLastSuggestion(),
                b && this.$el.html(b({ query: a, dataset: this.name }));
            },
            _empty: function () {
              this.$el.empty(), this._resetLastSuggestion();
            },
            _getSuggestionsFragment: function (c, d) {
              var e,
                g = this;
              return (
                (e = document.createDocumentFragment()),
                b.each(d, function (b) {
                  var d, f;
                  (f = g._injectQuery(c, b)),
                    (d = a(g.templates.suggestion(f))
                      .data(i.obj, b)
                      .data(i.val, g.displayFn(b))
                      .addClass(
                        g.classes.suggestion + " " + g.classes.selectable
                      )),
                    e.appendChild(d[0]);
                }),
                this.highlight &&
                  f({ className: this.classes.highlight, node: e, pattern: c }),
                a(e)
              );
            },
            _getFooter: function (a, b) {
              return this.templates.footer
                ? this.templates.footer({
                    query: a,
                    suggestions: b,
                    dataset: this.name,
                  })
                : null;
            },
            _getHeader: function (a, b) {
              return this.templates.header
                ? this.templates.header({
                    query: a,
                    suggestions: b,
                    dataset: this.name,
                  })
                : null;
            },
            _resetLastSuggestion: function () {
              this.$lastSuggestion = a();
            },
            _injectQuery: function (a, c) {
              return b.isObject(c) ? b.mixin({ _query: a }, c) : c;
            },
            update: function (b) {
              function c(a) {
                g ||
                  ((g = !0),
                  (a = (a || []).slice(0, e.limit)),
                  (h = a.length),
                  e._overwrite(b, a),
                  h < e.limit && e.async && e.trigger("asyncRequested", b));
              }
              function d(c) {
                (c = c || []),
                  !f &&
                    h < e.limit &&
                    ((e.cancel = a.noop),
                    (h += c.length),
                    e._append(b, c.slice(0, e.limit - h)),
                    e.async && e.trigger("asyncReceived", b));
              }
              var e = this,
                f = !1,
                g = !1,
                h = 0;
              this.cancel(),
                (this.cancel = function () {
                  (f = !0),
                    (e.cancel = a.noop),
                    e.async && e.trigger("asyncCanceled", b);
                }),
                this.source(b, c, d),
                !g && c([]);
            },
            cancel: a.noop,
            clear: function () {
              this._empty(), this.cancel(), this.trigger("cleared");
            },
            isEmpty: function () {
              return this.$el.is(":empty");
            },
            destroy: function () {
              this.$el = a("<div>");
            },
          }),
          c
        );
      })(),
      i = (function () {
        "use strict";
        function c(c, d) {
          function e(b) {
            var c = f.$node.find(b.node).first();
            return (
              (b.node = c.length ? c : a("<div>").appendTo(f.$node)),
              new h(b, d)
            );
          }
          var f = this;
          (c = c || {}),
            c.node || a.error("node is required"),
            d.mixin(this),
            (this.$node = a(c.node)),
            (this.query = null),
            (this.datasets = b.map(c.datasets, e));
        }
        return (
          b.mixin(c.prototype, e, {
            _onSelectableClick: function (b) {
              this.trigger("selectableClicked", a(b.currentTarget));
            },
            _onRendered: function (a, b, c, d) {
              this.$node.toggleClass(
                this.classes.empty,
                this._allDatasetsEmpty()
              ),
                this.trigger("datasetRendered", b, c, d);
            },
            _onCleared: function () {
              this.$node.toggleClass(
                this.classes.empty,
                this._allDatasetsEmpty()
              ),
                this.trigger("datasetCleared");
            },
            _propagate: function () {
              this.trigger.apply(this, arguments);
            },
            _allDatasetsEmpty: function () {
              function a(a) {
                return a.isEmpty();
              }
              return b.every(this.datasets, a);
            },
            _getSelectables: function () {
              return this.$node.find(this.selectors.selectable);
            },
            _removeCursor: function () {
              var a = this.getActiveSelectable();
              a && a.removeClass(this.classes.cursor);
            },
            _ensureVisible: function (a) {
              var b, c, d, e;
              (b = a.position().top),
                (c = b + a.outerHeight(!0)),
                (d = this.$node.scrollTop()),
                (e =
                  this.$node.height() +
                  parseInt(this.$node.css("paddingTop"), 10) +
                  parseInt(this.$node.css("paddingBottom"), 10)),
                0 > b
                  ? this.$node.scrollTop(d + b)
                  : c > e && this.$node.scrollTop(d + (c - e));
            },
            bind: function () {
              var a,
                c = this;
              return (
                (a = b.bind(this._onSelectableClick, this)),
                this.$node.on("click.tt", this.selectors.selectable, a),
                b.each(this.datasets, function (a) {
                  a.onSync("asyncRequested", c._propagate, c)
                    .onSync("asyncCanceled", c._propagate, c)
                    .onSync("asyncReceived", c._propagate, c)
                    .onSync("rendered", c._onRendered, c)
                    .onSync("cleared", c._onCleared, c);
                }),
                this
              );
            },
            isOpen: function () {
              return this.$node.hasClass(this.classes.open);
            },
            open: function () {
              this.$node.addClass(this.classes.open);
            },
            close: function () {
              this.$node.removeClass(this.classes.open), this._removeCursor();
            },
            setLanguageDirection: function (a) {
              this.$node.attr("dir", a);
            },
            selectableRelativeToCursor: function (a) {
              var b, c, d, e;
              return (
                (c = this.getActiveSelectable()),
                (b = this._getSelectables()),
                (d = c ? b.index(c) : -1),
                (e = d + a),
                (e = ((e + 1) % (b.length + 1)) - 1),
                (e = -1 > e ? b.length - 1 : e),
                -1 === e ? null : b.eq(e)
              );
            },
            setCursor: function (a) {
              this._removeCursor(),
                (a = a && a.first()) &&
                  (a.addClass(this.classes.cursor), this._ensureVisible(a));
            },
            getSelectableData: function (a) {
              return a && a.length ? h.extractData(a) : null;
            },
            getActiveSelectable: function () {
              var a = this._getSelectables()
                .filter(this.selectors.cursor)
                .first();
              return a.length ? a : null;
            },
            getTopSelectable: function () {
              var a = this._getSelectables().first();
              return a.length ? a : null;
            },
            update: function (a) {
              function c(b) {
                b.update(a);
              }
              var d = a !== this.query;
              return d && ((this.query = a), b.each(this.datasets, c)), d;
            },
            empty: function () {
              function a(a) {
                a.clear();
              }
              b.each(this.datasets, a),
                (this.query = null),
                this.$node.addClass(this.classes.empty);
            },
            destroy: function () {
              function c(a) {
                a.destroy();
              }
              this.$node.off(".tt"),
                (this.$node = a("<div>")),
                b.each(this.datasets, c);
            },
          }),
          c
        );
      })(),
      j = (function () {
        "use strict";
        function a() {
          i.apply(this, [].slice.call(arguments, 0));
        }
        var c = i.prototype;
        return (
          b.mixin(a.prototype, i.prototype, {
            open: function () {
              return (
                !this._allDatasetsEmpty() && this._show(),
                c.open.apply(this, [].slice.call(arguments, 0))
              );
            },
            close: function () {
              return (
                this._hide(), c.close.apply(this, [].slice.call(arguments, 0))
              );
            },
            _onRendered: function () {
              return (
                this._allDatasetsEmpty()
                  ? this._hide()
                  : this.isOpen() && this._show(),
                c._onRendered.apply(this, [].slice.call(arguments, 0))
              );
            },
            _onCleared: function () {
              return (
                this._allDatasetsEmpty()
                  ? this._hide()
                  : this.isOpen() && this._show(),
                c._onCleared.apply(this, [].slice.call(arguments, 0))
              );
            },
            setLanguageDirection: function (a) {
              return (
                this.$node.css("ltr" === a ? this.css.ltr : this.css.rtl),
                c.setLanguageDirection.apply(this, [].slice.call(arguments, 0))
              );
            },
            _hide: function () {
              this.$node.hide();
            },
            _show: function () {
              this.$node.css("display", "block");
            },
          }),
          a
        );
      })(),
      k = (function () {
        "use strict";
        function c(c, e) {
          var f, g, h, i, j, k, l, m, n, o, p;
          (c = c || {}),
            c.input || a.error("missing input"),
            c.menu || a.error("missing menu"),
            c.eventBus || a.error("missing event bus"),
            e.mixin(this),
            (this.eventBus = c.eventBus),
            (this.minLength = b.isNumber(c.minLength) ? c.minLength : 1),
            (this.input = c.input),
            (this.menu = c.menu),
            (this.enabled = !0),
            (this.active = !1),
            this.input.hasFocus() && this.activate(),
            (this.dir = this.input.getLangDir()),
            this._hacks(),
            this.menu
              .bind()
              .onSync("selectableClicked", this._onSelectableClicked, this)
              .onSync("asyncRequested", this._onAsyncRequested, this)
              .onSync("asyncCanceled", this._onAsyncCanceled, this)
              .onSync("asyncReceived", this._onAsyncReceived, this)
              .onSync("datasetRendered", this._onDatasetRendered, this)
              .onSync("datasetCleared", this._onDatasetCleared, this),
            (f = d(this, "activate", "open", "_onFocused")),
            (g = d(this, "deactivate", "_onBlurred")),
            (h = d(this, "isActive", "isOpen", "_onEnterKeyed")),
            (i = d(this, "isActive", "isOpen", "_onTabKeyed")),
            (j = d(this, "isActive", "_onEscKeyed")),
            (k = d(this, "isActive", "open", "_onUpKeyed")),
            (l = d(this, "isActive", "open", "_onDownKeyed")),
            (m = d(this, "isActive", "isOpen", "_onLeftKeyed")),
            (n = d(this, "isActive", "isOpen", "_onRightKeyed")),
            (o = d(this, "_openIfActive", "_onQueryChanged")),
            (p = d(this, "_openIfActive", "_onWhitespaceChanged")),
            this.input
              .bind()
              .onSync("focused", f, this)
              .onSync("blurred", g, this)
              .onSync("enterKeyed", h, this)
              .onSync("tabKeyed", i, this)
              .onSync("escKeyed", j, this)
              .onSync("upKeyed", k, this)
              .onSync("downKeyed", l, this)
              .onSync("leftKeyed", m, this)
              .onSync("rightKeyed", n, this)
              .onSync("queryChanged", o, this)
              .onSync("whitespaceChanged", p, this)
              .onSync("langDirChanged", this._onLangDirChanged, this);
        }
        function d(a) {
          var c = [].slice.call(arguments, 1);
          return function () {
            var d = [].slice.call(arguments);
            b.each(c, function (b) {
              return a[b].apply(a, d);
            });
          };
        }
        return (
          b.mixin(c.prototype, {
            _hacks: function () {
              var c, d;
              (c = this.input.$input || a("<div>")),
                (d = this.menu.$node || a("<div>")),
                c.on("blur.tt", function (a) {
                  var e, f, g;
                  (e = document.activeElement),
                    (f = d.is(e)),
                    (g = d.has(e).length > 0),
                    b.isMsie() &&
                      (f || g) &&
                      (a.preventDefault(),
                      a.stopImmediatePropagation(),
                      b.defer(function () {
                        c.focus();
                      }));
                }),
                d.on("mousedown.tt", function (a) {
                  a.preventDefault();
                });
            },
            _onSelectableClicked: function (a, b) {
              this.select(b);
            },
            _onDatasetCleared: function () {
              this._updateHint();
            },
            _onDatasetRendered: function (a, b, c, d) {
              this._updateHint(), this.eventBus.trigger("render", c, d, b);
            },
            _onAsyncRequested: function (a, b, c) {
              this.eventBus.trigger("asyncrequest", c, b);
            },
            _onAsyncCanceled: function (a, b, c) {
              this.eventBus.trigger("asynccancel", c, b);
            },
            _onAsyncReceived: function (a, b, c) {
              this.eventBus.trigger("asyncreceive", c, b);
            },
            _onFocused: function () {
              this._minLengthMet() && this.menu.update(this.input.getQuery());
            },
            _onBlurred: function () {
              this.input.hasQueryChangedSinceLastFocus() &&
                this.eventBus.trigger("change", this.input.getQuery());
            },
            _onEnterKeyed: function (a, b) {
              var c;
              (c = this.menu.getActiveSelectable()) &&
                this.select(c) &&
                b.preventDefault();
            },
            _onTabKeyed: function (a, b) {
              var c;
              (c = this.menu.getActiveSelectable())
                ? this.select(c) && b.preventDefault()
                : (c = this.menu.getTopSelectable()) &&
                  this.autocomplete(c) &&
                  b.preventDefault();
            },
            _onEscKeyed: function () {
              this.close();
            },
            _onUpKeyed: function () {
              this.moveCursor(-1);
            },
            _onDownKeyed: function () {
              this.moveCursor(1);
            },
            _onLeftKeyed: function () {
              "rtl" === this.dir &&
                this.input.isCursorAtEnd() &&
                this.autocomplete(this.menu.getTopSelectable());
            },
            _onRightKeyed: function () {
              "ltr" === this.dir &&
                this.input.isCursorAtEnd() &&
                this.autocomplete(this.menu.getTopSelectable());
            },
            _onQueryChanged: function (a, b) {
              this._minLengthMet(b) ? this.menu.update(b) : this.menu.empty();
            },
            _onWhitespaceChanged: function () {
              this._updateHint();
            },
            _onLangDirChanged: function (a, b) {
              this.dir !== b &&
                ((this.dir = b), this.menu.setLanguageDirection(b));
            },
            _openIfActive: function () {
              this.isActive() && this.open();
            },
            _minLengthMet: function (a) {
              return (
                (a = b.isString(a) ? a : this.input.getQuery() || ""),
                a.length >= this.minLength
              );
            },
            _updateHint: function () {
              var a, c, d, e, f, h, i;
              (a = this.menu.getTopSelectable()),
                (c = this.menu.getSelectableData(a)),
                (d = this.input.getInputValue()),
                !c || b.isBlankString(d) || this.input.hasOverflow()
                  ? this.input.clearHint()
                  : ((e = g.normalizeQuery(d)),
                    (f = b.escapeRegExChars(e)),
                    (h = new RegExp("^(?:" + f + ")(.+$)", "i")),
                    (i = h.exec(c.val)),
                    i && this.input.setHint(d + i[1]));
            },
            isEnabled: function () {
              return this.enabled;
            },
            enable: function () {
              this.enabled = !0;
            },
            disable: function () {
              this.enabled = !1;
            },
            isActive: function () {
              return this.active;
            },
            activate: function () {
              return this.isActive()
                ? !0
                : !this.isEnabled() || this.eventBus.before("active")
                ? !1
                : ((this.active = !0), this.eventBus.trigger("active"), !0);
            },
            deactivate: function () {
              return this.isActive()
                ? this.eventBus.before("idle")
                  ? !1
                  : ((this.active = !1),
                    this.close(),
                    this.eventBus.trigger("idle"),
                    !0)
                : !0;
            },
            isOpen: function () {
              return this.menu.isOpen();
            },
            open: function () {
              return (
                this.isOpen() ||
                  this.eventBus.before("open") ||
                  (this.menu.open(),
                  this._updateHint(),
                  this.eventBus.trigger("open")),
                this.isOpen()
              );
            },
            close: function () {
              return (
                this.isOpen() &&
                  !this.eventBus.before("close") &&
                  (this.menu.close(),
                  this.input.clearHint(),
                  this.input.resetInputValue(),
                  this.eventBus.trigger("close")),
                !this.isOpen()
              );
            },
            setVal: function (a) {
              this.input.setQuery(b.toStr(a));
            },
            getVal: function () {
              return this.input.getQuery();
            },
            select: function (a) {
              var b = this.menu.getSelectableData(a);
              return b && !this.eventBus.before("select", b.obj)
                ? (this.input.setQuery(b.val, !0),
                  this.eventBus.trigger("select", b.obj),
                  this.close(),
                  !0)
                : !1;
            },
            autocomplete: function (a) {
              var b, c, d;
              return (
                (b = this.input.getQuery()),
                (c = this.menu.getSelectableData(a)),
                (d = c && b !== c.val),
                d && !this.eventBus.before("autocomplete", c.obj)
                  ? (this.input.setQuery(c.val),
                    this.eventBus.trigger("autocomplete", c.obj),
                    !0)
                  : !1
              );
            },
            moveCursor: function (a) {
              var b, c, d, e, f;
              return (
                (b = this.input.getQuery()),
                (c = this.menu.selectableRelativeToCursor(a)),
                (d = this.menu.getSelectableData(c)),
                (e = d ? d.obj : null),
                (f = this._minLengthMet() && this.menu.update(b)),
                f || this.eventBus.before("cursorchange", e)
                  ? !1
                  : (this.menu.setCursor(c),
                    d
                      ? this.input.setInputValue(d.val)
                      : (this.input.resetInputValue(), this._updateHint()),
                    this.eventBus.trigger("cursorchange", e),
                    !0)
              );
            },
            destroy: function () {
              this.input.destroy(), this.menu.destroy();
            },
          }),
          c
        );
      })();
    !(function () {
      "use strict";
      function e(b, c) {
        b.each(function () {
          var b,
            d = a(this);
          (b = d.data(p.typeahead)) && c(b, d);
        });
      }
      function f(a, b) {
        return a
          .clone()
          .addClass(b.classes.hint)
          .removeData()
          .css(b.css.hint)
          .css(l(a))
          .prop("readonly", !0)
          .removeAttr("id name placeholder required")
          .attr({ autocomplete: "off", spellcheck: "false", tabindex: -1 });
      }
      function h(a, b) {
        a.data(p.attrs, {
          dir: a.attr("dir"),
          autocomplete: a.attr("autocomplete"),
          spellcheck: a.attr("spellcheck"),
          style: a.attr("style"),
        }),
          a
            .addClass(b.classes.input)
            .attr({ autocomplete: "off", spellcheck: !1 });
        try {
          !a.attr("dir") && a.attr("dir", "auto");
        } catch (c) {}
        return a;
      }
      function l(a) {
        return {
          backgroundAttachment: a.css("background-attachment"),
          backgroundClip: a.css("background-clip"),
          backgroundColor: a.css("background-color"),
          backgroundImage: a.css("background-image"),
          backgroundOrigin: a.css("background-origin"),
          backgroundPosition: a.css("background-position"),
          backgroundRepeat: a.css("background-repeat"),
          backgroundSize: a.css("background-size"),
        };
      }
      function m(a) {
        var c, d;
        (c = a.data(p.www)),
          (d = a.parent().filter(c.selectors.wrapper)),
          b.each(a.data(p.attrs), function (c, d) {
            b.isUndefined(c) ? a.removeAttr(d) : a.attr(d, c);
          }),
          a
            .removeData(p.typeahead)
            .removeData(p.www)
            .removeData(p.attr)
            .removeClass(c.classes.input),
          d.length && (a.detach().insertAfter(d), d.remove());
      }
      function n(c) {
        var d, e;
        return (
          (d = b.isJQuery(c) || b.isElement(c)),
          (e = d ? a(c).first() : []),
          e.length ? e : null
        );
      }
      var o, p, q;
      (o = a.fn.typeahead),
        (p = { www: "tt-www", attrs: "tt-attrs", typeahead: "tt-typeahead" }),
        (q = {
          initialize: function (e, l) {
            function m() {
              var c, m, q, r, s, t, u, v, w, x, y;
              b.each(l, function (a) {
                a.highlight = !!e.highlight;
              }),
                (c = a(this)),
                (m = a(o.html.wrapper)),
                (q = n(e.hint)),
                (r = n(e.menu)),
                (s = e.hint !== !1 && !q),
                (t = e.menu !== !1 && !r),
                s && (q = f(c, o)),
                t && (r = a(o.html.menu).css(o.css.menu)),
                q && q.val(""),
                (c = h(c, o)),
                (s || t) &&
                  (m.css(o.css.wrapper),
                  c.css(s ? o.css.input : o.css.inputWithNoHint),
                  c
                    .wrap(m)
                    .parent()
                    .prepend(s ? q : null)
                    .append(t ? r : null)),
                (y = t ? j : i),
                (u = new d({ el: c })),
                (v = new g({ hint: q, input: c }, o)),
                (w = new y({ node: r, datasets: l }, o)),
                (x = new k(
                  { input: v, menu: w, eventBus: u, minLength: e.minLength },
                  o
                )),
                c.data(p.www, o),
                c.data(p.typeahead, x);
            }
            var o;
            return (
              (l = b.isArray(l) ? l : [].slice.call(arguments, 1)),
              (e = e || {}),
              (o = c(e.classNames)),
              this.each(m)
            );
          },
          isEnabled: function () {
            var a;
            return (
              e(this.first(), function (b) {
                a = b.isEnabled();
              }),
              a
            );
          },
          enable: function () {
            return (
              e(this, function (a) {
                a.enable();
              }),
              this
            );
          },
          disable: function () {
            return (
              e(this, function (a) {
                a.disable();
              }),
              this
            );
          },
          isActive: function () {
            var a;
            return (
              e(this.first(), function (b) {
                a = b.isActive();
              }),
              a
            );
          },
          activate: function () {
            return (
              e(this, function (a) {
                a.activate();
              }),
              this
            );
          },
          deactivate: function () {
            return (
              e(this, function (a) {
                a.deactivate();
              }),
              this
            );
          },
          isOpen: function () {
            var a;
            return (
              e(this.first(), function (b) {
                a = b.isOpen();
              }),
              a
            );
          },
          open: function () {
            return (
              e(this, function (a) {
                a.open();
              }),
              this
            );
          },
          close: function () {
            return (
              e(this, function (a) {
                a.close();
              }),
              this
            );
          },
          select: function (b) {
            var c = !1,
              d = a(b);
            return (
              e(this.first(), function (a) {
                c = a.select(d);
              }),
              c
            );
          },
          autocomplete: function (b) {
            var c = !1,
              d = a(b);
            return (
              e(this.first(), function (a) {
                c = a.autocomplete(d);
              }),
              c
            );
          },
          moveCursor: function (a) {
            var b = !1;
            return (
              e(this.first(), function (c) {
                b = c.moveCursor(a);
              }),
              b
            );
          },
          val: function (a) {
            var b;
            return arguments.length
              ? (e(this, function (b) {
                  b.setVal(a);
                }),
                this)
              : (e(this.first(), function (a) {
                  b = a.getVal();
                }),
                b);
          },
          destroy: function () {
            return (
              e(this, function (a, b) {
                m(b), a.destroy();
              }),
              this
            );
          },
        }),
        (a.fn.typeahead = function (a) {
          return q[a]
            ? q[a].apply(this, [].slice.call(arguments, 1))
            : q.initialize.apply(this, arguments);
        }),
        (a.fn.typeahead.noConflict = function () {
          return (a.fn.typeahead = o), this;
        });
    })();
  });

/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if ("undefined" == typeof jQuery)
  throw new Error("Bootstrap's JavaScript requires jQuery");
+(function (a) {
  "use strict";
  var b = a.fn.jquery.split(" ")[0].split(".");
  if (
    (b[0] < 2 && b[1] < 9) ||
    (1 == b[0] && 9 == b[1] && b[2] < 1) ||
    b[0] > 3
  )
    throw new Error(
      "Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4"
    );
})(jQuery),
  +(function (a) {
    "use strict";
    function b() {
      var a = document.createElement("bootstrap"),
        b = {
          WebkitTransition: "webkitTransitionEnd",
          MozTransition: "transitionend",
          OTransition: "oTransitionEnd otransitionend",
          transition: "transitionend",
        };
      for (var c in b) if (void 0 !== a.style[c]) return { end: b[c] };
      return !1;
    }
    (a.fn.emulateTransitionEnd = function (b) {
      var c = !1,
        d = this;
      a(this).one("bsTransitionEnd", function () {
        c = !0;
      });
      var e = function () {
        c || a(d).trigger(a.support.transition.end);
      };
      return setTimeout(e, b), this;
    }),
      a(function () {
        (a.support.transition = b()),
          a.support.transition &&
            (a.event.special.bsTransitionEnd = {
              bindType: a.support.transition.end,
              delegateType: a.support.transition.end,
              handle: function (b) {
                if (a(b.target).is(this))
                  return b.handleObj.handler.apply(this, arguments);
              },
            });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var c = a(this),
          e = c.data("bs.alert");
        e || c.data("bs.alert", (e = new d(this))),
          "string" == typeof b && e[b].call(c);
      });
    }
    var c = '[data-dismiss="alert"]',
      d = function (b) {
        a(b).on("click", c, this.close);
      };
    (d.VERSION = "3.3.7"),
      (d.TRANSITION_DURATION = 150),
      (d.prototype.close = function (b) {
        function c() {
          g.detach().trigger("closed.bs.alert").remove();
        }
        var e = a(this),
          f = e.attr("data-target");
        f || ((f = e.attr("href")), (f = f && f.replace(/.*(?=#[^\s]*$)/, "")));
        var g = a("#" === f ? [] : f);
        b && b.preventDefault(),
          g.length || (g = e.closest(".alert")),
          g.trigger((b = a.Event("close.bs.alert"))),
          b.isDefaultPrevented() ||
            (g.removeClass("in"),
            a.support.transition && g.hasClass("fade")
              ? g
                  .one("bsTransitionEnd", c)
                  .emulateTransitionEnd(d.TRANSITION_DURATION)
              : c());
      });
    var e = a.fn.alert;
    (a.fn.alert = b),
      (a.fn.alert.Constructor = d),
      (a.fn.alert.noConflict = function () {
        return (a.fn.alert = e), this;
      }),
      a(document).on("click.bs.alert.data-api", c, d.prototype.close);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.button"),
          f = "object" == typeof b && b;
        e || d.data("bs.button", (e = new c(this, f))),
          "toggle" == b ? e.toggle() : b && e.setState(b);
      });
    }
    var c = function (b, d) {
      (this.$element = a(b)),
        (this.options = a.extend({}, c.DEFAULTS, d)),
        (this.isLoading = !1);
    };
    (c.VERSION = "3.3.7"),
      (c.DEFAULTS = { loadingText: "loading..." }),
      (c.prototype.setState = function (b) {
        var c = "disabled",
          d = this.$element,
          e = d.is("input") ? "val" : "html",
          f = d.data();
        (b += "Text"),
          null == f.resetText && d.data("resetText", d[e]()),
          setTimeout(
            a.proxy(function () {
              d[e](null == f[b] ? this.options[b] : f[b]),
                "loadingText" == b
                  ? ((this.isLoading = !0),
                    d.addClass(c).attr(c, c).prop(c, !0))
                  : this.isLoading &&
                    ((this.isLoading = !1),
                    d.removeClass(c).removeAttr(c).prop(c, !1));
            }, this),
            0
          );
      }),
      (c.prototype.toggle = function () {
        var a = !0,
          b = this.$element.closest('[data-toggle="buttons"]');
        if (b.length) {
          var c = this.$element.find("input");
          "radio" == c.prop("type")
            ? (c.prop("checked") && (a = !1),
              b.find(".active").removeClass("active"),
              this.$element.addClass("active"))
            : "checkbox" == c.prop("type") &&
              (c.prop("checked") !== this.$element.hasClass("active") &&
                (a = !1),
              this.$element.toggleClass("active")),
            c.prop("checked", this.$element.hasClass("active")),
            a && c.trigger("change");
        } else
          this.$element.attr("aria-pressed", !this.$element.hasClass("active")),
            this.$element.toggleClass("active");
      });
    var d = a.fn.button;
    (a.fn.button = b),
      (a.fn.button.Constructor = c),
      (a.fn.button.noConflict = function () {
        return (a.fn.button = d), this;
      }),
      a(document)
        .on(
          "click.bs.button.data-api",
          '[data-toggle^="button"]',
          function (c) {
            var d = a(c.target).closest(".btn");
            b.call(d, "toggle"),
              a(c.target).is('input[type="radio"], input[type="checkbox"]') ||
                (c.preventDefault(),
                d.is("input,button")
                  ? d.trigger("focus")
                  : d
                      .find("input:visible,button:visible")
                      .first()
                      .trigger("focus"));
          }
        )
        .on(
          "focus.bs.button.data-api blur.bs.button.data-api",
          '[data-toggle^="button"]',
          function (b) {
            a(b.target)
              .closest(".btn")
              .toggleClass("focus", /^focus(in)?$/.test(b.type));
          }
        );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.carousel"),
          f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
          g = "string" == typeof b ? b : f.slide;
        e || d.data("bs.carousel", (e = new c(this, f))),
          "number" == typeof b
            ? e.to(b)
            : g
            ? e[g]()
            : f.interval && e.pause().cycle();
      });
    }
    var c = function (b, c) {
      (this.$element = a(b)),
        (this.$indicators = this.$element.find(".carousel-indicators")),
        (this.options = c),
        (this.paused = null),
        (this.sliding = null),
        (this.interval = null),
        (this.$active = null),
        (this.$items = null),
        this.options.keyboard &&
          this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)),
        "hover" == this.options.pause &&
          !("ontouchstart" in document.documentElement) &&
          this.$element
            .on("mouseenter.bs.carousel", a.proxy(this.pause, this))
            .on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 600),
      (c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }),
      (c.prototype.keydown = function (a) {
        if (!/input|textarea/i.test(a.target.tagName)) {
          switch (a.which) {
            case 37:
              this.prev();
              break;
            case 39:
              this.next();
              break;
            default:
              return;
          }
          a.preventDefault();
        }
      }),
      (c.prototype.cycle = function (b) {
        return (
          b || (this.paused = !1),
          this.interval && clearInterval(this.interval),
          this.options.interval &&
            !this.paused &&
            (this.interval = setInterval(
              a.proxy(this.next, this),
              this.options.interval
            )),
          this
        );
      }),
      (c.prototype.getItemIndex = function (a) {
        return (
          (this.$items = a.parent().children(".item")),
          this.$items.index(a || this.$active)
        );
      }),
      (c.prototype.getItemForDirection = function (a, b) {
        var c = this.getItemIndex(b),
          d =
            ("prev" == a && 0 === c) ||
            ("next" == a && c == this.$items.length - 1);
        if (d && !this.options.wrap) return b;
        var e = "prev" == a ? -1 : 1,
          f = (c + e) % this.$items.length;
        return this.$items.eq(f);
      }),
      (c.prototype.to = function (a) {
        var b = this,
          c = this.getItemIndex(
            (this.$active = this.$element.find(".item.active"))
          );
        if (!(a > this.$items.length - 1 || a < 0))
          return this.sliding
            ? this.$element.one("slid.bs.carousel", function () {
                b.to(a);
              })
            : c == a
            ? this.pause().cycle()
            : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
      }),
      (c.prototype.pause = function (b) {
        return (
          b || (this.paused = !0),
          this.$element.find(".next, .prev").length &&
            a.support.transition &&
            (this.$element.trigger(a.support.transition.end), this.cycle(!0)),
          (this.interval = clearInterval(this.interval)),
          this
        );
      }),
      (c.prototype.next = function () {
        if (!this.sliding) return this.slide("next");
      }),
      (c.prototype.prev = function () {
        if (!this.sliding) return this.slide("prev");
      }),
      (c.prototype.slide = function (b, d) {
        var e = this.$element.find(".item.active"),
          f = d || this.getItemForDirection(b, e),
          g = this.interval,
          h = "next" == b ? "left" : "right",
          i = this;
        if (f.hasClass("active")) return (this.sliding = !1);
        var j = f[0],
          k = a.Event("slide.bs.carousel", { relatedTarget: j, direction: h });
        if ((this.$element.trigger(k), !k.isDefaultPrevented())) {
          if (
            ((this.sliding = !0), g && this.pause(), this.$indicators.length)
          ) {
            this.$indicators.find(".active").removeClass("active");
            var l = a(this.$indicators.children()[this.getItemIndex(f)]);
            l && l.addClass("active");
          }
          var m = a.Event("slid.bs.carousel", {
            relatedTarget: j,
            direction: h,
          });
          return (
            a.support.transition && this.$element.hasClass("slide")
              ? (f.addClass(b),
                f[0].offsetWidth,
                e.addClass(h),
                f.addClass(h),
                e
                  .one("bsTransitionEnd", function () {
                    f.removeClass([b, h].join(" ")).addClass("active"),
                      e.removeClass(["active", h].join(" ")),
                      (i.sliding = !1),
                      setTimeout(function () {
                        i.$element.trigger(m);
                      }, 0);
                  })
                  .emulateTransitionEnd(c.TRANSITION_DURATION))
              : (e.removeClass("active"),
                f.addClass("active"),
                (this.sliding = !1),
                this.$element.trigger(m)),
            g && this.cycle(),
            this
          );
        }
      });
    var d = a.fn.carousel;
    (a.fn.carousel = b),
      (a.fn.carousel.Constructor = c),
      (a.fn.carousel.noConflict = function () {
        return (a.fn.carousel = d), this;
      });
    var e = function (c) {
      var d,
        e = a(this),
        f = a(
          e.attr("data-target") ||
            ((d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""))
        );
      if (f.hasClass("carousel")) {
        var g = a.extend({}, f.data(), e.data()),
          h = e.attr("data-slide-to");
        h && (g.interval = !1),
          b.call(f, g),
          h && f.data("bs.carousel").to(h),
          c.preventDefault();
      }
    };
    a(document)
      .on("click.bs.carousel.data-api", "[data-slide]", e)
      .on("click.bs.carousel.data-api", "[data-slide-to]", e),
      a(window).on("load", function () {
        a('[data-ride="carousel"]').each(function () {
          var c = a(this);
          b.call(c, c.data());
        });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      var c,
        d =
          b.attr("data-target") ||
          ((c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, ""));
      return a(d);
    }
    function c(b) {
      return this.each(function () {
        var c = a(this),
          e = c.data("bs.collapse"),
          f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
        !e && f.toggle && /show|hide/.test(b) && (f.toggle = !1),
          e || c.data("bs.collapse", (e = new d(this, f))),
          "string" == typeof b && e[b]();
      });
    }
    var d = function (b, c) {
      (this.$element = a(b)),
        (this.options = a.extend({}, d.DEFAULTS, c)),
        (this.$trigger = a(
          '[data-toggle="collapse"][href="#' +
            b.id +
            '"],[data-toggle="collapse"][data-target="#' +
            b.id +
            '"]'
        )),
        (this.transitioning = null),
        this.options.parent
          ? (this.$parent = this.getParent())
          : this.addAriaAndCollapsedClass(this.$element, this.$trigger),
        this.options.toggle && this.toggle();
    };
    (d.VERSION = "3.3.7"),
      (d.TRANSITION_DURATION = 350),
      (d.DEFAULTS = { toggle: !0 }),
      (d.prototype.dimension = function () {
        var a = this.$element.hasClass("width");
        return a ? "width" : "height";
      }),
      (d.prototype.show = function () {
        if (!this.transitioning && !this.$element.hasClass("in")) {
          var b,
            e =
              this.$parent &&
              this.$parent.children(".panel").children(".in, .collapsing");
          if (
            !(
              e &&
              e.length &&
              ((b = e.data("bs.collapse")), b && b.transitioning)
            )
          ) {
            var f = a.Event("show.bs.collapse");
            if ((this.$element.trigger(f), !f.isDefaultPrevented())) {
              e &&
                e.length &&
                (c.call(e, "hide"), b || e.data("bs.collapse", null));
              var g = this.dimension();
              this.$element
                .removeClass("collapse")
                .addClass("collapsing")
                [g](0)
                .attr("aria-expanded", !0),
                this.$trigger
                  .removeClass("collapsed")
                  .attr("aria-expanded", !0),
                (this.transitioning = 1);
              var h = function () {
                this.$element
                  .removeClass("collapsing")
                  .addClass("collapse in")
                  [g](""),
                  (this.transitioning = 0),
                  this.$element.trigger("shown.bs.collapse");
              };
              if (!a.support.transition) return h.call(this);
              var i = a.camelCase(["scroll", g].join("-"));
              this.$element
                .one("bsTransitionEnd", a.proxy(h, this))
                .emulateTransitionEnd(d.TRANSITION_DURATION)
                [g](this.$element[0][i]);
            }
          }
        }
      }),
      (d.prototype.hide = function () {
        if (!this.transitioning && this.$element.hasClass("in")) {
          var b = a.Event("hide.bs.collapse");
          if ((this.$element.trigger(b), !b.isDefaultPrevented())) {
            var c = this.dimension();
            this.$element[c](this.$element[c]())[0].offsetHeight,
              this.$element
                .addClass("collapsing")
                .removeClass("collapse in")
                .attr("aria-expanded", !1),
              this.$trigger.addClass("collapsed").attr("aria-expanded", !1),
              (this.transitioning = 1);
            var e = function () {
              (this.transitioning = 0),
                this.$element
                  .removeClass("collapsing")
                  .addClass("collapse")
                  .trigger("hidden.bs.collapse");
            };
            return a.support.transition
              ? void this.$element[c](0)
                  .one("bsTransitionEnd", a.proxy(e, this))
                  .emulateTransitionEnd(d.TRANSITION_DURATION)
              : e.call(this);
          }
        }
      }),
      (d.prototype.toggle = function () {
        this[this.$element.hasClass("in") ? "hide" : "show"]();
      }),
      (d.prototype.getParent = function () {
        return a(this.options.parent)
          .find(
            '[data-toggle="collapse"][data-parent="' +
              this.options.parent +
              '"]'
          )
          .each(
            a.proxy(function (c, d) {
              var e = a(d);
              this.addAriaAndCollapsedClass(b(e), e);
            }, this)
          )
          .end();
      }),
      (d.prototype.addAriaAndCollapsedClass = function (a, b) {
        var c = a.hasClass("in");
        a.attr("aria-expanded", c),
          b.toggleClass("collapsed", !c).attr("aria-expanded", c);
      });
    var e = a.fn.collapse;
    (a.fn.collapse = c),
      (a.fn.collapse.Constructor = d),
      (a.fn.collapse.noConflict = function () {
        return (a.fn.collapse = e), this;
      }),
      a(document).on(
        "click.bs.collapse.data-api",
        '[data-toggle="collapse"]',
        function (d) {
          var e = a(this);
          e.attr("data-target") || d.preventDefault();
          var f = b(e),
            g = f.data("bs.collapse"),
            h = g ? "toggle" : e.data();
          c.call(f, h);
        }
      );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      var c = b.attr("data-target");
      c ||
        ((c = b.attr("href")),
        (c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, "")));
      var d = c && a(c);
      return d && d.length ? d : b.parent();
    }
    function c(c) {
      (c && 3 === c.which) ||
        (a(e).remove(),
        a(f).each(function () {
          var d = a(this),
            e = b(d),
            f = { relatedTarget: this };
          e.hasClass("open") &&
            ((c &&
              "click" == c.type &&
              /input|textarea/i.test(c.target.tagName) &&
              a.contains(e[0], c.target)) ||
              (e.trigger((c = a.Event("hide.bs.dropdown", f))),
              c.isDefaultPrevented() ||
                (d.attr("aria-expanded", "false"),
                e
                  .removeClass("open")
                  .trigger(a.Event("hidden.bs.dropdown", f)))));
        }));
    }
    function d(b) {
      return this.each(function () {
        var c = a(this),
          d = c.data("bs.dropdown");
        d || c.data("bs.dropdown", (d = new g(this))),
          "string" == typeof b && d[b].call(c);
      });
    }
    var e = ".dropdown-backdrop",
      f = '[data-toggle="dropdown"]',
      g = function (b) {
        a(b).on("click.bs.dropdown", this.toggle);
      };
    (g.VERSION = "3.3.7"),
      (g.prototype.toggle = function (d) {
        var e = a(this);
        if (!e.is(".disabled, :disabled")) {
          var f = b(e),
            g = f.hasClass("open");
          if ((c(), !g)) {
            "ontouchstart" in document.documentElement &&
              !f.closest(".navbar-nav").length &&
              a(document.createElement("div"))
                .addClass("dropdown-backdrop")
                .insertAfter(a(this))
                .on("click", c);
            var h = { relatedTarget: this };
            if (
              (f.trigger((d = a.Event("show.bs.dropdown", h))),
              d.isDefaultPrevented())
            )
              return;
            e.trigger("focus").attr("aria-expanded", "true"),
              f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
          }
          return !1;
        }
      }),
      (g.prototype.keydown = function (c) {
        if (
          /(38|40|27|32)/.test(c.which) &&
          !/input|textarea/i.test(c.target.tagName)
        ) {
          var d = a(this);
          if (
            (c.preventDefault(),
            c.stopPropagation(),
            !d.is(".disabled, :disabled"))
          ) {
            var e = b(d),
              g = e.hasClass("open");
            if ((!g && 27 != c.which) || (g && 27 == c.which))
              return (
                27 == c.which && e.find(f).trigger("focus"), d.trigger("click")
              );
            var h = " li:not(.disabled):visible a",
              i = e.find(".dropdown-menu" + h);
            if (i.length) {
              var j = i.index(c.target);
              38 == c.which && j > 0 && j--,
                40 == c.which && j < i.length - 1 && j++,
                ~j || (j = 0),
                i.eq(j).trigger("focus");
            }
          }
        }
      });
    var h = a.fn.dropdown;
    (a.fn.dropdown = d),
      (a.fn.dropdown.Constructor = g),
      (a.fn.dropdown.noConflict = function () {
        return (a.fn.dropdown = h), this;
      }),
      a(document)
        .on("click.bs.dropdown.data-api", c)
        .on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
          a.stopPropagation();
        })
        .on("click.bs.dropdown.data-api", f, g.prototype.toggle)
        .on("keydown.bs.dropdown.data-api", f, g.prototype.keydown)
        .on(
          "keydown.bs.dropdown.data-api",
          ".dropdown-menu",
          g.prototype.keydown
        );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b, d) {
      return this.each(function () {
        var e = a(this),
          f = e.data("bs.modal"),
          g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
        f || e.data("bs.modal", (f = new c(this, g))),
          "string" == typeof b ? f[b](d) : g.show && f.show(d);
      });
    }
    var c = function (b, c) {
      (this.options = c),
        (this.$body = a(document.body)),
        (this.$element = a(b)),
        (this.$dialog = this.$element.find(".modal-dialog")),
        (this.$backdrop = null),
        (this.isShown = null),
        (this.originalBodyPad = null),
        (this.scrollbarWidth = 0),
        (this.ignoreBackdropClick = !1),
        this.options.remote &&
          this.$element.find(".modal-content").load(
            this.options.remote,
            a.proxy(function () {
              this.$element.trigger("loaded.bs.modal");
            }, this)
          );
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 300),
      (c.BACKDROP_TRANSITION_DURATION = 150),
      (c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
      (c.prototype.toggle = function (a) {
        return this.isShown ? this.hide() : this.show(a);
      }),
      (c.prototype.show = function (b) {
        var d = this,
          e = a.Event("show.bs.modal", { relatedTarget: b });
        this.$element.trigger(e),
          this.isShown ||
            e.isDefaultPrevented() ||
            ((this.isShown = !0),
            this.checkScrollbar(),
            this.setScrollbar(),
            this.$body.addClass("modal-open"),
            this.escape(),
            this.resize(),
            this.$element.on(
              "click.dismiss.bs.modal",
              '[data-dismiss="modal"]',
              a.proxy(this.hide, this)
            ),
            this.$dialog.on("mousedown.dismiss.bs.modal", function () {
              d.$element.one("mouseup.dismiss.bs.modal", function (b) {
                a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
              });
            }),
            this.backdrop(function () {
              var e = a.support.transition && d.$element.hasClass("fade");
              d.$element.parent().length || d.$element.appendTo(d.$body),
                d.$element.show().scrollTop(0),
                d.adjustDialog(),
                e && d.$element[0].offsetWidth,
                d.$element.addClass("in"),
                d.enforceFocus();
              var f = a.Event("shown.bs.modal", { relatedTarget: b });
              e
                ? d.$dialog
                    .one("bsTransitionEnd", function () {
                      d.$element.trigger("focus").trigger(f);
                    })
                    .emulateTransitionEnd(c.TRANSITION_DURATION)
                : d.$element.trigger("focus").trigger(f);
            }));
      }),
      (c.prototype.hide = function (b) {
        b && b.preventDefault(),
          (b = a.Event("hide.bs.modal")),
          this.$element.trigger(b),
          this.isShown &&
            !b.isDefaultPrevented() &&
            ((this.isShown = !1),
            this.escape(),
            this.resize(),
            a(document).off("focusin.bs.modal"),
            this.$element
              .removeClass("in")
              .off("click.dismiss.bs.modal")
              .off("mouseup.dismiss.bs.modal"),
            this.$dialog.off("mousedown.dismiss.bs.modal"),
            a.support.transition && this.$element.hasClass("fade")
              ? this.$element
                  .one("bsTransitionEnd", a.proxy(this.hideModal, this))
                  .emulateTransitionEnd(c.TRANSITION_DURATION)
              : this.hideModal());
      }),
      (c.prototype.enforceFocus = function () {
        a(document)
          .off("focusin.bs.modal")
          .on(
            "focusin.bs.modal",
            a.proxy(function (a) {
              document === a.target ||
                this.$element[0] === a.target ||
                this.$element.has(a.target).length ||
                this.$element.trigger("focus");
            }, this)
          );
      }),
      (c.prototype.escape = function () {
        this.isShown && this.options.keyboard
          ? this.$element.on(
              "keydown.dismiss.bs.modal",
              a.proxy(function (a) {
                27 == a.which && this.hide();
              }, this)
            )
          : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
      }),
      (c.prototype.resize = function () {
        this.isShown
          ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this))
          : a(window).off("resize.bs.modal");
      }),
      (c.prototype.hideModal = function () {
        var a = this;
        this.$element.hide(),
          this.backdrop(function () {
            a.$body.removeClass("modal-open"),
              a.resetAdjustments(),
              a.resetScrollbar(),
              a.$element.trigger("hidden.bs.modal");
          });
      }),
      (c.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
      }),
      (c.prototype.backdrop = function (b) {
        var d = this,
          e = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
          var f = a.support.transition && e;
          if (
            ((this.$backdrop = a(document.createElement("div"))
              .addClass("modal-backdrop " + e)
              .appendTo(this.$body)),
            this.$element.on(
              "click.dismiss.bs.modal",
              a.proxy(function (a) {
                return this.ignoreBackdropClick
                  ? void (this.ignoreBackdropClick = !1)
                  : void (
                      a.target === a.currentTarget &&
                      ("static" == this.options.backdrop
                        ? this.$element[0].focus()
                        : this.hide())
                    );
              }, this)
            ),
            f && this.$backdrop[0].offsetWidth,
            this.$backdrop.addClass("in"),
            !b)
          )
            return;
          f
            ? this.$backdrop
                .one("bsTransitionEnd", b)
                .emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION)
            : b();
        } else if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass("in");
          var g = function () {
            d.removeBackdrop(), b && b();
          };
          a.support.transition && this.$element.hasClass("fade")
            ? this.$backdrop
                .one("bsTransitionEnd", g)
                .emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION)
            : g();
        } else b && b();
      }),
      (c.prototype.handleUpdate = function () {
        this.adjustDialog();
      }),
      (c.prototype.adjustDialog = function () {
        var a =
          this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
          paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "",
          paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "",
        });
      }),
      (c.prototype.resetAdjustments = function () {
        this.$element.css({ paddingLeft: "", paddingRight: "" });
      }),
      (c.prototype.checkScrollbar = function () {
        var a = window.innerWidth;
        if (!a) {
          var b = document.documentElement.getBoundingClientRect();
          a = b.right - Math.abs(b.left);
        }
        (this.bodyIsOverflowing = document.body.clientWidth < a),
          (this.scrollbarWidth = this.measureScrollbar());
      }),
      (c.prototype.setScrollbar = function () {
        var a = parseInt(this.$body.css("padding-right") || 0, 10);
        (this.originalBodyPad = document.body.style.paddingRight || ""),
          this.bodyIsOverflowing &&
            this.$body.css("padding-right", a + this.scrollbarWidth);
      }),
      (c.prototype.resetScrollbar = function () {
        this.$body.css("padding-right", this.originalBodyPad);
      }),
      (c.prototype.measureScrollbar = function () {
        var a = document.createElement("div");
        (a.className = "modal-scrollbar-measure"), this.$body.append(a);
        var b = a.offsetWidth - a.clientWidth;
        return this.$body[0].removeChild(a), b;
      });
    var d = a.fn.modal;
    (a.fn.modal = b),
      (a.fn.modal.Constructor = c),
      (a.fn.modal.noConflict = function () {
        return (a.fn.modal = d), this;
      }),
      a(document).on(
        "click.bs.modal.data-api",
        '[data-toggle="modal"]',
        function (c) {
          var d = a(this),
            e = d.attr("href"),
            f = a(
              d.attr("data-target") || (e && e.replace(/.*(?=#[^\s]+$)/, ""))
            ),
            g = f.data("bs.modal")
              ? "toggle"
              : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());
          d.is("a") && c.preventDefault(),
            f.one("show.bs.modal", function (a) {
              a.isDefaultPrevented() ||
                f.one("hidden.bs.modal", function () {
                  d.is(":visible") && d.trigger("focus");
                });
            }),
            b.call(f, g, this);
        }
      );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.tooltip"),
          f = "object" == typeof b && b;
        (!e && /destroy|hide/.test(b)) ||
          (e || d.data("bs.tooltip", (e = new c(this, f))),
          "string" == typeof b && e[b]());
      });
    }
    var c = function (a, b) {
      (this.type = null),
        (this.options = null),
        (this.enabled = null),
        (this.timeout = null),
        (this.hoverState = null),
        (this.$element = null),
        (this.inState = null),
        this.init("tooltip", a, b);
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 150),
      (c.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template:
          '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1,
        viewport: { selector: "body", padding: 0 },
      }),
      (c.prototype.init = function (b, c, d) {
        if (
          ((this.enabled = !0),
          (this.type = b),
          (this.$element = a(c)),
          (this.options = this.getOptions(d)),
          (this.$viewport =
            this.options.viewport &&
            a(
              a.isFunction(this.options.viewport)
                ? this.options.viewport.call(this, this.$element)
                : this.options.viewport.selector || this.options.viewport
            )),
          (this.inState = { click: !1, hover: !1, focus: !1 }),
          this.$element[0] instanceof document.constructor &&
            !this.options.selector)
        )
          throw new Error(
            "`selector` option must be specified when initializing " +
              this.type +
              " on the window.document object!"
          );
        for (var e = this.options.trigger.split(" "), f = e.length; f--; ) {
          var g = e[f];
          if ("click" == g)
            this.$element.on(
              "click." + this.type,
              this.options.selector,
              a.proxy(this.toggle, this)
            );
          else if ("manual" != g) {
            var h = "hover" == g ? "mouseenter" : "focusin",
              i = "hover" == g ? "mouseleave" : "focusout";
            this.$element.on(
              h + "." + this.type,
              this.options.selector,
              a.proxy(this.enter, this)
            ),
              this.$element.on(
                i + "." + this.type,
                this.options.selector,
                a.proxy(this.leave, this)
              );
          }
        }
        this.options.selector
          ? (this._options = a.extend({}, this.options, {
              trigger: "manual",
              selector: "",
            }))
          : this.fixTitle();
      }),
      (c.prototype.getDefaults = function () {
        return c.DEFAULTS;
      }),
      (c.prototype.getOptions = function (b) {
        return (
          (b = a.extend({}, this.getDefaults(), this.$element.data(), b)),
          b.delay &&
            "number" == typeof b.delay &&
            (b.delay = { show: b.delay, hide: b.delay }),
          b
        );
      }),
      (c.prototype.getDelegateOptions = function () {
        var b = {},
          c = this.getDefaults();
        return (
          this._options &&
            a.each(this._options, function (a, d) {
              c[a] != d && (b[a] = d);
            }),
          b
        );
      }),
      (c.prototype.enter = function (b) {
        var c =
          b instanceof this.constructor
            ? b
            : a(b.currentTarget).data("bs." + this.type);
        return (
          c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c)),
          b instanceof a.Event &&
            (c.inState["focusin" == b.type ? "focus" : "hover"] = !0),
          c.tip().hasClass("in") || "in" == c.hoverState
            ? void (c.hoverState = "in")
            : (clearTimeout(c.timeout),
              (c.hoverState = "in"),
              c.options.delay && c.options.delay.show
                ? void (c.timeout = setTimeout(function () {
                    "in" == c.hoverState && c.show();
                  }, c.options.delay.show))
                : c.show())
        );
      }),
      (c.prototype.isInStateTrue = function () {
        for (var a in this.inState) if (this.inState[a]) return !0;
        return !1;
      }),
      (c.prototype.leave = function (b) {
        var c =
          b instanceof this.constructor
            ? b
            : a(b.currentTarget).data("bs." + this.type);
        if (
          (c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c)),
          b instanceof a.Event &&
            (c.inState["focusout" == b.type ? "focus" : "hover"] = !1),
          !c.isInStateTrue())
        )
          return (
            clearTimeout(c.timeout),
            (c.hoverState = "out"),
            c.options.delay && c.options.delay.hide
              ? void (c.timeout = setTimeout(function () {
                  "out" == c.hoverState && c.hide();
                }, c.options.delay.hide))
              : c.hide()
          );
      }),
      (c.prototype.show = function () {
        var b = a.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
          this.$element.trigger(b);
          var d = a.contains(
            this.$element[0].ownerDocument.documentElement,
            this.$element[0]
          );
          if (b.isDefaultPrevented() || !d) return;
          var e = this,
            f = this.tip(),
            g = this.getUID(this.type);
          this.setContent(),
            f.attr("id", g),
            this.$element.attr("aria-describedby", g),
            this.options.animation && f.addClass("fade");
          var h =
              "function" == typeof this.options.placement
                ? this.options.placement.call(this, f[0], this.$element[0])
                : this.options.placement,
            i = /\s?auto?\s?/i,
            j = i.test(h);
          j && (h = h.replace(i, "") || "top"),
            f
              .detach()
              .css({ top: 0, left: 0, display: "block" })
              .addClass(h)
              .data("bs." + this.type, this),
            this.options.container
              ? f.appendTo(this.options.container)
              : f.insertAfter(this.$element),
            this.$element.trigger("inserted.bs." + this.type);
          var k = this.getPosition(),
            l = f[0].offsetWidth,
            m = f[0].offsetHeight;
          if (j) {
            var n = h,
              o = this.getPosition(this.$viewport);
            (h =
              "bottom" == h && k.bottom + m > o.bottom
                ? "top"
                : "top" == h && k.top - m < o.top
                ? "bottom"
                : "right" == h && k.right + l > o.width
                ? "left"
                : "left" == h && k.left - l < o.left
                ? "right"
                : h),
              f.removeClass(n).addClass(h);
          }
          var p = this.getCalculatedOffset(h, k, l, m);
          this.applyPlacement(p, h);
          var q = function () {
            var a = e.hoverState;
            e.$element.trigger("shown.bs." + e.type),
              (e.hoverState = null),
              "out" == a && e.leave(e);
          };
          a.support.transition && this.$tip.hasClass("fade")
            ? f
                .one("bsTransitionEnd", q)
                .emulateTransitionEnd(c.TRANSITION_DURATION)
            : q();
        }
      }),
      (c.prototype.applyPlacement = function (b, c) {
        var d = this.tip(),
          e = d[0].offsetWidth,
          f = d[0].offsetHeight,
          g = parseInt(d.css("margin-top"), 10),
          h = parseInt(d.css("margin-left"), 10);
        isNaN(g) && (g = 0),
          isNaN(h) && (h = 0),
          (b.top += g),
          (b.left += h),
          a.offset.setOffset(
            d[0],
            a.extend(
              {
                using: function (a) {
                  d.css({ top: Math.round(a.top), left: Math.round(a.left) });
                },
              },
              b
            ),
            0
          ),
          d.addClass("in");
        var i = d[0].offsetWidth,
          j = d[0].offsetHeight;
        "top" == c && j != f && (b.top = b.top + f - j);
        var k = this.getViewportAdjustedDelta(c, b, i, j);
        k.left ? (b.left += k.left) : (b.top += k.top);
        var l = /top|bottom/.test(c),
          m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
          n = l ? "offsetWidth" : "offsetHeight";
        d.offset(b), this.replaceArrow(m, d[0][n], l);
      }),
      (c.prototype.replaceArrow = function (a, b, c) {
        this.arrow()
          .css(c ? "left" : "top", 50 * (1 - a / b) + "%")
          .css(c ? "top" : "left", "");
      }),
      (c.prototype.setContent = function () {
        var a = this.tip(),
          b = this.getTitle();
        a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b),
          a.removeClass("fade in top bottom left right");
      }),
      (c.prototype.hide = function (b) {
        function d() {
          "in" != e.hoverState && f.detach(),
            e.$element &&
              e.$element
                .removeAttr("aria-describedby")
                .trigger("hidden.bs." + e.type),
            b && b();
        }
        var e = this,
          f = a(this.$tip),
          g = a.Event("hide.bs." + this.type);
        if ((this.$element.trigger(g), !g.isDefaultPrevented()))
          return (
            f.removeClass("in"),
            a.support.transition && f.hasClass("fade")
              ? f
                  .one("bsTransitionEnd", d)
                  .emulateTransitionEnd(c.TRANSITION_DURATION)
              : d(),
            (this.hoverState = null),
            this
          );
      }),
      (c.prototype.fixTitle = function () {
        var a = this.$element;
        (a.attr("title") || "string" != typeof a.attr("data-original-title")) &&
          a
            .attr("data-original-title", a.attr("title") || "")
            .attr("title", "");
      }),
      (c.prototype.hasContent = function () {
        return this.getTitle();
      }),
      (c.prototype.getPosition = function (b) {
        b = b || this.$element;
        var c = b[0],
          d = "BODY" == c.tagName,
          e = c.getBoundingClientRect();
        null == e.width &&
          (e = a.extend({}, e, {
            width: e.right - e.left,
            height: e.bottom - e.top,
          }));
        var f = window.SVGElement && c instanceof window.SVGElement,
          g = d ? { top: 0, left: 0 } : f ? null : b.offset(),
          h = {
            scroll: d
              ? document.documentElement.scrollTop || document.body.scrollTop
              : b.scrollTop(),
          },
          i = d
            ? { width: a(window).width(), height: a(window).height() }
            : null;
        return a.extend({}, e, h, i, g);
      }),
      (c.prototype.getCalculatedOffset = function (a, b, c, d) {
        return "bottom" == a
          ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 }
          : "top" == a
          ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 }
          : "left" == a
          ? { top: b.top + b.height / 2 - d / 2, left: b.left - c }
          : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
      }),
      (c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
        var e = { top: 0, left: 0 };
        if (!this.$viewport) return e;
        var f = (this.options.viewport && this.options.viewport.padding) || 0,
          g = this.getPosition(this.$viewport);
        if (/right|left/.test(a)) {
          var h = b.top - f - g.scroll,
            i = b.top + f - g.scroll + d;
          h < g.top
            ? (e.top = g.top - h)
            : i > g.top + g.height && (e.top = g.top + g.height - i);
        } else {
          var j = b.left - f,
            k = b.left + f + c;
          j < g.left
            ? (e.left = g.left - j)
            : k > g.right && (e.left = g.left + g.width - k);
        }
        return e;
      }),
      (c.prototype.getTitle = function () {
        var a,
          b = this.$element,
          c = this.options;
        return (a =
          b.attr("data-original-title") ||
          ("function" == typeof c.title ? c.title.call(b[0]) : c.title));
      }),
      (c.prototype.getUID = function (a) {
        do a += ~~(1e6 * Math.random());
        while (document.getElementById(a));
        return a;
      }),
      (c.prototype.tip = function () {
        if (
          !this.$tip &&
          ((this.$tip = a(this.options.template)), 1 != this.$tip.length)
        )
          throw new Error(
            this.type +
              " `template` option must consist of exactly 1 top-level element!"
          );
        return this.$tip;
      }),
      (c.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
      }),
      (c.prototype.enable = function () {
        this.enabled = !0;
      }),
      (c.prototype.disable = function () {
        this.enabled = !1;
      }),
      (c.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled;
      }),
      (c.prototype.toggle = function (b) {
        var c = this;
        b &&
          ((c = a(b.currentTarget).data("bs." + this.type)),
          c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c))),
          b
            ? ((c.inState.click = !c.inState.click),
              c.isInStateTrue() ? c.enter(c) : c.leave(c))
            : c.tip().hasClass("in")
            ? c.leave(c)
            : c.enter(c);
      }),
      (c.prototype.destroy = function () {
        var a = this;
        clearTimeout(this.timeout),
          this.hide(function () {
            a.$element.off("." + a.type).removeData("bs." + a.type),
              a.$tip && a.$tip.detach(),
              (a.$tip = null),
              (a.$arrow = null),
              (a.$viewport = null),
              (a.$element = null);
          });
      });
    var d = a.fn.tooltip;
    (a.fn.tooltip = b),
      (a.fn.tooltip.Constructor = c),
      (a.fn.tooltip.noConflict = function () {
        return (a.fn.tooltip = d), this;
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.popover"),
          f = "object" == typeof b && b;
        (!e && /destroy|hide/.test(b)) ||
          (e || d.data("bs.popover", (e = new c(this, f))),
          "string" == typeof b && e[b]());
      });
    }
    var c = function (a, b) {
      this.init("popover", a, b);
    };
    if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
    (c.VERSION = "3.3.7"),
      (c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template:
          '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
      })),
      (c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype)),
      (c.prototype.constructor = c),
      (c.prototype.getDefaults = function () {
        return c.DEFAULTS;
      }),
      (c.prototype.setContent = function () {
        var a = this.tip(),
          b = this.getTitle(),
          c = this.getContent();
        a.find(".popover-title")[this.options.html ? "html" : "text"](b),
          a
            .find(".popover-content")
            .children()
            .detach()
            .end()
            [
              this.options.html
                ? "string" == typeof c
                  ? "html"
                  : "append"
                : "text"
            ](c),
          a.removeClass("fade top bottom left right in"),
          a.find(".popover-title").html() || a.find(".popover-title").hide();
      }),
      (c.prototype.hasContent = function () {
        return this.getTitle() || this.getContent();
      }),
      (c.prototype.getContent = function () {
        var a = this.$element,
          b = this.options;
        return (
          a.attr("data-content") ||
          ("function" == typeof b.content ? b.content.call(a[0]) : b.content)
        );
      }),
      (c.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
      });
    var d = a.fn.popover;
    (a.fn.popover = b),
      (a.fn.popover.Constructor = c),
      (a.fn.popover.noConflict = function () {
        return (a.fn.popover = d), this;
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(c, d) {
      (this.$body = a(document.body)),
        (this.$scrollElement = a(a(c).is(document.body) ? window : c)),
        (this.options = a.extend({}, b.DEFAULTS, d)),
        (this.selector = (this.options.target || "") + " .nav li > a"),
        (this.offsets = []),
        (this.targets = []),
        (this.activeTarget = null),
        (this.scrollHeight = 0),
        this.$scrollElement.on(
          "scroll.bs.scrollspy",
          a.proxy(this.process, this)
        ),
        this.refresh(),
        this.process();
    }
    function c(c) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.scrollspy"),
          f = "object" == typeof c && c;
        e || d.data("bs.scrollspy", (e = new b(this, f))),
          "string" == typeof c && e[c]();
      });
    }
    (b.VERSION = "3.3.7"),
      (b.DEFAULTS = { offset: 10 }),
      (b.prototype.getScrollHeight = function () {
        return (
          this.$scrollElement[0].scrollHeight ||
          Math.max(
            this.$body[0].scrollHeight,
            document.documentElement.scrollHeight
          )
        );
      }),
      (b.prototype.refresh = function () {
        var b = this,
          c = "offset",
          d = 0;
        (this.offsets = []),
          (this.targets = []),
          (this.scrollHeight = this.getScrollHeight()),
          a.isWindow(this.$scrollElement[0]) ||
            ((c = "position"), (d = this.$scrollElement.scrollTop())),
          this.$body
            .find(this.selector)
            .map(function () {
              var b = a(this),
                e = b.data("target") || b.attr("href"),
                f = /^#./.test(e) && a(e);
              return (
                (f && f.length && f.is(":visible") && [[f[c]().top + d, e]]) ||
                null
              );
            })
            .sort(function (a, b) {
              return a[0] - b[0];
            })
            .each(function () {
              b.offsets.push(this[0]), b.targets.push(this[1]);
            });
      }),
      (b.prototype.process = function () {
        var a,
          b = this.$scrollElement.scrollTop() + this.options.offset,
          c = this.getScrollHeight(),
          d = this.options.offset + c - this.$scrollElement.height(),
          e = this.offsets,
          f = this.targets,
          g = this.activeTarget;
        if ((this.scrollHeight != c && this.refresh(), b >= d))
          return g != (a = f[f.length - 1]) && this.activate(a);
        if (g && b < e[0]) return (this.activeTarget = null), this.clear();
        for (a = e.length; a--; )
          g != f[a] &&
            b >= e[a] &&
            (void 0 === e[a + 1] || b < e[a + 1]) &&
            this.activate(f[a]);
      }),
      (b.prototype.activate = function (b) {
        (this.activeTarget = b), this.clear();
        var c =
            this.selector +
            '[data-target="' +
            b +
            '"],' +
            this.selector +
            '[href="' +
            b +
            '"]',
          d = a(c).parents("li").addClass("active");
        d.parent(".dropdown-menu").length &&
          (d = d.closest("li.dropdown").addClass("active")),
          d.trigger("activate.bs.scrollspy");
      }),
      (b.prototype.clear = function () {
        a(this.selector)
          .parentsUntil(this.options.target, ".active")
          .removeClass("active");
      });
    var d = a.fn.scrollspy;
    (a.fn.scrollspy = c),
      (a.fn.scrollspy.Constructor = b),
      (a.fn.scrollspy.noConflict = function () {
        return (a.fn.scrollspy = d), this;
      }),
      a(window).on("load.bs.scrollspy.data-api", function () {
        a('[data-spy="scroll"]').each(function () {
          var b = a(this);
          c.call(b, b.data());
        });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.tab");
        e || d.data("bs.tab", (e = new c(this))),
          "string" == typeof b && e[b]();
      });
    }
    var c = function (b) {
      this.element = a(b);
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 150),
      (c.prototype.show = function () {
        var b = this.element,
          c = b.closest("ul:not(.dropdown-menu)"),
          d = b.data("target");
        if (
          (d ||
            ((d = b.attr("href")), (d = d && d.replace(/.*(?=#[^\s]*$)/, ""))),
          !b.parent("li").hasClass("active"))
        ) {
          var e = c.find(".active:last a"),
            f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
            g = a.Event("show.bs.tab", { relatedTarget: e[0] });
          if (
            (e.trigger(f),
            b.trigger(g),
            !g.isDefaultPrevented() && !f.isDefaultPrevented())
          ) {
            var h = a(d);
            this.activate(b.closest("li"), c),
              this.activate(h, h.parent(), function () {
                e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }),
                  b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
              });
          }
        }
      }),
      (c.prototype.activate = function (b, d, e) {
        function f() {
          g
            .removeClass("active")
            .find("> .dropdown-menu > .active")
            .removeClass("active")
            .end()
            .find('[data-toggle="tab"]')
            .attr("aria-expanded", !1),
            b
              .addClass("active")
              .find('[data-toggle="tab"]')
              .attr("aria-expanded", !0),
            h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"),
            b.parent(".dropdown-menu").length &&
              b
                .closest("li.dropdown")
                .addClass("active")
                .end()
                .find('[data-toggle="tab"]')
                .attr("aria-expanded", !0),
            e && e();
        }
        var g = d.find("> .active"),
          h =
            e &&
            a.support.transition &&
            ((g.length && g.hasClass("fade")) || !!d.find("> .fade").length);
        g.length && h
          ? g
              .one("bsTransitionEnd", f)
              .emulateTransitionEnd(c.TRANSITION_DURATION)
          : f(),
          g.removeClass("in");
      });
    var d = a.fn.tab;
    (a.fn.tab = b),
      (a.fn.tab.Constructor = c),
      (a.fn.tab.noConflict = function () {
        return (a.fn.tab = d), this;
      });
    var e = function (c) {
      c.preventDefault(), b.call(a(this), "show");
    };
    a(document)
      .on("click.bs.tab.data-api", '[data-toggle="tab"]', e)
      .on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.affix"),
          f = "object" == typeof b && b;
        e || d.data("bs.affix", (e = new c(this, f))),
          "string" == typeof b && e[b]();
      });
    }
    var c = function (b, d) {
      (this.options = a.extend({}, c.DEFAULTS, d)),
        (this.$target = a(this.options.target)
          .on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this))
          .on(
            "click.bs.affix.data-api",
            a.proxy(this.checkPositionWithEventLoop, this)
          )),
        (this.$element = a(b)),
        (this.affixed = null),
        (this.unpin = null),
        (this.pinnedOffset = null),
        this.checkPosition();
    };
    (c.VERSION = "3.3.7"),
      (c.RESET = "affix affix-top affix-bottom"),
      (c.DEFAULTS = { offset: 0, target: window }),
      (c.prototype.getState = function (a, b, c, d) {
        var e = this.$target.scrollTop(),
          f = this.$element.offset(),
          g = this.$target.height();
        if (null != c && "top" == this.affixed) return e < c && "top";
        if ("bottom" == this.affixed)
          return null != c
            ? !(e + this.unpin <= f.top) && "bottom"
            : !(e + g <= a - d) && "bottom";
        var h = null == this.affixed,
          i = h ? e : f.top,
          j = h ? g : b;
        return null != c && e <= c
          ? "top"
          : null != d && i + j >= a - d && "bottom";
      }),
      (c.prototype.getPinnedOffset = function () {
        if (this.pinnedOffset) return this.pinnedOffset;
        this.$element.removeClass(c.RESET).addClass("affix");
        var a = this.$target.scrollTop(),
          b = this.$element.offset();
        return (this.pinnedOffset = b.top - a);
      }),
      (c.prototype.checkPositionWithEventLoop = function () {
        setTimeout(a.proxy(this.checkPosition, this), 1);
      }),
      (c.prototype.checkPosition = function () {
        if (this.$element.is(":visible")) {
          var b = this.$element.height(),
            d = this.options.offset,
            e = d.top,
            f = d.bottom,
            g = Math.max(a(document).height(), a(document.body).height());
          "object" != typeof d && (f = e = d),
            "function" == typeof e && (e = d.top(this.$element)),
            "function" == typeof f && (f = d.bottom(this.$element));
          var h = this.getState(g, b, e, f);
          if (this.affixed != h) {
            null != this.unpin && this.$element.css("top", "");
            var i = "affix" + (h ? "-" + h : ""),
              j = a.Event(i + ".bs.affix");
            if ((this.$element.trigger(j), j.isDefaultPrevented())) return;
            (this.affixed = h),
              (this.unpin = "bottom" == h ? this.getPinnedOffset() : null),
              this.$element
                .removeClass(c.RESET)
                .addClass(i)
                .trigger(i.replace("affix", "affixed") + ".bs.affix");
          }
          "bottom" == h && this.$element.offset({ top: g - b - f });
        }
      });
    var d = a.fn.affix;
    (a.fn.affix = b),
      (a.fn.affix.Constructor = c),
      (a.fn.affix.noConflict = function () {
        return (a.fn.affix = d), this;
      }),
      a(window).on("load", function () {
        a('[data-spy="affix"]').each(function () {
          var c = a(this),
            d = c.data();
          (d.offset = d.offset || {}),
            null != d.offsetBottom && (d.offset.bottom = d.offsetBottom),
            null != d.offsetTop && (d.offset.top = d.offsetTop),
            b.call(c, d);
        });
      });
  })(jQuery);

/*!
 * Validator v0.11.9 for Bootstrap 3, by @1000hz
 * Copyright 2017 Cina Saffary
 * Licensed under http://opensource.org/licenses/MIT
 *
 * https://github.com/1000hz/bootstrap-validator
 */
+(function (a) {
  "use strict";
  function b(b) {
    return b.is('[type="checkbox"]')
      ? b.prop("checked")
      : b.is('[type="radio"]')
      ? !!a('[name="' + b.attr("name") + '"]:checked').length
      : b.is("select[multiple]")
      ? (b.val() || []).length
      : b.val();
  }
  function c(b) {
    return this.each(function () {
      var c = a(this),
        e = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b),
        f = c.data("bs.validator");
      (f || "destroy" != b) &&
        (f || c.data("bs.validator", (f = new d(this, e))),
        "string" == typeof b && f[b]());
    });
  }
  var d = function (c, e) {
    (this.options = e),
      (this.validators = a.extend({}, d.VALIDATORS, e.custom)),
      (this.$element = a(c)),
      (this.$btn = a('button[type="submit"], input[type="submit"]')
        .filter('[form="' + this.$element.attr("id") + '"]')
        .add(
          this.$element.find('input[type="submit"], button[type="submit"]')
        )),
      this.update(),
      this.$element.on(
        "input.bs.validator change.bs.validator focusout.bs.validator",
        a.proxy(this.onInput, this)
      ),
      this.$element.on("submit.bs.validator", a.proxy(this.onSubmit, this)),
      this.$element.on("reset.bs.validator", a.proxy(this.reset, this)),
      this.$element.find("[data-match]").each(function () {
        var c = a(this),
          d = c.attr("data-match");
        a(d).on("input.bs.validator", function () {
          b(c) && c.trigger("input.bs.validator");
        });
      }),
      this.$inputs
        .filter(function () {
          return b(a(this)) && !a(this).closest(".has-error").length;
        })
        .trigger("focusout"),
      this.$element.attr("novalidate", !0);
  };
  (d.VERSION = "0.11.9"),
    (d.INPUT_SELECTOR =
      ':input:not([type="hidden"], [type="submit"], [type="reset"], button)'),
    (d.FOCUS_OFFSET = 20),
    (d.DEFAULTS = {
      delay: 500,
      html: !1,
      disable: !0,
      focus: !0,
      custom: {},
      errors: { match: "Does not match", minlength: "Not long enough" },
      feedback: { success: "glyphicon-ok", error: "glyphicon-remove" },
    }),
    (d.VALIDATORS = {
      native: function (a) {
        var b = a[0];
        return b.checkValidity
          ? !b.checkValidity() &&
              !b.validity.valid &&
              (b.validationMessage || "error!")
          : void 0;
      },
      match: function (b) {
        var c = b.attr("data-match");
        return b.val() !== a(c).val() && d.DEFAULTS.errors.match;
      },
      minlength: function (a) {
        var b = a.attr("data-minlength");
        return a.val().length < b && d.DEFAULTS.errors.minlength;
      },
    }),
    (d.prototype.update = function () {
      var b = this;
      return (
        (this.$inputs = this.$element
          .find(d.INPUT_SELECTOR)
          .add(this.$element.find('[data-validate="true"]'))
          .not(
            this.$element.find('[data-validate="false"]').each(function () {
              b.clearErrors(a(this));
            })
          )),
        this.toggleSubmit(),
        this
      );
    }),
    (d.prototype.onInput = function (b) {
      var c = this,
        d = a(b.target),
        e = "focusout" !== b.type;
      this.$inputs.is(d) &&
        this.validateInput(d, e).done(function () {
          c.toggleSubmit();
        });
    }),
    (d.prototype.validateInput = function (c, d) {
      var e = (b(c), c.data("bs.validator.errors"));
      c.is('[type="radio"]') &&
        (c = this.$element.find('input[name="' + c.attr("name") + '"]'));
      var f = a.Event("validate.bs.validator", { relatedTarget: c[0] });
      if ((this.$element.trigger(f), !f.isDefaultPrevented())) {
        var g = this;
        return this.runValidators(c).done(function (b) {
          c.data("bs.validator.errors", b),
            b.length
              ? d
                ? g.defer(c, g.showErrors)
                : g.showErrors(c)
              : g.clearErrors(c),
            (e && b.toString() === e.toString()) ||
              ((f = b.length
                ? a.Event("invalid.bs.validator", {
                    relatedTarget: c[0],
                    detail: b,
                  })
                : a.Event("valid.bs.validator", {
                    relatedTarget: c[0],
                    detail: e,
                  })),
              g.$element.trigger(f)),
            g.toggleSubmit(),
            g.$element.trigger(
              a.Event("validated.bs.validator", { relatedTarget: c[0] })
            );
        });
      }
    }),
    (d.prototype.runValidators = function (c) {
      function d(a) {
        return c.attr("data-" + a + "-error");
      }
      function e() {
        var a = c[0].validity;
        return a.typeMismatch
          ? c.attr("data-type-error")
          : a.patternMismatch
          ? c.attr("data-pattern-error")
          : a.stepMismatch
          ? c.attr("data-step-error")
          : a.rangeOverflow
          ? c.attr("data-max-error")
          : a.rangeUnderflow
          ? c.attr("data-min-error")
          : a.valueMissing
          ? c.attr("data-required-error")
          : null;
      }
      function f() {
        return c.attr("data-error");
      }
      function g(a) {
        return d(a) || e() || f();
      }
      var h = [],
        i = a.Deferred();
      return (
        c.data("bs.validator.deferred") &&
          c.data("bs.validator.deferred").reject(),
        c.data("bs.validator.deferred", i),
        a.each(
          this.validators,
          a.proxy(function (a, d) {
            var e = null;
            (!b(c) && !c.attr("required")) ||
              (void 0 === c.attr("data-" + a) && "native" != a) ||
              !(e = d.call(this, c)) ||
              ((e = g(a) || e), !~h.indexOf(e) && h.push(e));
          }, this)
        ),
        !h.length && b(c) && c.attr("data-remote")
          ? this.defer(c, function () {
              var d = {};
              (d[c.attr("name")] = b(c)),
                a
                  .get(c.attr("data-remote"), d)
                  .fail(function (a, b, c) {
                    h.push(g("remote") || c);
                  })
                  .always(function () {
                    i.resolve(h);
                  });
            })
          : i.resolve(h),
        i.promise()
      );
    }),
    (d.prototype.validate = function () {
      var b = this;
      return (
        a
          .when(
            this.$inputs.map(function () {
              return b.validateInput(a(this), !1);
            })
          )
          .then(function () {
            b.toggleSubmit(), b.focusError();
          }),
        this
      );
    }),
    (d.prototype.focusError = function () {
      if (this.options.focus) {
        var b = this.$element.find(".has-error:first :input");
        0 !== b.length &&
          (a("html, body").animate(
            { scrollTop: b.offset().top - d.FOCUS_OFFSET },
            250
          ),
          b.focus());
      }
    }),
    (d.prototype.showErrors = function (b) {
      var c = this.options.html ? "html" : "text",
        d = b.data("bs.validator.errors"),
        e = b.closest(".form-group"),
        f = e.find(".help-block.with-errors"),
        g = e.find(".form-control-feedback");
      d.length &&
        ((d = a("<ul/>")
          .addClass("list-unstyled")
          .append(
            a.map(d, function (b) {
              return a("<li/>")[c](b);
            })
          )),
        void 0 === f.data("bs.validator.originalContent") &&
          f.data("bs.validator.originalContent", f.html()),
        f.empty().append(d),
        e.addClass("has-error has-danger"),
        e.hasClass("has-feedback") &&
          g.removeClass(this.options.feedback.success) &&
          g.addClass(this.options.feedback.error) &&
          e.removeClass("has-success"));
    }),
    (d.prototype.clearErrors = function (a) {
      var c = a.closest(".form-group"),
        d = c.find(".help-block.with-errors"),
        e = c.find(".form-control-feedback");
      d.html(d.data("bs.validator.originalContent")),
        c.removeClass("has-error has-danger has-success"),
        c.hasClass("has-feedback") &&
          e.removeClass(this.options.feedback.error) &&
          e.removeClass(this.options.feedback.success) &&
          b(a) &&
          e.addClass(this.options.feedback.success) &&
          c.addClass("has-success");
    }),
    (d.prototype.hasErrors = function () {
      function b() {
        return !!(a(this).data("bs.validator.errors") || []).length;
      }
      return !!this.$inputs.filter(b).length;
    }),
    (d.prototype.isIncomplete = function () {
      function c() {
        var c = b(a(this));
        return !("string" == typeof c ? a.trim(c) : c);
      }
      return !!this.$inputs.filter("[required]").filter(c).length;
    }),
    (d.prototype.onSubmit = function (a) {
      this.validate(),
        (this.isIncomplete() || this.hasErrors()) && a.preventDefault();
    }),
    (d.prototype.toggleSubmit = function () {
      this.options.disable &&
        this.$btn.toggleClass(
          "disabled",
          this.isIncomplete() || this.hasErrors()
        );
    }),
    (d.prototype.defer = function (b, c) {
      return (
        (c = a.proxy(c, this, b)),
        this.options.delay
          ? (window.clearTimeout(b.data("bs.validator.timeout")),
            void b.data(
              "bs.validator.timeout",
              window.setTimeout(c, this.options.delay)
            ))
          : c()
      );
    }),
    (d.prototype.reset = function () {
      return (
        this.$element
          .find(".form-control-feedback")
          .removeClass(this.options.feedback.error)
          .removeClass(this.options.feedback.success),
        this.$inputs
          .removeData(["bs.validator.errors", "bs.validator.deferred"])
          .each(function () {
            var b = a(this),
              c = b.data("bs.validator.timeout");
            window.clearTimeout(c) && b.removeData("bs.validator.timeout");
          }),
        this.$element.find(".help-block.with-errors").each(function () {
          var b = a(this),
            c = b.data("bs.validator.originalContent");
          b.removeData("bs.validator.originalContent").html(c);
        }),
        this.$btn.removeClass("disabled"),
        this.$element
          .find(".has-error, .has-danger, .has-success")
          .removeClass("has-error has-danger has-success"),
        this
      );
    }),
    (d.prototype.destroy = function () {
      return (
        this.reset(),
        this.$element
          .removeAttr("novalidate")
          .removeData("bs.validator")
          .off(".bs.validator"),
        this.$inputs.off(".bs.validator"),
        (this.options = null),
        (this.validators = null),
        (this.$element = null),
        (this.$btn = null),
        (this.$inputs = null),
        this
      );
    });
  var e = a.fn.validator;
  (a.fn.validator = c),
    (a.fn.validator.Constructor = d),
    (a.fn.validator.noConflict = function () {
      return (a.fn.validator = e), this;
    }),
    a(window).on("load", function () {
      a('form[data-toggle="validator"]').each(function () {
        var b = a(this);
        c.call(b, b.data());
      });
    });
})(jQuery);

!(function () {
  var loadScript = function (url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    // If the browser is Internet Explorer.
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
      // For any other browser.
    } else {
      script.onload = function () {
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  /* This is my app's JavaScript */
  var zifyfaqJS = function (jQuery) {
    var B64 = {
      alphabet:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      lookup: null,
      ie: /MSIE /.test(navigator.userAgent),
      ieo: /MSIE [67]/.test(navigator.userAgent),
      encode: function (a) {
        var e,
          f,
          g,
          b = B64.toUtf8(a),
          c = -1,
          d = b.length,
          h = [, ,];
        if (B64.ie) {
          for (var i = []; ++c < d; )
            (e = b[c]),
              (f = b[++c]),
              (h[0] = e >> 2),
              (h[1] = ((3 & e) << 4) | (f >> 4)),
              isNaN(f)
                ? (h[2] = h[3] = 64)
                : ((g = b[++c]),
                  (h[2] = ((15 & f) << 2) | (g >> 6)),
                  (h[3] = isNaN(g) ? 64 : 63 & g)),
              i.push(
                B64.alphabet.charAt(h[0]),
                B64.alphabet.charAt(h[1]),
                B64.alphabet.charAt(h[2]),
                B64.alphabet.charAt(h[3])
              );
          return i.join("");
        }
        for (var i = ""; ++c < d; )
          (e = b[c]),
            (f = b[++c]),
            (h[0] = e >> 2),
            (h[1] = ((3 & e) << 4) | (f >> 4)),
            isNaN(f)
              ? (h[2] = h[3] = 64)
              : ((g = b[++c]),
                (h[2] = ((15 & f) << 2) | (g >> 6)),
                (h[3] = isNaN(g) ? 64 : 63 & g)),
            (i +=
              B64.alphabet[h[0]] +
              B64.alphabet[h[1]] +
              B64.alphabet[h[2]] +
              B64.alphabet[h[3]]);
        return i;
      },
      decode: function (a) {
        if (a.length % 4)
          throw new Error(
            "InvalidCharacterError: 'B64.decode' failed: The string to be decoded is not correctly encoded."
          );
        var b = B64.fromUtf8(a),
          c = 0,
          d = b.length;
        if (B64.ieo) {
          for (var e = []; d > c; )
            b[c] < 128
              ? e.push(String.fromCharCode(b[c++]))
              : b[c] > 191 && b[c] < 224
              ? e.push(
                  String.fromCharCode(((31 & b[c++]) << 6) | (63 & b[c++]))
                )
              : e.push(
                  String.fromCharCode(
                    ((15 & b[c++]) << 12) | ((63 & b[c++]) << 6) | (63 & b[c++])
                  )
                );
          return e.join("");
        }
        for (var e = ""; d > c; )
          e +=
            b[c] < 128
              ? String.fromCharCode(b[c++])
              : b[c] > 191 && b[c] < 224
              ? String.fromCharCode(((31 & b[c++]) << 6) | (63 & b[c++]))
              : String.fromCharCode(
                  ((15 & b[c++]) << 12) | ((63 & b[c++]) << 6) | (63 & b[c++])
                );
        return e;
      },
      toUtf8: function (a) {
        var d,
          b = -1,
          c = a.length,
          e = [];
        if (/^[\x00-\x7f]*$/.test(a)) for (; ++b < c; ) e.push(a.charCodeAt(b));
        else
          for (; ++b < c; )
            (d = a.charCodeAt(b)),
              128 > d
                ? e.push(d)
                : 2048 > d
                ? e.push(192 | (d >> 6), 128 | (63 & d))
                : e.push(
                    224 | (d >> 12),
                    128 | (63 & (d >> 6)),
                    128 | (63 & d)
                  );
        return e;
      },
      fromUtf8: function (a) {
        var c,
          b = -1,
          d = [],
          e = [, ,];
        if (!B64.lookup) {
          for (c = B64.alphabet.length, B64.lookup = {}; ++b < c; )
            B64.lookup[B64.alphabet.charAt(b)] = b;
          b = -1;
        }
        for (
          c = a.length;
          ++b < c &&
          ((e[0] = B64.lookup[a.charAt(b)]),
          (e[1] = B64.lookup[a.charAt(++b)]),
          d.push((e[0] << 2) | (e[1] >> 4)),
          (e[2] = B64.lookup[a.charAt(++b)]),
          64 != e[2]) &&
          (d.push(((15 & e[1]) << 4) | (e[2] >> 2)),
          (e[3] = B64.lookup[a.charAt(++b)]),
          64 != e[3]);

        )
          d.push(((3 & e[2]) << 6) | e[3]);
        return d;
      },
    };
    var faqs_data_response = JSON.parse(B64.decode(zify_faq_data));
    var zify_faq_category_data_response = JSON.parse(
      B64.decode(zify_faq_category_data)
    );

    var replacer = function (finder, element, blackList) {
      if (!finder) {
        return;
      }
      var regex = typeof finder == "string" ? new RegExp(finder, "g") : finder;
      var regex2 = typeof finder == "string" ? new RegExp(finder, "g") : finder;
      var childNodes = element.childNodes;
      var len = childNodes.length;
      var list =
        typeof blackList == "undefined"
          ? "html,head,style,title,link,meta,script,object,iframe,pre,a,"
          : blackList;
      while (len--) {
        var node = childNodes[len];
        if (
          (node.nodeType === 1 && true) ||
          list.indexOf(node.nodeName.toLowerCase()) === -1
        ) {
          replacer(finder, node, list);
        }
        if (node.nodeType !== 3 || !regex.test(node.data)) {
          continue;
        }
        var frag = (function () {
          var wrap = document.createElement("span");
          var frag = document.createDocumentFragment();
          var itemId = regex2.exec(node.data)[1];
          if (itemId) {
            wrap.innerHTML =
              '<div class="zifyfaq" id="zifyfaq-' + itemId + '"></div>';
          } else {
            wrap.innerHTML =
              '<div class="zifyfaq-wrapper" id="zifyfaq-wrapper"></div>';
          }

          while (wrap.firstChild) {
            frag.appendChild(wrap.firstChild);
          }
          return frag;
        })();
        var parent = node.parentNode;
        parent.insertBefore(frag, node);
        parent.removeChild(node);
      }
    };

    //jQuery.ajaxSetup({
    //cache: true
    //});

    var blackList;
    jQuery("body").each(function () {
      replacer("\\[zify-faq]", jQuery(this).get(0), blackList);
      replacer("\\[zifyfaq-(\\d+)\\]", jQuery(this).get(0), blackList);
    });

    var array = [];
    jQuery(".zifyfaq").each(function (index) {
      var id = jQuery(this).attr("id");
      var numb = id.match(/\d+$/)[0];
      array[index] = numb;
    });
    var ids = array.reduce(function (a, b) {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, []);

    if (jQuery("#zifyfaq-wrapper").length) {
      jQuery("#zifyfaq-wrapper").append(faqs_data_response);
    }

    ids.forEach(function (id) {
      jQuery("#zifyfaq-" + id).append(zify_faq_category_data_response[id].html);
      jQuery(".cd-faq-items").css("padding-left", "0");
      //jQuery('.zify-widget').hide();
      jQuery(".cd-faq-categories").remove();
    });

    jQuery.ajaxSetup({
      cache: false,
    });

    //MAIN.JS
    jQuery(function () {
      var margin_top_value = margin_top;
      //Search FAQ
      jQuery("#zify-search-query").bind(
        "typeahead:select",
        function (ev, suggestion) {
          //console.log(suggestion.id);
          //jQuery("#faq-question-"+suggestion.id).trigger('click');
          jQuery("#faq-question-" + suggestion.id)[0].click();
          jQuery([document.documentElement, document.body]).animate(
            {
              scrollTop:
                jQuery("#faq-question-" + suggestion.id).offset().top -
                margin_top_value,
            },
            500
          );
        }
      );
      //Anchor
      function GetURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split("&");
        for (var i = 0; i < sURLVariables.length; i++) {
          var sParameterName = sURLVariables[i].split("=");
          if (sParameterName[0] == sParam) {
            return sParameterName[1];
          }
        }
      }
      var item = GetURLParameter("item");
      if (item) {
        jQuery("html, body").animate(
          {
            scrollTop: parseInt(
              jQuery("#faq-question-" + item).offset().top - margin_top_value
            ),
          },
          500
        );
        jQuery("#faq-content-" + item).show();
        //console.log(item);
      }
      //

      var MqM = 768,
        MqL = 1024;

      var faqsSections = jQuery(".cd-faq-group"),
        faqTrigger = jQuery(".cd-faq-trigger"),
        faqsContainer = jQuery(".cd-faq-items"),
        faqsCategoriesContainer = jQuery(".cd-faq-categories"),
        faqsCategories = faqsCategoriesContainer.find("a"),
        closeFaqsContainer = jQuery(".cd-close-panel");

      //select a faq section
      faqsCategories.on("click", function (event) {
        event.preventDefault();
        var selectedHref = jQuery(this).attr("href"),
          target = jQuery(selectedHref);
        if (jQuery(window).width() < MqM) {
          faqsContainer
            .scrollTop(0)
            .addClass("slide-in")
            .children("ul")
            .removeClass("selected")
            .end()
            .children(selectedHref)
            .addClass("selected");
          closeFaqsContainer.addClass("move-left");
          jQuery("body").addClass("cd-overlay");
        } else {
          jQuery("body,html").animate(
            { scrollTop: target.offset().top - margin_top_value },
            200
          );
        }
      });

      //close faq lateral panel - mobile only
      jQuery("body").bind("click touchstart", function (event) {
        if (
          jQuery(event.target).is("body.cd-overlay") ||
          jQuery(event.target).is(".cd-close-panel")
        ) {
          closePanel(event);
        }
      });
      faqsContainer.on("swiperight", function (event) {
        closePanel(event);
      });

      //show faq content clicking on faqTrigger
      faqTrigger.on("click", function (event) {
        event.preventDefault();
        jQuery(this).toggleClass("active");
        jQuery(this)
          .next(".cd-faq-content")
          .slideToggle(200)
          .end()
          .parent("li")
          .toggleClass("content-visible");
      });

      //update category sidebar while scrolling
      jQuery(window).on("scroll", function () {
        if (jQuery(window).width() > MqL) {
          !window.requestAnimationFrame
            ? updateCategory()
            : window.requestAnimationFrame(updateCategory);
        }
      });

      jQuery(window).on("resize", function () {
        if (jQuery(window).width() <= MqL) {
          faqsCategoriesContainer.removeClass("is-fixed").css({
            "-moz-transform": "translateY(0)",
            "-webkit-transform": "translateY(0)",
            "-ms-transform": "translateY(0)",
            "-o-transform": "translateY(0)",
            transform: "translateY(0)",
          });
        }
        if (faqsCategoriesContainer.hasClass("is-fixed")) {
          faqsCategoriesContainer.css({
            left: faqsContainer.offset().left,
          });
        }
      });

      function closePanel(e) {
        e.preventDefault();
        faqsContainer.removeClass("slide-in").find("li").show();
        closeFaqsContainer.removeClass("move-left");
        jQuery("body").removeClass("cd-overlay");
      }

      function updateCategory() {
        if (jQuery(".cd-faq-categories").length) {
          updateCategoryPosition();
          updateSelectedCategory();
        }
      }

      function updateCategoryPosition() {
        var top = jQuery(".cd-faq").offset().top,
          height =
            jQuery(".cd-faq").height() - jQuery(".cd-faq-categories").height(),
          margin = margin_top_value;
        if (
          top - margin <= jQuery(window).scrollTop() &&
          top - margin + height > jQuery(window).scrollTop()
        ) {
          var leftValue = jQuery(".cd-faq-categories").offset().left,
            widthValue = jQuery(".cd-faq-categories").width();
          jQuery(".cd-faq-categories").addClass("is-fixed").css({
            left: leftValue,
            top: margin,
            "-moz-transform": "translateZ(0)",
            "-webkit-transform": "translateZ(0)",
            "-ms-transform": "translateZ(0)",
            "-o-transform": "translateZ(0)",
            transform: "translateZ(0)",
          });
        } else if (top - margin + height <= jQuery(window).scrollTop()) {
          var delta = top - margin + height - jQuery(window).scrollTop();
          jQuery(".cd-faq-categories").css({
            "-moz-transform": "translateZ(0) translateY(" + delta + "px)",
            "-webkit-transform": "translateZ(0) translateY(" + delta + "px)",
            "-ms-transform": "translateZ(0) translateY(" + delta + "px)",
            "-o-transform": "translateZ(0) translateY(" + delta + "px)",
            transform: "translateZ(0) translateY(" + delta + "px)",
          });
        } else {
          jQuery(".cd-faq-categories").removeClass("is-fixed").css({
            left: 0,
            top: 0,
          });
        }
      }

      function updateSelectedCategory() {
        faqsSections.each(function () {
          var actual = jQuery(this),
            margin = parseInt(
              jQuery(".cd-faq-title").eq(1).css("marginTop").replace("px", "")
            ),
            activeCategory = jQuery(
              '.cd-faq-categories a[href="#' + actual.attr("id") + '"]'
            ),
            topSection = activeCategory.parent("li").is(":first-child")
              ? 0
              : Math.round(actual.offset().top);

          if (
            topSection - margin_top_value <= jQuery(window).scrollTop() &&
            Math.round(actual.offset().top) +
              actual.height() +
              margin -
              margin_top_value >
              jQuery(window).scrollTop()
          ) {
            activeCategory.addClass("selected");
          } else {
            activeCategory.removeClass("selected");
          }
        });
      }
    });
    //End MAIN.JS
  };
  /* If jQuery has not yet been loaded or if it has but it's too old for our needs,
  we will load jQuery from the Google CDN, and when it's fully loaded, we will run
  our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
  as the minimum version we are ready to use, and if the jQuery is older, we load 1.9.
  //ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js
  */
  function check_zify_faq_scripttag() {
    var scripts = document.getElementsByTagName("script");
    for (var i = scripts.length; i--; ) {
      if (
        scripts[i].innerText.indexOf("asyncLoad") >= 0 &&
        scripts[i].innerText.indexOf("faq.zifyapp.com") >= 0
      ) {
        console.log("FAQify is working.");
        return true;
      }
    }
    return false;
  }
  if (typeof jQuery === "undefined" || parseFloat(jQuery.fn.jquery) < 1.7) {
    loadScript("//code.jquery.com/jquery-1.11.1.min.js", function () {
      ZIFY = jQuery.noConflict(true);
      ZIFY(document).ready(function () {
        if (check_zify_faq_scripttag() && status == 1) {
          zifyfaqJS(ZIFY);
        }
      });
    });
  } else {
    if (check_zify_faq_scripttag() && status == 1) {
      zifyfaqJS(jQuery);
    }
  }
})();
